// [autogen: artifact] AUTOMATICALLY GENERATED FILE. NOT DO EDIT BY HAND.

import { gql } from '@kazoohr/graphql';
import * as ApolloReactCommon from '@kazoohr/graphql/common';
import * as ApolloReactHooks from '@kazoohr/graphql/hooks';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
  /** All dates within this schema are ISO-8601 strings without time or timezone. */
  Date: { input: any; output: any; }
  /** All date-times are supposed to be are ISO-8601 strings, but we do accept input in other formats.  That behavior will change and we will replace Date and DateTime's behavior with that of StrictDate. */
  DateTime: { input: any; output: any; }
  /** A datetime input and output type only accepts ISO-8601 dates. */
  StrictDateTimeInput: { input: String; output: String; }
  /** General-use Upload input scalar */
  FileToUpload: { input: any; output: any; }
  /** General-use scalar to use for fields of JSON data. See https://www.npmjs.com/package/graphql-type-json for more information. */
  JSONObject: { input: any; output: any; }
  /** Represents a rich text document in its native ProseMirror document format. This is a JSON object with a specific schema. Use a TipTap editor instance from the @kazoohr/richtext-components package to interact with this format. */
  RichTextDocument: { input: any; output: any; }
}

export interface Query {
  __typename?: 'Query';
  /** Fetch the current authenticated user, or null if not logged in */
  currentUser?: Maybe<User>;
  /** Fetch a user by ID (platform admin only) */
  user: User;
  /** Global state of the application, such as maintenance mode */
  applicationState: ApplicationState;
  nextQuestion: NextQuestionResponse;
  nextSolutionQuestion?: Maybe<Question>;
  session: Session;
  questions: Array<Question>;
  participantAnswers: Array<Question>;
  participant?: Maybe<Participant>;
  participants: Array<Participant>;
  sessions: SessionsConnection;
  feedback: FeedbackConnection;
  sessionInsights: SessionInsightsResult;
  /** Fetch attribute templates for the current user */
  sessionAttributeTemplates: SessionAttributeTemplatesConnection;
  /** Fetch all users (platform admin only) */
  users: UsersConnection;
  /** Fetch users for a specific organization (admin only) */
  organizationUsers: UsersConnection;
  organizations: OrganizationsConnection;
  velocityFactors: VelocityFactorsConnection;
  velocityIssues: VelocityIssuesConnection;
  velocityFactor?: Maybe<VelocityFactor>;
  velocityIssue?: Maybe<VelocityIssue>;
  velocityOrgStrength?: Maybe<VelocityOrgStrength>;
  accessCapabilities: AccessCapabilities;
  apiPing: Scalars['String']['output'];
}


export interface QueryUserArgs {
  id: Scalars['ID']['input'];
}


export interface QueryNextQuestionArgs {
  sessionId: Scalars['ID']['input'];
}


export interface QueryNextSolutionQuestionArgs {
  solutionSessionId: Scalars['ID']['input'];
}


export interface QuerySessionArgs {
  id: Scalars['ID']['input'];
}


export interface QueryQuestionsArgs {
  filter: QuestionsFilterInput;
  sort?: InputMaybe<Array<QuestionsSortInput>>;
}


export interface QueryParticipantAnswersArgs {
  filter: ParticipantAnswersFilterInput;
}


export interface QueryParticipantArgs {
  sessionId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
}


export interface QueryParticipantsArgs {
  filter: ParticipantsFilterInput;
  sort?: InputMaybe<Array<ParticipantsSortInput>>;
}


export interface QuerySessionsArgs {
  filter?: InputMaybe<SessionsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SessionsSortInput>>;
}


export interface QueryFeedbackArgs {
  filter: FeedbackFilterInput;
}


export interface QuerySessionInsightsArgs {
  sessionId: Scalars['ID']['input'];
  selectedForSolutioningOnly?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QuerySessionAttributeTemplatesArgs {
  filter?: InputMaybe<SessionAttributeTemplatesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryUsersArgs {
  filter?: InputMaybe<UsersFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<UsersSortInput>>;
}


export interface QueryOrganizationUsersArgs {
  organizationId: Scalars['ID']['input'];
  filter?: InputMaybe<OrganizationUsersFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<OrganizationUsersSortInput>>;
}


export interface QueryOrganizationsArgs {
  filter?: InputMaybe<OrganizationsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryVelocityFactorsArgs {
  sessionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryVelocityIssuesArgs {
  sessionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryVelocityFactorArgs {
  sessionId: Scalars['ID']['input'];
  factorCode: Scalars['String']['input'];
}


export interface QueryVelocityIssueArgs {
  sessionId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
}


export interface QueryVelocityOrgStrengthArgs {
  sessionId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
}

/** Global application state shared by every client. */
export interface ApplicationState {
  __typename?: 'ApplicationState';
  /** Whether the platform is in maintenance mode */
  maintenanceModeEnabled: Scalars['Boolean']['output'];
}

export interface Mutation {
  __typename?: 'Mutation';
  startSession: StartSessionPayload;
  createSession: CreateSessionPayload;
  updateSession: UpdateSessionPayload;
  duplicateSession: DuplicateSessionPayload;
  reassignSession: ReassignSessionPayload;
  joinSession: JoinSessionPayload;
  answerTextQuestion: AnswerQuestionPayload;
  answerMultipleChoiceQuestion: AnswerQuestionPayload;
  answerBooleanQuestion: AnswerQuestionPayload;
  answerRankingQuestion: AnswerQuestionPayload;
  answerRatingScaleQuestion: AnswerQuestionPayload;
  skipQuestion: AnswerQuestionPayload;
  abandonQuestion: AbandonQuestionPayload;
  endSession: EndSessionPayload;
  skipToNextSection: SkipToNextSectionPayload;
  pauseSession: PauseSessionPayload;
  resumeSession: ResumeSessionPayload;
  createFeedback: CreateFeedbackPayload;
  saveVote: SaveVotePayload;
  regenerateSessionSummary: RegenerateSessionSummaryPayload;
  startSolutionForIdea: StartSolutionForIdeaPayload;
  answerSolutionQuestion: AnswerSolutionQuestionPayload;
  createSessionAttributeTemplate: CreateSessionAttributeTemplatePayload;
  updateSessionAttributeTemplate: UpdateSessionAttributeTemplatePayload;
  archiveSessionAttributeTemplate: ArchiveSessionAttributeTemplatePayload;
  sendInvitation: SendInvitationPayload;
  archiveUser: ArchiveUserPayload;
  updateUser: UpdateUserPayload;
  /** Stores the signed-in user's UI language. Must be a supported language code. */
  updateCurrentUserLocale: UpdateCurrentUserLocalePayload;
  addUserToOrganization: AddUserToOrganizationPayload;
  removeUserFromOrganization: RemoveUserFromOrganizationPayload;
  updateUserOrganizationRole: UpdateUserOrganizationRolePayload;
  createOrganization: CreateOrganizationPayload;
  updateOrganization: UpdateOrganizationPayload;
  deleteOrganization: DeleteOrganizationPayload;
  archiveOrganization: ArchiveOrganizationPayload;
  restoreOrganization: RestoreOrganizationPayload;
  assignTopicOwnership: AssignTopicOwnershipPayload;
  setSolutioningTopics: SetSolutioningTopicsPayload;
  removeTopicAssignment: RemoveTopicAssignmentPayload;
  /** Assign an email address as an owner of a Velocity issue. Facilitator only. */
  assignVelocityIssueOwnership: AssignVelocityIssueOwnershipPayload;
  /** Remove owner assignments from a Velocity issue. Facilitator only. */
  removeVelocityIssueAssignment: RemoveVelocityIssueAssignmentPayload;
  sendInsightsEmail: SendInsightsEmailPayload;
  toggleCurrentUserPlatformAdmin: ToggleCurrentUserPlatformAdminPayload;
  apiPing: Scalars['String']['output'];
}


export interface MutationStartSessionArgs {
  input: StartSessionInput;
}


export interface MutationCreateSessionArgs {
  input: CreateSessionInput;
}


export interface MutationUpdateSessionArgs {
  input: UpdateSessionInput;
}


export interface MutationDuplicateSessionArgs {
  input: DuplicateSessionInput;
}


export interface MutationReassignSessionArgs {
  input: ReassignSessionInput;
}


export interface MutationJoinSessionArgs {
  input: JoinSessionInput;
}


export interface MutationAnswerTextQuestionArgs {
  input: AnswerTextQuestionInput;
}


export interface MutationAnswerMultipleChoiceQuestionArgs {
  input: AnswerMultipleChoiceQuestionInput;
}


export interface MutationAnswerBooleanQuestionArgs {
  input: AnswerBooleanQuestionInput;
}


export interface MutationAnswerRankingQuestionArgs {
  input: AnswerRankingQuestionInput;
}


export interface MutationAnswerRatingScaleQuestionArgs {
  input: AnswerRatingScaleQuestionInput;
}


export interface MutationSkipQuestionArgs {
  input: SkipQuestionInput;
}


export interface MutationAbandonQuestionArgs {
  input: AbandonQuestionInput;
}


export interface MutationEndSessionArgs {
  input: EndSessionInput;
}


export interface MutationSkipToNextSectionArgs {
  input: SkipToNextSectionInput;
}


export interface MutationPauseSessionArgs {
  input: PauseSessionInput;
}


export interface MutationResumeSessionArgs {
  input: ResumeSessionInput;
}


export interface MutationCreateFeedbackArgs {
  input: CreateFeedbackInput;
}


export interface MutationSaveVoteArgs {
  input: SaveVoteInput;
}


export interface MutationRegenerateSessionSummaryArgs {
  input: RegenerateSessionSummaryInput;
}


export interface MutationStartSolutionForIdeaArgs {
  input: StartSolutionForIdeaInput;
}


export interface MutationAnswerSolutionQuestionArgs {
  input: AnswerSolutionQuestionInput;
}


export interface MutationCreateSessionAttributeTemplateArgs {
  input: CreateSessionAttributeTemplateInput;
}


export interface MutationUpdateSessionAttributeTemplateArgs {
  input: UpdateSessionAttributeTemplateInput;
}


export interface MutationArchiveSessionAttributeTemplateArgs {
  input: ArchiveSessionAttributeTemplateInput;
}


export interface MutationSendInvitationArgs {
  input: SendInvitationInput;
}


export interface MutationArchiveUserArgs {
  input: ArchiveUserInput;
}


export interface MutationUpdateUserArgs {
  input: UpdateUserInput;
}


export interface MutationUpdateCurrentUserLocaleArgs {
  input: UpdateCurrentUserLocaleInput;
}


export interface MutationAddUserToOrganizationArgs {
  input: AddUserToOrganizationInput;
}


export interface MutationRemoveUserFromOrganizationArgs {
  input: RemoveUserFromOrganizationInput;
}


export interface MutationUpdateUserOrganizationRoleArgs {
  input: UpdateUserOrganizationRoleInput;
}


export interface MutationCreateOrganizationArgs {
  input: CreateOrganizationInput;
}


export interface MutationUpdateOrganizationArgs {
  input: UpdateOrganizationInput;
}


export interface MutationDeleteOrganizationArgs {
  input: DeleteOrganizationInput;
}


export interface MutationArchiveOrganizationArgs {
  input: ArchiveOrganizationInput;
}


export interface MutationRestoreOrganizationArgs {
  input: RestoreOrganizationInput;
}


export interface MutationAssignTopicOwnershipArgs {
  input: AssignTopicOwnershipInput;
}


export interface MutationSetSolutioningTopicsArgs {
  input: SetSolutioningTopicsInput;
}


export interface MutationRemoveTopicAssignmentArgs {
  input: RemoveTopicAssignmentInput;
}


export interface MutationAssignVelocityIssueOwnershipArgs {
  input: AssignVelocityIssueOwnershipInput;
}


export interface MutationRemoveVelocityIssueAssignmentArgs {
  input: RemoveVelocityIssueAssignmentInput;
}


export interface MutationSendInsightsEmailArgs {
  input: SendInsightsEmailInput;
}

export interface VelocityFactor {
  __typename?: 'VelocityFactor';
  id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  /** How this factor ranks among the session's factors, ordered by ascending score (lowest/most-concerning first). */
  rankDetails: VelocityFactorRankDetails;
  /** Percentage (0-100) of the session's participants who voiced an issue on this factor. */
  engagementPercent: Scalars['Int']['output'];
  questionBreakdowns: Array<VelocityFactorQuestionBreakdown>;
  /** 0-100 Likert score per reporting factor that rolls up into this factor. */
  reportingFactorScores: Array<ReportingFactorScore>;
  /**
   * This factor's trend across the completed sessions closest in time to this
   * one in the same org (or the same user when the session has no org) running
   * the same velocity engine type, ordered oldest→newest. This session is always
   * included and sits in the middle when both sides have enough sessions;
   * otherwise the window spills over to the fuller side. Each point drives the
   * historical chart: `score` is the trend line, the sentiment counts (summed
   * across the factor's question breakdowns) the stacked bar. Capped at 8
   * sessions.
   */
  historicalScores: Array<VelocityFactorHistoricalScore>;
  issues: VelocityIssuesConnection;
  /**
   * Verbatim participant quotes supporting this factor's top issues, surfaced
   * in the drawer's "Why" section. Ordered by relevance, highest first, and
   * capped. Attributed by name and role for identified participants only.
   */
  whyQuotes: Array<VelocityFactorWhyQuote>;
}


export interface VelocityFactorIssuesArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}

/** A verbatim participant quote shown in the factor drawer's "Why" section. */
export interface VelocityFactorWhyQuote {
  __typename?: 'VelocityFactorWhyQuote';
  id: Scalars['ID']['output'];
  /** The verbatim quote text. */
  text: Scalars['String']['output'];
  /** The question prompt, when the quote came from a question answer. Null for free-form comments. */
  questionText?: Maybe<Scalars['String']['output']>;
  /** Participant display name. Null when the participant joined anonymously. */
  name?: Maybe<Scalars['String']['output']>;
  /** Participant role/title. Null when anonymous or unknown. */
  role?: Maybe<Scalars['String']['output']>;
}

/**
 * Where a factor sits among the session's factors, ranked by ascending score
 * (the lowest-scoring, most-concerning factor is #1).
 */
export interface VelocityFactorRankDetails {
  __typename?: 'VelocityFactorRankDetails';
  /** 1-based rank of this factor. */
  rank: Scalars['Int']['output'];
  /** Total number of ranked factors in the session. */
  totalFactors: Scalars['Int']['output'];
}

export interface VelocityFactorQuestionBreakdown {
  __typename?: 'VelocityFactorQuestionBreakdown';
  prompt: Scalars['String']['output'];
  negativeCount: Scalars['Int']['output'];
  neutralCount: Scalars['Int']['output'];
  positiveCount: Scalars['Int']['output'];
  participantCount: Scalars['Int']['output'];
}

/**
 * One session's data point in a factor's historical trend: the factor score
 * (plotted as the line) plus Likert sentiment counts summed across the factor's
 * question breakdowns for that session (plotted as the stacked bar).
 */
export interface VelocityFactorHistoricalScore {
  __typename?: 'VelocityFactorHistoricalScore';
  sessionId: Scalars['ID']['output'];
  sessionTitle: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Null until the session is marked completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 0-100 factor score for this session. */
  score: Scalars['Float']['output'];
  negativeCount: Scalars['Int']['output'];
  neutralCount: Scalars['Int']['output'];
  positiveCount: Scalars['Int']['output'];
}

/** 0-100 Likert score for a single reporting factor. */
export interface ReportingFactorScore {
  __typename?: 'ReportingFactorScore';
  reportingFactor: Scalars['String']['output'];
  score: Scalars['Float']['output'];
}

/** A taxonomy placement assigned to an issue: the domain/category problem area its root-cause probes are generated from. */
export interface IssueCategorization {
  __typename?: 'IssueCategorization';
  domain: Scalars['String']['output'];
  category: Scalars['String']['output'];
}

/** A root-cause pattern (cross-cutting tag) surfaced by an issue's probes, with the evidence behind it. `score / maxScore` is the tag's confidence; only confident tags are materialized. */
export interface IssueRcaPattern {
  __typename?: 'IssueRcaPattern';
  pattern: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  maxScore: Scalars['Float']['output'];
}

/** One root-cause probe generated for an issue — the Likert statement participants rated — with its rating counts. Probes appear as soon as they're generated, so all counts can be zero. */
export interface IssuePatternValidation {
  __typename?: 'IssuePatternValidation';
  /** The single pattern the probe tested. Null for probes generated after probes began carrying per-side pattern tag lists instead. */
  pattern?: Maybe<Scalars['String']['output']>;
  /** The contributor quote the probe was built from. Null for probes generated from the issue's taxonomy placement rather than contributor quotes. */
  quote?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  /** 1-4 word label naming the probe's specific hypothesis. Null for probes generated before shorts existed. */
  short?: Maybe<Scalars['String']['output']>;
  /** How many participants gave each 1-5 rating, keyed by scale point. */
  ratingCounts: LikertRatingCounts;
}

/** How many participants gave each 1-5 rating on a Likert statement. */
export interface LikertRatingCounts {
  __typename?: 'LikertRatingCounts';
  stronglyDisagree: Scalars['Int']['output'];
  disagree: Scalars['Int']['output'];
  neutral: Scalars['Int']['output'];
  agree: Scalars['Int']['output'];
  stronglyAgree: Scalars['Int']['output'];
}

export interface VelocityIssue {
  __typename?: 'VelocityIssue';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  longDescription: Scalars['String']['output'];
  /**
   * The session topic-to-avoid this issue matches, or null when it matches
   * none. Matched issues are hidden from participants mid-session and appear
   * only in the report.
   */
  matchedAvoidTopic?: Maybe<Scalars['String']['output']>;
  /** Guidance for the team, generated at finalize and grounded in the concrete responses participants left about this issue and the organization's diagnosed strengths, without naming individuals. A short list of one-sentence bullets (2-5), each tied to a specific issue detail or strength. Null until the report has been finalized. */
  guidance?: Maybe<Array<Scalars['String']['output']>>;
  /** Taxonomy placements (domain/category) assigned by the LLM. Additive — an issue can span multiple placements. Empty until the issue has been placed. */
  categorizations: Array<IssueCategorization>;
  /** Root-cause pattern probes generated for this issue with their 1-5 rating counts from the pattern-validation questions. Empty until probes have been generated. */
  patternValidations: Array<IssuePatternValidation>;
  factorCodes: Array<Scalars['String']['output']>;
  factorNames: Array<Scalars['String']['output']>;
  originatorParticipantId: Scalars['String']['output'];
  originatorName?: Maybe<Scalars['String']['output']>;
  participants: Array<VelocityParticipantRef>;
  /** Total assessment responses — the sum of agree, disagree, and "not relevant". */
  assessmentCount: Scalars['Int']['output'];
  assessmentAgreeCount: Scalars['Int']['output'];
  assessmentDisagreeCount: Scalars['Int']['output'];
  /** "Not sure; not relevant to me" responses — counted as responses but never toward the score. */
  assessmentNotRelevantCount: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  averageImpactScore?: Maybe<Scalars['Float']['output']>;
  impactScoreCount: Scalars['Int']['output'];
  averageFactorEffectScores: Array<VelocityFactorEffectScore>;
  /** When this issue was first surfaced by the engine. */
  createdAt: Scalars['DateTime']['output'];
  /** Distributions for the newer diagnostic dimensions (scale prompts other than jobImpact, plus scope + attempts). Options with zero votes are filtered out; dimensions with no answers at all are omitted (or null). */
  diagnosticDimensionBreakdowns: IssueDiagnosticDimensionBreakdowns;
  relatedFactors: VelocityFactorsConnection;
  /** Where this issue sits among the session's issues, ranked by descending score (the highest-scoring, most-agreed issue is #1) — matching the ordering of the issues report list. */
  rankDetails: VelocityIssueRankDetails;
  /** Percentage (0-100) of the session's participants who voted (agreed or disagreed) on this issue. 0 when the session has no participants. */
  engagementPercent: Scalars['Int']['output'];
  /** The highest-relevance verbatim participant quotes linked to this issue, best first, capped at 3. Attributed by name and role for identified participants only. */
  participantQuotes: Array<VelocityFactorWhyQuote>;
  /** Email-based owner assignments for this issue, oldest first. */
  assignments: Array<VelocityIssueAssignment>;
}


export interface VelocityIssueRelatedFactorsArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Where an issue sits among the session's issues, ranked by descending score
 * (the highest-scoring, most-agreed issue is #1).
 */
export interface VelocityIssueRankDetails {
  __typename?: 'VelocityIssueRankDetails';
  /** 1-based rank of this issue. */
  rank: Scalars['Int']['output'];
  /** Total number of ranked issues in the session. */
  totalIssues: Scalars['Int']['output'];
}

/**
 * One organizational strength from the report projection, fetched for the
 * strength drawer by `(sessionId, slug)`.
 */
export interface VelocityOrgStrength {
  __typename?: 'VelocityOrgStrength';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  longDescription: Scalars['String']['output'];
  /**
   * The session topic-to-avoid this strength matches, or null when it matches
   * none. Matched strengths are hidden from participants mid-session and appear
   * only in the report.
   */
  matchedAvoidTopic?: Maybe<Scalars['String']['output']>;
  /** Participants who agreed, including the originator's implicit agreement. */
  agreeCount: Scalars['Int']['output'];
  disagreeCount: Scalars['Int']['output'];
  /** Total reactions (agree, disagree, and "not relevant"), including the originator's implicit agreement. 0 for rows materialized before this was tracked. */
  responseCount: Scalars['Int']['output'];
  /** Where this strength sits among the session's reported strengths, ordered like the Org Strengths report list (net sentiment descending). */
  rankDetails: VelocityOrgStrengthRankDetails;
  /** Percentage (0-100) of the session's participants who agreed or disagreed with this strength. 0 when the session has no participants. */
  engagementPercent: Scalars['Int']['output'];
  /** Verbatim notes and examples participants left about this strength, newest first, capped at 3. Attributed by name and role for identified participants only. */
  participantQuotes: Array<VelocityFactorWhyQuote>;
  /** Rolled-up diagnostic answers for this strength. Null until at least one diagnostic answer lands. */
  diagnostics?: Maybe<OrgStrengthDiagnostics>;
}

/**
 * Where a strength sits among the session's reported strengths, ranked by
 * descending net sentiment (the most-agreed strength is #1).
 */
export interface VelocityOrgStrengthRankDetails {
  __typename?: 'VelocityOrgStrengthRankDetails';
  /** 1-based rank of this strength. 0 when nobody beyond the originator has reacted to it, since the report list leaves such strengths out. */
  rank: Scalars['Int']['output'];
  /** Total number of ranked strengths in the session. */
  totalStrengths: Scalars['Int']['output'];
}

/** Distributions for the newer diagnostic dimensions on an issue. */
export interface IssueDiagnosticDimensionBreakdowns {
  __typename?: 'IssueDiagnosticDimensionBreakdowns';
  /** Per-scale bucketed low/mid/high distributions (gettingWorse, resolutionImpact, urgency). Only includes dimensions with at least one rating. */
  scales: Array<IssueScaleBreakdown>;
  /** Who the issue affects, tallied across the three scope choices. Null when no one answered. */
  scope?: Maybe<IssueChoiceBreakdown>;
  /** Prior-attempts responses, tallied across the three attempts choices. Null when no one answered. */
  attempts?: Maybe<IssueChoiceBreakdown>;
}

/** One diagnostic scale's rating distribution, bucketed low (1-2) / mid (3) / high (4-5). */
export interface IssueScaleBreakdown {
  __typename?: 'IssueScaleBreakdown';
  prompt: Scalars['String']['output'];
  /** Label of the scale's low endpoint (rating 1), as shown to participants. */
  lowLabel: Scalars['String']['output'];
  /** Label of the scale's high endpoint (rating 5), as shown to participants. */
  highLabel: Scalars['String']['output'];
  /** How many participants gave each 1-5 rating; stronglyDisagree is the low endpoint (rating 1). */
  ratingCounts: LikertRatingCounts;
  participantCount: Scalars['Int']['output'];
}

/** A single-choice distribution: option tallies in descriptor order, zero-count options dropped. */
export interface IssueChoiceBreakdown {
  __typename?: 'IssueChoiceBreakdown';
  total: Scalars['Int']['output'];
  counts: Array<IssueChoiceCount>;
}

export interface IssueChoiceCount {
  __typename?: 'IssueChoiceCount';
  choice: Scalars['String']['output'];
  /** Short report label for the choice, ready to render in legends. */
  label: Scalars['String']['output'];
  /** Full participant-facing option text, as shown in the wizard. Longer than `label`. */
  detailLabel: Scalars['String']['output'];
  count: Scalars['Int']['output'];
}

/** Per-factor effect aggregate for an issue. */
export interface VelocityFactorEffectScore {
  __typename?: 'VelocityFactorEffectScore';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Average 1-5 effect rating across raters who supplied one for this factor. */
  average: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
}

/** Denormalized {id, name} from the projection's participant JSONB column. */
export interface VelocityParticipantRef {
  __typename?: 'VelocityParticipantRef';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface VelocityFactorsConnection {
  __typename?: 'VelocityFactorsConnection';
  pageInfo: PageInfo;
  edges: Array<VelocityFactorsEdge>;
}

export interface VelocityFactorsEdge {
  __typename?: 'VelocityFactorsEdge';
  cursor: Scalars['String']['output'];
  node: VelocityFactor;
}

export interface VelocityIssuesConnection {
  __typename?: 'VelocityIssuesConnection';
  pageInfo: PageInfo;
  edges: Array<VelocityIssuesEdge>;
}

export interface VelocityIssuesEdge {
  __typename?: 'VelocityIssuesEdge';
  cursor: Scalars['String']['output'];
  node: VelocityIssue;
}

export interface OrganizationsConnection {
  __typename?: 'OrganizationsConnection';
  pageInfo: PageInfo;
  edges: Array<OrganizationsEdge>;
}

export interface OrganizationsEdge {
  __typename?: 'OrganizationsEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
}

export interface SessionSection {
  __typename?: 'SessionSection';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  section: SessionSectionType;
  timeInSeconds: Scalars['Int']['output'];
  timeRemaining?: Maybe<Scalars['Int']['output']>;
}

export interface Session {
  __typename?: 'Session';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /**
   * Velocity engine subtype, e.g. "organizationalHealth" or "retrospective".
   * Null for non-velocity sessions. On velocity sessions, null means
   * organizationalHealth (resolved by the server).
   */
  velocityEngineType?: Maybe<Scalars['String']['output']>;
  /**
   * Org-health driver categories chosen for the session. Null means the
   * code-defined default set (all categories).
   */
  activeFactorCodes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Org-health reporting factors chosen for the session. Null means every
   * reporting factor of each active category.
   */
  activeReportingFactorCodes?: Maybe<Array<Scalars['String']['output']>>;
  section?: Maybe<SessionSectionType>;
  sections: Array<SessionSection>;
  description?: Maybe<Scalars['String']['output']>;
  status: SessionStatus;
  length: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  sessionTimeRemaining?: Maybe<Scalars['Int']['output']>;
  sectionTimeRemaining?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** When the facilitator locked in the Section 4 solutioning topics. Null until first selection. */
  solutioningTopicsSelectedAt?: Maybe<Scalars['DateTime']['output']>;
  focus?: Maybe<Scalars['String']['output']>;
  currentParticipantHasJoined: Scalars['Boolean']['output'];
  /** Whether to allow experimental factor-based follow-up questions */
  allowExperimentalFactorQuestions: Scalars['Boolean']['output'];
  /** Participant identification mode: REQUIRED, OPTIONAL, or ANONYMOUS */
  identificationMode: IdentificationMode;
  /** Insights visibility: PRIVATE (facilitators only) or PUBLIC (public link) */
  insightsVisibility: InsightsVisibility;
  /** Whether the current viewer is allowed to see this session's insights and report. */
  canViewInsights: Scalars['Boolean']['output'];
  /** Attribute templates selected for this session to collect from participants */
  selectedAttributes: Array<SessionAttributeTemplate>;
  implementations: ImplementationsConnection;
  defaultQuestions: Array<Scalars['String']['output']>;
  requireDefaultQuestions: Scalars['Boolean']['output'];
  /**
   * Topics the facilitator asked the session to avoid. Extracted issues matching
   * one of these are tagged so they are hidden from participants mid-session but
   * remain visible in reports.
   */
  topicsToAvoid: Array<Scalars['String']['output']>;
  user: User;
  questions: Array<Question>;
  participants: ParticipantsConnection;
  feedback: FeedbackConnection;
  /** AI-generated factor insights for this session with generation status. */
  factors?: Maybe<SessionFactors>;
  /**
   * Per-orchestrator report details (e.g. item counts), discriminated by the
   * session's velocity engine type. Null for non-velocity sessions.
   */
  velocityDetails?: Maybe<VelocityDetails>;
  /**
   * The Velocity engine's dynamic questions and participant answer threads
   * (velocity_question rows), ordered by serve time. Empty for non-velocity
   * sessions.
   */
  velocityQuestions: Array<VelocityQuestion>;
  /**
   * Report visualizations. `attributeFilters` narrows factor Likert data to the
   * participants whose attribute responses match every filter. Factor data is
   * withheld (empty `factors`) for segments smaller than three participants.
   */
  report?: Maybe<Array<VelocityReportVisualization>>;
}


export interface SessionImplementationsArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}


export interface SessionQuestionsArgs {
  sort?: InputMaybe<Array<QuestionsSortInput>>;
}


export interface SessionParticipantsArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ParticipantsSortInput>>;
  filter?: InputMaybe<SessionParticipantsFilterInput>;
}


export interface SessionFeedbackArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}


export interface SessionReportArgs {
  attributeFilters?: InputMaybe<Array<ReportAttributeFilterInput>>;
}

export interface VelocityReportVisualization {
  __typename?: 'VelocityReportVisualization';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  module: VelocityReportModule;
}

export type VelocityReportModule = FactorReportModule | OrgHealthReportModule | IssuesReportModule | PraiseReportModule | OrgStrengthsReportModule;

/**
 * Report details for a velocity session, discriminated by the session's
 * velocity engine type. Each orchestrator exposes its own variant.
 */
export type VelocityDetails = OrgHealthSessionDetails | RetrospectiveSessionDetails;

/**
 * Report items for an Organizational Health velocity session, exposed as
 * connections. Counts are read from each connection's `pageInfo.totalCount`.
 */
export interface OrgHealthSessionDetails {
  __typename?: 'OrgHealthSessionDetails';
  issues: VelocityIssuesConnection;
}


/**
 * Report items for an Organizational Health velocity session, exposed as
 * connections. Counts are read from each connection's `pageInfo.totalCount`.
 */
export interface OrgHealthSessionDetailsIssuesArgs {
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Report details for a Retrospective velocity session. Placeholder until the
 * retrospective report lands — exposes the count of answered questions so far.
 */
export interface RetrospectiveSessionDetails {
  __typename?: 'RetrospectiveSessionDetails';
  responseCount: Scalars['Int']['output'];
}

export interface PraiseReportModule {
  __typename?: 'PraiseReportModule';
  praise: Array<PraiseItem>;
  /** Null when the session's identificationMode is ANONYMOUS. */
  topRecognizers?: Maybe<Array<RecognizerStat>>;
}

/**
 * One organizational strength surfaced by the team, with live agree/disagree/note
 * tallies. Sorted by net sentiment (agree − disagree) by the resolver.
 */
export interface OrgStrengthsItem {
  __typename?: 'OrgStrengthsItem';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  longDescription: Scalars['String']['output'];
  agreeCount: Scalars['Int']['output'];
  disagreeCount: Scalars['Int']['output'];
  noteCount: Scalars['Int']['output'];
  /** Derived support score: 3 + 3 per explicit agree − 2 per disagree, floored at 0 — same formula issues use. The base 3 stands for the originator's agreement, which agreeCount also includes. */
  score: Scalars['Int']['output'];
  /** Rolled-up diagnostic answers for this strength. Null until at least one diagnostic answer lands. */
  diagnostics?: Maybe<OrgStrengthDiagnostics>;
}

/** Distribution of 1-5 ratings for a scale diagnostic dimension. */
export interface OrgStrengthScaleRollup {
  __typename?: 'OrgStrengthScaleRollup';
  count: Scalars['Int']['output'];
  average: Scalars['Float']['output'];
  /** Five buckets; index 0 = a rating of 1 … index 4 = a rating of 5. */
  distribution: Array<Scalars['Int']['output']>;
}

/** One choice option with the number of times responders selected it. */
export interface OrgStrengthChoiceCount {
  __typename?: 'OrgStrengthChoiceCount';
  value: Scalars['String']['output'];
  /** Short report label for the choice, ready to render in legends. */
  label: Scalars['String']['output'];
  /** Full participant-facing option text, as shown in the wizard. Longer than `label`. */
  detailLabel: Scalars['String']['output'];
  count: Scalars['Int']['output'];
}

/** How widely a strength reaches across the organization, as choice counts. */
export interface OrgStrengthReachRollup {
  __typename?: 'OrgStrengthReachRollup';
  total: Scalars['Int']['output'];
  counts: Array<OrgStrengthChoiceCount>;
}

/** Per-strength rollup of the diagnostic follow-up answers. */
export interface OrgStrengthDiagnostics {
  __typename?: 'OrgStrengthDiagnostics';
  significance: OrgStrengthScaleRollup;
  fragility: OrgStrengthScaleRollup;
  reach: OrgStrengthReachRollup;
}

/** Post-session report module: ranked organizational strengths. */
export interface OrgStrengthsReportModule {
  __typename?: 'OrgStrengthsReportModule';
  strengths: Array<OrgStrengthsItem>;
}

export interface RecognizerStat {
  __typename?: 'RecognizerStat';
  participantId: Scalars['String']['output'];
  participantName: Scalars['String']['output'];
  praiseGiven: Scalars['Int']['output'];
}

export interface VelocityIssueItem {
  __typename?: 'VelocityIssueItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  longDescription: Scalars['String']['output'];
  /**
   * The session topic-to-avoid this issue matches, or null when it matches
   * none. Matched issues were hidden from participants mid-session.
   */
  matchedAvoidTopic?: Maybe<Scalars['String']['output']>;
  /** Taxonomy placements (domain/category) assigned by the LLM — the problem areas the issue's root-cause probes were generated from. Additive — an issue can span multiple placements. Empty until the issue has been placed. */
  categorizations: Array<IssueCategorization>;
  /** Confident root-cause patterns (cross-cutting tags) surfaced by the issue's probes. Empty until probes have been answered with enough agreement to clear the confidence threshold. */
  rcaPatterns: Array<IssueRcaPattern>;
  factorCodes: Array<Scalars['String']['output']>;
  factorNames: Array<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  assessmentCount: Scalars['Int']['output'];
  assessmentAgreeCount: Scalars['Int']['output'];
  assessmentDisagreeCount: Scalars['Int']['output'];
  averageImpactScore?: Maybe<Scalars['Float']['output']>;
  impactScoreCount: Scalars['Int']['output'];
  averageFactorEffectScores: Array<IssueFactorEffectScore>;
  /** Null when the session's identificationMode is ANONYMOUS. */
  agreedParticipants?: Maybe<Array<Participant>>;
  /** Null when the session's identificationMode is ANONYMOUS. */
  originatorParticipant?: Maybe<Participant>;
  relatedFactors: Array<IssueRelatedFactor>;
}

export interface IssueRelatedFactor {
  __typename?: 'IssueRelatedFactor';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  score: Scalars['Float']['output'];
}

export interface IssueFactorEffectScore {
  __typename?: 'IssueFactorEffectScore';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  average: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
}

export interface OrgHealthReportModule {
  __typename?: 'OrgHealthReportModule';
  participantCount: Scalars['Int']['output'];
  questionsAnswered: Scalars['Int']['output'];
  issueCount: Scalars['Int']['output'];
  factorsCovered: Scalars['Int']['output'];
  totalFactors: Scalars['Int']['output'];
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** Items the summary references, for summary-fidelity checks (BSV-7). Model-reported and best-effort — the summary is free narrative, so this is not guaranteed complete or exact; ids that don't resolve to a real item are dropped. Empty when the summary cites nothing. */
  citedItems: Array<CitedItem>;
  topIssues: Array<VelocityIssueItem>;
}

/** An item that the org-health summary references — see OrgHealthReportModule.citedItems. */
export interface CitedItem {
  __typename?: 'CitedItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  category: CitedItemCategory;
}

export type CitedItemCategory =
  | 'ISSUE';

export interface PraiseItem {
  __typename?: 'PraiseItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  celebratedPerson: Scalars['String']['output'];
  highFives: Scalars['Int']['output'];
  /** Null when the session's identificationMode is ANONYMOUS. */
  praiser?: Maybe<Participant>;
}

export interface FactorReportModule {
  __typename?: 'FactorReportModule';
  factors: Array<FactorReportFactor>;
  totalParticipants: Scalars['Int']['output'];
}

/**
 * Post-session report module: every issue surfaced in the session, ranked
 * worst-first (highest agreement score). Each carries its categorization and
 * the same fields the issue drawer reads.
 */
export interface IssuesReportModule {
  __typename?: 'IssuesReportModule';
  issues: Array<VelocityIssueItem>;
  totalParticipants: Scalars['Int']['output'];
}

export interface FactorReportFactor {
  __typename?: 'FactorReportFactor';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  participantCount: Scalars['Int']['output'];
  issues: Array<VelocityIssueItem>;
  summary?: Maybe<Scalars['String']['output']>;
  questionBreakdowns: Array<FactorQuestionBreakdown>;
  /** 0-100 Likert score per reporting factor that rolls up into this factor. */
  reportingFactorScores: Array<ReportingFactorScore>;
}

export interface FactorQuestionBreakdown {
  __typename?: 'FactorQuestionBreakdown';
  prompt: Scalars['String']['output'];
  negativeCount: Scalars['Int']['output'];
  neutralCount: Scalars['Int']['output'];
  positiveCount: Scalars['Int']['output'];
  participantCount: Scalars['Int']['output'];
}

/** Wrapper type for session factor insights including generation status. */
export interface SessionFactors {
  __typename?: 'SessionFactors';
  /** Current status of factor generation */
  status: SessionFactorGenerationStatus;
  /** The generated factor insights. Empty array if status is not 'GENERATED'. */
  factors: Array<SessionFactor>;
  /** Error message if status is 'ERRORED', null otherwise */
  error?: Maybe<Scalars['String']['output']>;
}

/** Status of factor insights generation for a session. */
export type SessionFactorGenerationStatus =
  /** Task has been queued but not started */
  | 'ENQUEUED'
  /** Task is actively generating insights */
  | 'GENERATING'
  /** Generation completed successfully */
  | 'GENERATED'
  /** Generation failed with an error */
  | 'ERRORED';

/** AI-generated insights for a specific factor across all participants in a session. */
export interface SessionFactor {
  __typename?: 'SessionFactor';
  id: Scalars['ID']['output'];
  /** The factor code (e.g., 'engagement_index', 'job_satisfaction') */
  factorCode: Scalars['String']['output'];
  /** Human-readable factor name derived from the factor code */
  factorName: Scalars['String']['output'];
  /** A 2-5 sentence plain text summary of the factor insights. No markdown formatting. */
  description: Scalars['String']['output'];
  /** A detailed analysis (3-5 paragraphs) of the factor insights with Markdown formatting */
  analysis: Scalars['String']['output'];
  /** Notable quotes from participants that illustrate the factor sentiment */
  quotes: Array<SessionFactorQuote>;
}

/** A quote from a participant that illustrates a factor's sentiment. */
export interface SessionFactorQuote {
  __typename?: 'SessionFactorQuote';
  /** The text of the quote */
  quote: Scalars['String']['output'];
  /** The participant who said this quote */
  participant: Participant;
}

export interface ImplementationsConnection {
  __typename?: 'ImplementationsConnection';
  pageInfo: PageInfo;
  edges: Array<ImplementationsEdge>;
}

export interface ImplementationsEdge {
  __typename?: 'ImplementationsEdge';
  cursor: Scalars['String']['output'];
  node: Implementation;
}

export interface Implementation {
  __typename?: 'Implementation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  description: Scalars['String']['output'];
  /** AI-generated detailed summary (markdown format). Null until enrichment completes. */
  summary?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  myVote?: Maybe<VoteType>;
  /** True when the current participant authored this implementation. */
  submittedByMe: Scalars['Boolean']['output'];
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedIssueIds: Array<Scalars['ID']['output']>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedOpportunityIds: Array<Scalars['ID']['output']>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedPraiseIds: Array<Scalars['ID']['output']>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedParticipantIds: Array<Scalars['ID']['output']>;
}

export type UserOrganizationRole =
  | 'ADMIN'
  | 'MEMBER';

export type UserStatus =
  | 'ACTIVE'
  | 'INVITED'
  | 'ARCHIVED';

export interface Organization {
  __typename?: 'Organization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  userCount: Scalars['Int']['output'];
  status: OrganizationStatus;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
}

export type OrganizationStatus =
  | 'ACTIVE'
  | 'ARCHIVED';

export interface UserOrganization {
  __typename?: 'UserOrganization';
  id: Scalars['ID']['output'];
  user: User;
  organization: Organization;
  role: UserOrganizationRole;
}

export interface ImpersonatorInfo {
  __typename?: 'ImpersonatorInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

/** Feature flags evaluated for the requesting user and their current organization. */
export interface UserFeatureFlags {
  __typename?: 'UserFeatureFlags';
  /** Whether Velocity beta session types are available when creating a session. */
  velocityBetaSessionTypes: Scalars['Boolean']['output'];
  /** Whether in-development Velocity experimental features (e.g. the in-session issue map) are shown. */
  velocityExperimentalFeatures: Scalars['Boolean']['output'];
  /** Whether the WorkTango roadmap tab is shown on the organization settings page. */
  worktangoRoadmapPage: Scalars['Boolean']['output'];
}

export interface User {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Whether this user is a WorkTango platform admin. Only visible to other platform admins. */
  isPlatformAdmin?: Maybe<Scalars['Boolean']['output']>;
  /** User source (workos or dev) */
  source: Scalars['String']['output'];
  /** User account status. Only visible to admins. */
  status?: Maybe<UserStatus>;
  /** Supported language code this user chose for the UI. Null until set. */
  locale?: Maybe<Scalars['String']['output']>;
  /** User creation timestamp */
  createdAt: Scalars['DateTime']['output'];
  /** Organization memberships this user belongs to. */
  organizationMemberships: Array<UserOrganization>;
  /** The user's current organization. Only visible to self, as organization selection is a session-level concept setting. */
  organization?: Maybe<Organization>;
  /** Whether the user's organization is overridden for the current session. */
  organizationOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** The impersonator for this session. Only visible to self. */
  impersonator?: Maybe<ImpersonatorInfo>;
  /** Feature flags for this user's current organization. Only visible to self. */
  featureFlags?: Maybe<UserFeatureFlags>;
}

export interface Participant {
  __typename?: 'Participant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** Whether this participant joined anonymously */
  isAnonymous: Scalars['Boolean']['output'];
  /** When this participant first joined the session (frozen at first join). */
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this participant last answered a question — a coarse activity signal. */
  lastQuestionAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Attribute responses provided by this participant */
  attributeResponses: Array<ParticipantAttributeResponse>;
  /** Factor scores for this participant. Returns all factors including inconclusive ones. */
  factorScores: Array<ParticipantFactorScore>;
}

export interface ParticipantAttributeResponse {
  __typename?: 'ParticipantAttributeResponse';
  id: Scalars['ID']['output'];
  /** The attribute template this response is for */
  attributeTemplate: SessionAttributeTemplate;
  /** The participant's response value */
  value: Scalars['String']['output'];
}

export interface ParticipantFactorScore {
  __typename?: 'ParticipantFactorScore';
  id: Scalars['ID']['output'];
  factorCode: Scalars['String']['output'];
  factorName: Scalars['String']['output'];
  sentiment: FactorSentiment;
  sentimentLabel: Scalars['String']['output'];
  /** AI-generated summary. Only present for conclusive factors (positive/negative), null for inconclusive. */
  summary?: Maybe<Scalars['String']['output']>;
}

/** Sentiment values for factor scores. Survey questions naturally surface problems, so 'positive' includes both clearly positive AND mixed/acceptable states. 'inconclusive' means insufficient data to assess. */
export type FactorSentiment =
  | 'POSITIVE'
  | 'NEGATIVE'
  | 'INCONCLUSIVE';

/** A Velocity engine dynamic question and its participant answer thread (one velocity_question row). Question/answer payloads are polymorphic by `type`. */
export interface VelocityQuestion {
  __typename?: 'VelocityQuestion';
  id: Scalars['ID']['output'];
  participantId: Scalars['ID']['output'];
  techniqueId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  questionData?: Maybe<Scalars['JSONObject']['output']>;
  answerData?: Maybe<Scalars['JSONObject']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** When the question was served to the participant. Null if never served. */
  askedAt?: Maybe<Scalars['DateTime']['output']>;
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
}

export interface Question {
  __typename?: 'Question';
  id: Scalars['ID']['output'];
  content: QuestionContent;
  createdAt: Scalars['DateTime']['output'];
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  section: SessionSectionType;
  issues: Array<Issue>;
  opportunities: Array<Opportunity>;
  praise: Array<Praise>;
  implementations: Array<Implementation>;
}

export type QuestionContent = MultipleChoiceQuestionContent | TextQuestionContent | BooleanQuestionContent | RankingQuestionContent | RatingScaleQuestionContent;

export interface MultipleChoiceQuestionContent {
  __typename?: 'MultipleChoiceQuestionContent';
  preamble?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  multipleChoiceOptions: Array<Scalars['String']['output']>;
}

export interface TextQuestionContent {
  __typename?: 'TextQuestionContent';
  preamble?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
}

export interface BooleanQuestionContent {
  __typename?: 'BooleanQuestionContent';
  preamble?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
}

export interface RankingQuestionOption {
  __typename?: 'RankingQuestionOption';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
}

export interface RankingQuestionContent {
  __typename?: 'RankingQuestionContent';
  preamble?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  rankingOptions: Array<RankingQuestionOption>;
  rankingType?: Maybe<Scalars['String']['output']>;
  issues: Array<Issue>;
  opportunities: Array<Opportunity>;
  praise: Array<Praise>;
}

export interface RatingScaleQuestionContent {
  __typename?: 'RatingScaleQuestionContent';
  preamble?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  scaleType: RatingScaleType;
  minLabel: Scalars['String']['output'];
  maxLabel: Scalars['String']['output'];
}

export type RatingScaleType =
  | 'NUMERIC'
  | 'STARS';

export interface NextQuestionResponse {
  __typename?: 'NextQuestionResponse';
  question?: Maybe<Question>;
  session: Session;
}

export interface CreateSessionPayload {
  __typename?: 'CreateSessionPayload';
  session?: Maybe<Session>;
}

export interface UpdateSessionPayload {
  __typename?: 'UpdateSessionPayload';
  session?: Maybe<Session>;
}

export interface DuplicateSessionPayload {
  __typename?: 'DuplicateSessionPayload';
  session?: Maybe<Session>;
}

export interface ReassignSessionPayload {
  __typename?: 'ReassignSessionPayload';
  session?: Maybe<Session>;
}

export interface AnswerQuestionPayload {
  __typename?: 'AnswerQuestionPayload';
  answer?: Maybe<Scalars['String']['output']>;
  answeredAt?: Maybe<Scalars['DateTime']['output']>;
  issues: Array<Issue>;
  opportunities: Array<Opportunity>;
  praise: Array<Praise>;
}

export interface StartSessionPayload {
  __typename?: 'StartSessionPayload';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
}

export type SessionSectionType =
  | 'DISCUSSION'
  | 'GENERATING_IDEAS'
  | 'GENERATING_IMPLEMENTATIONS'
  | 'RANKING_IDEAS'
  | 'RANKING_IMPLEMENTATIONS'
  | 'VELOCITY';

export type SessionStatus =
  | 'DRAFT'
  | 'ACTIVE'
  | 'PAUSED'
  /**
   * Velocity-only: the session has ended for participants, but the
   * report is still being generated.
   */
  | 'FINALIZING'
  | 'COMPLETED'
  | 'ARCHIVED';

export type IdentificationMode =
  | 'REQUIRED'
  | 'OPTIONAL'
  | 'ANONYMOUS';

export type InsightsVisibility =
  | 'PRIVATE'
  | 'PUBLIC';

export interface AnswerTextQuestionInput {
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  answer: Scalars['String']['input'];
}

export interface AnswerMultipleChoiceQuestionInput {
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  selectedOption: Scalars['String']['input'];
}

export interface AnswerBooleanQuestionInput {
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  value: Scalars['Boolean']['input'];
}

export interface RankedOption {
  id: Scalars['ID']['input'];
}

export interface AnswerRankingQuestionInput {
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  rankedOptions: Array<RankedOption>;
}

export interface AnswerRatingScaleQuestionInput {
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
}

export interface SkipQuestionInput {
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
}

export interface AbandonQuestionInput {
  sessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
}

export interface AbandonQuestionPayload {
  __typename?: 'AbandonQuestionPayload';
  success: Scalars['Boolean']['output'];
}

export interface CreateSessionInput {
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  description: Scalars['String']['input'];
  length: Scalars['Int']['input'];
  focus?: InputMaybe<Scalars['String']['input']>;
  defaultQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  requireDefaultQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Topics the session's AI should avoid surfacing to participants. Extracted
   * issues matching one of these are tagged so they are hidden mid-session but
   * remain visible in reports. Empty entries are ignored.
   */
  topicsToAvoid?: InputMaybe<Array<Scalars['String']['input']>>;
  allowExperimentalFactorQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  identificationMode?: InputMaybe<IdentificationMode>;
  insightsVisibility?: InputMaybe<InsightsVisibility>;
  selectedAttributeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Velocity engine subtype. Only meaningful when type is "velocity".
   * Defaults to "organizationalHealth" if omitted on a velocity session.
   */
  velocityEngineType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Org-health driver categories chosen for the session. Only meaningful for
   * velocity sessions using the organizationalHealth engine. Omitted or null
   * means the code-defined default set. Must be non-empty when provided.
   */
  activeFactorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Org-health reporting factors chosen for the session. Requires
   * activeFactorCodes. Every code must belong to an active category, and every
   * active category needs at least one selected reporting factor. Omitted or
   * null means every reporting factor of each active category.
   */
  activeReportingFactorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface UpdateSessionInput {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Int']['input']>;
  focus?: InputMaybe<Scalars['String']['input']>;
  defaultQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  requireDefaultQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Replaces the session's topics to avoid, following the CreateSessionInput
   * rules. Only accepted while the session is a draft.
   */
  topicsToAvoid?: InputMaybe<Array<Scalars['String']['input']>>;
  allowExperimentalFactorQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  insightsVisibility?: InputMaybe<InsightsVisibility>;
  /**
   * Org-health driver categories for the session, following the
   * CreateSessionInput rules. Only accepted while the session is a draft.
   */
  activeFactorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Org-health reporting factors for the session, following the
   * CreateSessionInput rules and validated against the categories in this
   * input when provided, otherwise the stored ones. Only accepted while the
   * session is a draft.
   */
  activeReportingFactorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Participant identification mode. Only accepted while the session is a
   * draft nobody has joined, because joined participants agreed to the terms
   * of the mode in force when they joined.
   */
  identificationMode?: InputMaybe<IdentificationMode>;
  /**
   * Attribute templates participants must answer when joining. Same
   * restriction as identificationMode.
   */
  selectedAttributeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface DuplicateSessionInput {
  id: Scalars['ID']['input'];
}

/**
 * Moves a session to a different organization. Platform admin only. Selected
 * attribute templates keep their original scope and do not move with the
 * session.
 */
export interface ReassignSessionInput {
  id: Scalars['ID']['input'];
  /**
   * Target organization. Null removes the session from any organization,
   * leaving it accessible only to its facilitator.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}

export interface StartSessionInput {
  id: Scalars['ID']['input'];
}

export interface JoinSessionInput {
  sessionId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Attribute responses for session-configured attributes */
  attributeResponses?: InputMaybe<Array<AttributeResponseInput>>;
  /**
   * Verbatim terms text the participant agreed to when joining. Must exactly
   * match the terms required for the session's identification mode
   * (TERMS_AGREEMENT_BY_IDENTIFICATION_MODE in the joinSession resolver).
   */
  agreedTerms: Scalars['String']['input'];
  /** Supported language code chosen on the join card; stored on the participant. */
  locale?: InputMaybe<Scalars['String']['input']>;
}

export interface ReportAttributeFilterInput {
  attributeTemplateId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}

export interface AttributeResponseInput {
  attributeTemplateId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}

export interface JoinSessionPayload {
  __typename?: 'JoinSessionPayload';
  session: Session;
  participant?: Maybe<Participant>;
}

export interface QuestionsFilterInput {
  sessionId: Scalars['ID']['input'];
}

export interface QuestionsSortInput {
  field: QuestionsSortField;
  direction?: InputMaybe<SortDirection>;
}

export type QuestionsSortField =
  | 'CREATED_AT';

export interface ParticipantAnswersFilterInput {
  sessionId: Scalars['ID']['input'];
  participantId: Scalars['String']['input'];
}

export interface ParticipantsFilterInput {
  sessionId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface SessionParticipantsFilterInput {
  /** Filter by participant name (partial match, case-insensitive) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by participant email (partial match, case-insensitive) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filter by participant title (partial match, case-insensitive) */
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface ParticipantsSortInput {
  field: ParticipantsSortField;
  direction?: InputMaybe<SortDirection>;
}

export type ParticipantsSortField =
  | 'NAME'
  | 'EMAIL'
  | 'TITLE';

export interface SessionsConnection {
  __typename?: 'SessionsConnection';
  pageInfo: PageInfo;
  edges: Array<SessionsEdge>;
}

export interface SessionsEdge {
  __typename?: 'SessionsEdge';
  cursor: Scalars['String']['output'];
  node: Session;
}

export interface SessionsFilterInput {
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statuses?: InputMaybe<Array<SessionStatus>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * Return only velocity sessions whose engine type is one of the given types.
   * A velocity session with no stored engine type is treated as
   * organizationalHealth.
   */
  engineType?: InputMaybe<Array<SessionEngineType>>;
}

/**
 * Subtype of the velocity engine. Used to filter velocity sessions by their
 * engine type. Values match the stored `velocityEngineType` on a session.
 */
export type SessionEngineType =
  | 'VELOCITY'
  | 'FEEDBACK';

export interface SessionsSortInput {
  field: SessionsSortField;
  direction?: InputMaybe<SortDirection>;
}

export type SessionsSortField =
  | 'CREATED_AT'
  | 'TITLE';

export interface ParticipantsConnection {
  __typename?: 'ParticipantsConnection';
  pageInfo: PageInfo;
  edges: Array<ParticipantsEdge>;
}

export interface ParticipantsEdge {
  __typename?: 'ParticipantsEdge';
  cursor: Scalars['String']['output'];
  node: Participant;
}

export interface EndSessionInput {
  id: Scalars['ID']['input'];
}

export interface EndSessionPayload {
  __typename?: 'EndSessionPayload';
  session?: Maybe<Session>;
}

export interface SkipToNextSectionInput {
  sessionId: Scalars['ID']['input'];
}

export interface SkipToNextSectionPayload {
  __typename?: 'SkipToNextSectionPayload';
  session: Session;
  newSectionIndex: Scalars['Int']['output'];
}

export interface CreateFeedbackInput {
  sessionId: Scalars['ID']['input'];
  feedback: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
}

export interface Feedback {
  __typename?: 'Feedback';
  id: Scalars['ID']['output'];
  feedback: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  participant: Participant;
  createdAt: Scalars['DateTime']['output'];
}

export interface CreateFeedbackPayload {
  __typename?: 'CreateFeedbackPayload';
  feedback?: Maybe<Feedback>;
}

export interface FeedbackConnection {
  __typename?: 'FeedbackConnection';
  pageInfo: PageInfo;
  edges: Array<FeedbackEdge>;
}

export interface FeedbackEdge {
  __typename?: 'FeedbackEdge';
  cursor: Scalars['String']['output'];
  node: Feedback;
}

export interface FeedbackFilterInput {
  sessionId: Scalars['ID']['input'];
  participantId?: InputMaybe<Scalars['String']['input']>;
}

export interface SessionInsightsResult {
  __typename?: 'SessionInsightsResult';
  sessionInsights?: Maybe<SessionInsights>;
  wasTaskEnqueued: Scalars['Boolean']['output'];
  /** False when the requesting user lacks read access to this session's insights. The client renders a gated screen rather than treating it as an error. */
  canViewInsights: Scalars['Boolean']['output'];
}

export interface SessionInsights {
  __typename?: 'SessionInsights';
  sessionSummary?: Maybe<SessionSummary>;
  issues: Array<Issue>;
  opportunities: Array<Opportunity>;
  praise: Array<Praise>;
  implementations: Array<Implementation>;
  participantCount: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
}

/** AI-generated summary of a session's key findings and themes. */
export interface SessionSummary {
  __typename?: 'SessionSummary';
  /**
   * Unique identifier for cache invalidation. When a summary is regenerated,
   * it gets a new ID, allowing Apollo Client to detect the change and update
   * the UI without showing stale cached data.
   */
  id: Scalars['ID']['output'];
  positiveHighlights: Array<Scalars['String']['output']>;
  areasForImprovement: Array<Scalars['String']['output']>;
}

export interface Issue {
  __typename?: 'Issue';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Short plain-text description (1-2 sentences) of the issue. */
  description: Scalars['String']['output'];
  /**
   * The session topic-to-avoid this issue matches, or null when it matches
   * none. Matched issues are hidden from participants mid-session and appear
   * only in facilitator-facing insights.
   */
  matchedAvoidTopic?: Maybe<Scalars['String']['output']>;
  /** Single-sentence organizational implication, shown as the topic detail headline. Null until insights are finalized or when generation fails. */
  oneLiner?: Maybe<Scalars['String']['output']>;
  /** Detailed Markdown-formatted summary enriched with participant responses. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Absolute value of how many people concur with this issue. */
  score: Scalars['Int']['output'];
  myVote?: Maybe<VoteType>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedParticipantIds: Array<Scalars['ID']['output']>;
  /** Email-based topic ownership assignments for this issue. */
  topicAssignments: Array<TopicAssignment>;
  /** 1-3 verbatim participant quotes that explain the issue, shown in the 'Why' section. */
  whyQuotes: Array<TopicWhyQuote>;
  /** The current participant's solutioning state for this topic. */
  mySolutionStatus: SolutionStatus;
  /** Whether the facilitator selected this topic to carry forward to Section 4. */
  selectedForSolutioning: Scalars['Boolean']['output'];
}

export interface Opportunity {
  __typename?: 'Opportunity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Short plain-text description (1-2 sentences) of the opportunity. */
  description: Scalars['String']['output'];
  /**
   * The session topic-to-avoid this opportunity matches, or null when it
   * matches none. Matched opportunities are hidden from participants
   * mid-session and appear only in facilitator-facing insights.
   */
  matchedAvoidTopic?: Maybe<Scalars['String']['output']>;
  /** Single-sentence organizational implication, shown as the topic detail headline. Null until insights are finalized or when generation fails. */
  oneLiner?: Maybe<Scalars['String']['output']>;
  /** Detailed Markdown-formatted summary enriched with participant responses. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Absolute value of how many people concur with this opportunity. */
  score: Scalars['Int']['output'];
  myVote?: Maybe<VoteType>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedParticipantIds: Array<Scalars['ID']['output']>;
  /** Email-based topic ownership assignments for this opportunity. */
  topicAssignments: Array<TopicAssignment>;
  /** 1-3 verbatim participant quotes that explain the opportunity, shown in the 'Why' section. */
  whyQuotes: Array<TopicWhyQuote>;
  /** The current participant's solutioning state for this topic. */
  mySolutionStatus: SolutionStatus;
  /** Whether the facilitator selected this topic to carry forward to Section 4. */
  selectedForSolutioning: Scalars['Boolean']['output'];
}

export interface Praise {
  __typename?: 'Praise';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Short plain-text description (1-2 sentences) of the praise. */
  description: Scalars['String']['output'];
  /** Single-sentence organizational implication, shown as the topic detail headline. Null until insights are finalized or when generation fails. */
  oneLiner?: Maybe<Scalars['String']['output']>;
  /** Detailed Markdown-formatted summary enriched with participant responses. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Absolute value of how many people concur with this praise. */
  score: Scalars['Int']['output'];
  myVote?: Maybe<VoteType>;
  /** Exposed as a quick list for visualizations. Only accessible from the SessionInsights query. */
  linkedParticipantIds: Array<Scalars['ID']['output']>;
  /** Email-based topic ownership assignments for this praise. */
  topicAssignments: Array<TopicAssignment>;
  /** 1-3 verbatim participant quotes that explain the praise, shown in the 'Why' section. */
  whyQuotes: Array<TopicWhyQuote>;
}

/** A verbatim participant quote shown in a topic's 'Why' section. Attribution follows the session's anonymity level. */
export interface TopicWhyQuote {
  __typename?: 'TopicWhyQuote';
  id: Scalars['ID']['output'];
  /** The verbatim quote text. */
  text: Scalars['String']['output'];
  /** The prompt the participant was answering when they said this. */
  questionText: Scalars['String']['output'];
  /** Participant display name. Null when the participant joined anonymously. */
  name?: Maybe<Scalars['String']['output']>;
  /** Participant role/title. Null when the participant joined anonymously. */
  role?: Maybe<Scalars['String']['output']>;
}

/** An idea can be an issue, opportunity, or praise. */
export type Idea = Issue | Opportunity | Praise;

export type VoteType =
  | 'UP'
  | 'NONE';

export type SolutionStatus =
  | 'NONE'
  | 'IN_PROGRESS'
  | 'SUBMITTED';

export type VotableEntityType =
  | 'IDEA'
  | 'IMPLEMENTATION';

export interface SaveVoteInput {
  sessionId: Scalars['ID']['input'];
  entityType: VotableEntityType;
  entityId: Scalars['ID']['input'];
  vote: VoteType;
}

export interface SaveVotePayload {
  __typename?: 'SaveVotePayload';
  success: Scalars['Boolean']['output'];
  opportunity?: Maybe<Opportunity>;
  implementation?: Maybe<Implementation>;
  issue?: Maybe<Issue>;
  praise?: Maybe<Praise>;
}

export interface PauseSessionInput {
  sessionId: Scalars['ID']['input'];
}

export interface PauseSessionPayload {
  __typename?: 'PauseSessionPayload';
  session: Session;
}

export interface ResumeSessionInput {
  sessionId: Scalars['ID']['input'];
}

export interface ResumeSessionPayload {
  __typename?: 'ResumeSessionPayload';
  session: Session;
}

export interface RegenerateSessionSummaryInput {
  sessionId: Scalars['ID']['input'];
}

export interface RegenerateSessionSummaryPayload {
  __typename?: 'RegenerateSessionSummaryPayload';
  success: Scalars['Boolean']['output'];
  session: Session;
}

export interface StartSolutionForIdeaInput {
  sessionId: Scalars['ID']['input'];
  ideaId: Scalars['ID']['input'];
  initialSolution: Scalars['String']['input'];
}

export interface StartSolutionForIdeaPayload {
  __typename?: 'StartSolutionForIdeaPayload';
  solutionSessionId: Scalars['ID']['output'];
  nextQuestion?: Maybe<Question>;
}

export interface AnswerSolutionQuestionInput {
  solutionSessionId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
  answer: Scalars['String']['input'];
}

export interface AnswerSolutionQuestionPayload {
  __typename?: 'AnswerSolutionQuestionPayload';
  solutionSessionId: Scalars['ID']['output'];
  nextQuestion?: Maybe<Question>;
  isComplete: Scalars['Boolean']['output'];
  questionsAnswered: Scalars['Int']['output'];
}

export type SessionAttributeType =
  | 'DROPDOWN'
  | 'CUSTOM';

export interface SessionAttributeTemplate {
  __typename?: 'SessionAttributeTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: SessionAttributeType;
  options: Array<Scalars['String']['output']>;
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
}

export interface SessionAttributeTemplatesConnection {
  __typename?: 'SessionAttributeTemplatesConnection';
  pageInfo: PageInfo;
  edges: Array<SessionAttributeTemplatesEdge>;
}

export interface SessionAttributeTemplatesEdge {
  __typename?: 'SessionAttributeTemplatesEdge';
  cursor: Scalars['String']['output'];
  node: SessionAttributeTemplate;
}

export interface SessionAttributeTemplatesFilterInput {
  name?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SessionAttributeStatus>>;
  types?: InputMaybe<Array<SessionAttributeType>>;
}

export type SessionAttributeStatus =
  | 'ACTIVE'
  | 'ARCHIVED';

export interface CreateSessionAttributeTemplateInput {
  name: Scalars['String']['input'];
  type: SessionAttributeType;
  options: Array<Scalars['String']['input']>;
}

export interface CreateSessionAttributeTemplatePayload {
  __typename?: 'CreateSessionAttributeTemplatePayload';
  sessionAttributeTemplate: SessionAttributeTemplate;
}

export interface UpdateSessionAttributeTemplateInput {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type: SessionAttributeType;
  options: Array<Scalars['String']['input']>;
  archived: Scalars['Boolean']['input'];
}

export interface UpdateSessionAttributeTemplatePayload {
  __typename?: 'UpdateSessionAttributeTemplatePayload';
  sessionAttributeTemplate: SessionAttributeTemplate;
}

export interface ArchiveSessionAttributeTemplateInput {
  id: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
}

export interface ArchiveSessionAttributeTemplatePayload {
  __typename?: 'ArchiveSessionAttributeTemplatePayload';
  sessionAttributeTemplate: SessionAttributeTemplate;
}

export interface UsersConnection {
  __typename?: 'UsersConnection';
  pageInfo: PageInfo;
  edges: Array<UsersEdge>;
}

export interface UsersEdge {
  __typename?: 'UsersEdge';
  cursor: Scalars['String']['output'];
  node: User;
}

export interface UsersFilterInput {
  search?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  roles?: InputMaybe<Array<UserOrganizationRole>>;
  statuses?: InputMaybe<Array<UserStatus>>;
}

export interface OrganizationsFilterInput {
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<OrganizationStatus>>;
}

export interface UsersSortInput {
  field: UsersSortField;
  direction?: InputMaybe<SortDirection>;
}

export type UsersSortField =
  | 'EMAIL'
  | 'CREATED_AT'
  | 'STATUS';

export interface OrganizationUsersFilterInput {
  /** Filter by first name, last name, or email (partial match, case-insensitive) */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by organization role(s) */
  roles?: InputMaybe<Array<UserOrganizationRole>>;
  /** Filter by user status(es) */
  statuses?: InputMaybe<Array<UserStatus>>;
}

export interface OrganizationUsersSortInput {
  field: OrganizationUsersSortField;
  direction?: InputMaybe<SortDirection>;
}

export type OrganizationUsersSortField =
  | 'NAME'
  | 'EMAIL'
  | 'CREATED_AT';

export interface SendInvitationInput {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<UserOrganizationRole>;
}

export interface SendInvitationPayload {
  __typename?: 'SendInvitationPayload';
  invitationSent: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['String']['output']>;
}

export interface SendInsightsEmailInput {
  sessionId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
}

export interface SendInsightsEmailPayload {
  __typename?: 'SendInsightsEmailPayload';
  success: Scalars['Boolean']['output'];
  emailsSent: Scalars['Int']['output'];
}

export interface ArchiveUserInput {
  userId: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
}

export interface ArchiveUserPayload {
  __typename?: 'ArchiveUserPayload';
  user: User;
}

export interface UpdateUserInput {
  userId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationRole?: InputMaybe<UserOrganizationRole>;
}

export interface UpdateUserPayload {
  __typename?: 'UpdateUserPayload';
  user: User;
}

export interface UpdateCurrentUserLocaleInput {
  locale: Scalars['String']['input'];
}

export interface UpdateCurrentUserLocalePayload {
  __typename?: 'UpdateCurrentUserLocalePayload';
  user: User;
}

export interface AddUserToOrganizationInput {
  userId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  role?: InputMaybe<UserOrganizationRole>;
}

export interface AddUserToOrganizationPayload {
  __typename?: 'AddUserToOrganizationPayload';
  userOrganization: UserOrganization;
}

export interface RemoveUserFromOrganizationInput {
  userId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}

export interface RemoveUserFromOrganizationPayload {
  __typename?: 'RemoveUserFromOrganizationPayload';
  success: Scalars['Boolean']['output'];
}

export interface UpdateUserOrganizationRoleInput {
  userId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  role: UserOrganizationRole;
}

export interface UpdateUserOrganizationRolePayload {
  __typename?: 'UpdateUserOrganizationRolePayload';
  userOrganization: UserOrganization;
}

export interface CreateOrganizationInput {
  name: Scalars['String']['input'];
}

export interface CreateOrganizationPayload {
  __typename?: 'CreateOrganizationPayload';
  organization: Organization;
}

export interface UpdateOrganizationInput {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface UpdateOrganizationPayload {
  __typename?: 'UpdateOrganizationPayload';
  organization: Organization;
}

export interface DeleteOrganizationInput {
  id: Scalars['ID']['input'];
}

export interface DeleteOrganizationPayload {
  __typename?: 'DeleteOrganizationPayload';
  success: Scalars['Boolean']['output'];
}

export interface ArchiveOrganizationInput {
  id: Scalars['ID']['input'];
}

export interface ArchiveOrganizationPayload {
  __typename?: 'ArchiveOrganizationPayload';
  organization: Organization;
}

export interface RestoreOrganizationInput {
  id: Scalars['ID']['input'];
}

export interface RestoreOrganizationPayload {
  __typename?: 'RestoreOrganizationPayload';
  organization: Organization;
}

/** An email-based topic ownership assignment for an idea. */
export interface TopicAssignment {
  __typename?: 'TopicAssignment';
  id: Scalars['ID']['output'];
  /** The email address of the assigned owner. */
  email: Scalars['String']['output'];
  /** The user ID of the person who created this assignment. */
  assignedByUserId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
}

export interface AssignTopicOwnershipInput {
  /** The session this idea belongs to. */
  sessionId: Scalars['ID']['input'];
  /** The idea (issue, opportunity, or praise) to assign. */
  ideaId: Scalars['ID']['input'];
  /** The email address of the person to assign as topic owner. */
  email: Scalars['String']['input'];
}

export interface AssignTopicOwnershipPayload {
  __typename?: 'AssignTopicOwnershipPayload';
  topicAssignment: TopicAssignment;
  idea: Idea;
}

export interface RemoveTopicAssignmentInput {
  /** The IDs of the topic assignments to remove. */
  ids: Array<Scalars['ID']['input']>;
}

export interface RemoveTopicAssignmentPayload {
  __typename?: 'RemoveTopicAssignmentPayload';
  success: Scalars['Boolean']['output'];
  idea?: Maybe<Idea>;
}

/** An email-based owner assignment for a Velocity issue. */
export interface VelocityIssueAssignment {
  __typename?: 'VelocityIssueAssignment';
  id: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  assignedByUserId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
}

export interface AssignVelocityIssueOwnershipInput {
  issueId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}

export interface AssignVelocityIssueOwnershipPayload {
  __typename?: 'AssignVelocityIssueOwnershipPayload';
  assignment: VelocityIssueAssignment;
  issue: VelocityIssue;
}

export interface RemoveVelocityIssueAssignmentInput {
  issueId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
}

export interface RemoveVelocityIssueAssignmentPayload {
  __typename?: 'RemoveVelocityIssueAssignmentPayload';
  success: Scalars['Boolean']['output'];
  issue: VelocityIssue;
}

export interface SetSolutioningTopicsInput {
  /** The session whose solutioning topics are being set. */
  sessionId: Scalars['ID']['input'];
  /** The issue/opportunity ideas to carry forward to Section 4. Replaces the prior selection. */
  ideaIds: Array<Scalars['ID']['input']>;
}

export interface SetSolutioningTopicsPayload {
  __typename?: 'SetSolutioningTopicsPayload';
  /** All issues in the session, with their updated selection state. */
  issues: Array<Issue>;
  /** All opportunities in the session, with their updated selection state. */
  opportunities: Array<Opportunity>;
}

export interface ToggleCurrentUserPlatformAdminPayload {
  __typename?: 'ToggleCurrentUserPlatformAdminPayload';
  user: User;
}

export interface AccessCapabilities {
  __typename?: 'AccessCapabilities';
  /** Not used, but required by Apollo Federation v2 to be a key field. */
  id: Scalars['ID']['output'];
}

export interface NotificationSetting {
  __typename?: 'NotificationSetting';
  /** Key (which is unique) copied into the ID column for cache invalidation on the UI. */
  id: Scalars['ID']['output'];
  /** Unique key identifying this notification setting */
  key: Scalars['String']['output'];
  /** A localized translation value. */
  nameTranslation: Scalars['String']['output'];
  /** An indicator of how to render these notification settings in grouped sections in the UI. */
  section: NotificationSettingUiSection;
  /** true: enabled. false: disabled. undefined: unset (use the API's default) */
  bell?: Maybe<Scalars['Boolean']['output']>;
  /** true: enabled. false: disabled. undefined: unset (use the API's default) */
  actionItem?: Maybe<Scalars['Boolean']['output']>;
  /** true: enabled. false: disabled. undefined: unset (use the API's default) */
  email?: Maybe<Scalars['Boolean']['output']>;
  /** true: enabled. false: disabled. null: this notification type does not offer push */
  push?: Maybe<Scalars['Boolean']['output']>;
}

export type NotificationSettingUiSection =
  | 'MAIN'
  | 'MANAGER_ENABLEMENT';

/** Represents some rich text content, which can be rendered in one of several formats. JSON is the native format; other formats are derived from it and may be lossy. */
export interface RichTextContent {
  __typename?: 'RichTextContent';
  /** The canonical representation of the rich text content, in ProseMirror JSON format. */
  json: Scalars['RichTextDocument']['output'];
  /** The HTML representation of the rich text content, supporting a limited set of basic HTML formatting tags. Conversion to and from ProseMirror JSON may not be 1-to-1. */
  html: Scalars['String']['output'];
  /** The plaintext representation of the rich text content. Any rich text formatting will be lost. */
  plaintext: Scalars['String']['output'];
}

/** Represents a user's input for some rich text content. User input can be provided in one of several formats and will be sanitized and converted to a ProseMirror document if necessary. JSON inputs which do not conform to the ProseMirror schema will be rejected. */
export interface RichTextContentInput {
  json?: InputMaybe<Scalars['RichTextDocument']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  plaintext?: InputMaybe<Scalars['String']['input']>;
}

export interface PageInfo {
  __typename?: 'PageInfo';
  totalCount: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
  endCursor?: Maybe<Scalars['String']['output']>;
}

export type SortDirection =
  | 'ASC'
  | 'DESC';

export interface Node {
  /** A globally unique identifier. */
  id: Scalars['ID']['output'];
}

/** Used for calling out 'today's birthdays' without Kazoo storing actual DOB. */
export interface MonthDayInput {
  /** 2 digit month */
  month: Scalars['Int']['input'];
  /** 2 digit day of month */
  day: Scalars['Int']['input'];
  nullify?: InputMaybe<Scalars['Boolean']['input']>;
}

export type DateFilterOperator =
  | 'DATE_EQUALS'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'IS_NULL'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO'
  /** For finding a date that matches the month and day of the value, but not the year. IE all anniversaries today regardless of year. */
  | 'MATCH_MONTH_AND_DAY_ANY_YEAR'
  | 'MATCH_MONTH_AND_DAY_GREATER_THAN_OR_EQUAL_ANY_YEAR'
  | 'MATCH_MONTH_AND_DAY_LESS_THAN_OR_EQUAL_ANY_YEAR';

export interface MonthDayFilter {
  operator: DateFilterOperator;
  value?: InputMaybe<MonthDayInput>;
}

export interface DateFilter {
  operator: DateFilterOperator;
  value?: InputMaybe<Scalars['Date']['input']>;
}

export interface DateTimeFilter {
  operator: DateTimeFilterOperator;
  value?: InputMaybe<Scalars['DateTime']['input']>;
}

export type DateTimeFilterOperator =
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL_TO'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL_TO';

export type KazooModule =
  | 'AWARDS'
  | 'BEHAVIOR_BONUS'
  | 'INCENTIVES'
  | 'KW_FEEDBACK'
  | 'KW_SYNC_UPS'
  | 'KW_TALENT_REVIEW'
  | 'LEGACY_AWARDS'
  | 'NEW_CHECK_INS'
  | 'NEW_GOALS'
  | 'REWARDS'
  | 'SURVEYS'
  | 'SYNC_UP';

export type KazooIcon =
  | 'ADD_USER'
  | 'ADMIN'
  | 'ANNIVERSARY'
  | 'ANNIVERSARY_CAL'
  | 'ARROW_LEFT'
  | 'ARROW_RIGHT'
  | 'BACK'
  | 'BELL'
  | 'BIRTHDAY'
  | 'BIRTHDAY_CAKE'
  | 'CALENDAR'
  | 'CARET_DN'
  | 'CARET_DOWN'
  | 'CARET_LEFT'
  | 'CARET_RIGHT'
  | 'CARET_UP'
  | 'CHECK'
  | 'CHECKMARK'
  | 'CHECK_IN'
  | 'CHECK_SEAL'
  | 'CLOCK'
  | 'CLOSE'
  | 'CLOUD_DOWNLOAD'
  | 'COMMENT'
  | 'COMPANY_LINKS'
  | 'DATEPICKER_NAV'
  | 'DOT'
  | 'DOWNLOAD'
  | 'DOWN_ARROW'
  | 'DRAG'
  | 'EARN'
  | 'EMAIL'
  | 'EXPIRED'
  | 'EYE'
  | 'FEEDBACK'
  | 'FILTER'
  | 'FILTER_MENU'
  | 'FIND'
  | 'FLAG'
  | 'GOALS'
  | 'GOAL_COUNT'
  | 'GOAL_PERCENT'
  | 'GOAL_TASK'
  | 'HAMBURGER'
  | 'HAND_EXPANDED'
  | 'HELP'
  | 'HIGH_FIVE'
  | 'HIGH_FIVE_HOLLOW'
  | 'HOME'
  | 'HORIZONTAL_LINE'
  | 'HOURGLASS'
  | 'IMAGE_FILE'
  | 'INCENTIVES'
  | 'INFO'
  | 'INSIGHTS'
  | 'LINK'
  | 'LINK_ARROW'
  | 'LINK_FEATURE'
  | 'LOCK'
  | 'MEATBALL_MENU'
  | 'NOMINATION'
  | 'NOTIFICATION'
  | 'OPEN_CARET'
  | 'OPEN_CARET_DOWN'
  | 'OPEN_CARET_LEFT'
  | 'OPEN_CARET_UP'
  | 'PENCIL'
  | 'PEOPLE'
  | 'PIN'
  | 'PLATFORM_LOGO'
  | 'PLUS'
  | 'PROGRESS_CIRCLE'
  | 'PUSH_PIN'
  | 'RATING'
  | 'RECOGNITION'
  | 'REMOVE'
  | 'REWARDS'
  | 'SEARCH'
  | 'SEND_RECOGNITION'
  | 'SHARE_LINK'
  | 'SKILL'
  | 'SMILEY'
  | 'SURVEY'
  | 'SURVEYS'
  | 'SYNCS'
  | 'TALENT_REVIEW'
  | 'TALENT_REVIEW_INSIGHTS'
  | 'TASK_COMPLETED'
  | 'TEAMS'
  | 'TEXT_BOLD'
  | 'TEXT_BULLETLIST'
  | 'TEXT_INPUT'
  | 'TEXT_ITALIC'
  | 'TEXT_NUMBERLIST'
  | 'TEXT_UNDERLINE'
  | 'TOGGLE'
  | 'TRASH'
  | 'TREND_DOWN'
  | 'TREND_UP'
  | 'UP_ARROW'
  | 'UP_DOWN_CARET'
  | 'VERTICAL_LINE'
  | 'WARNING'
  | 'WARNING_NO_OUTLINE';

export interface TranslationLinkInput {
  /** URL you'd like the split of the translation to link to */
  url: Scalars['String']['input'];
  /** The split point in the translation value EG: for <0>Sent Recognition to</0> <1>{{ recipient }}</1>, the split would be 1. */
  translationSubstitutionIndex: Scalars['Int']['input'];
}

export interface TranslationVariableInput {
  /** The variable name defined in content.json or common.json for a specific translation. */
  key: Scalars['String']['input'];
  /** The value to be rendered in the translation. EG: Janet, Q4 Check-In, etc. */
  value: Scalars['String']['input'];
  /** Optionally may provide a UUID. Useful for linking to something on the frontend. */
  translationLink?: InputMaybe<TranslationLinkInput>;
}

export type TranslationIdentifierTypes =
  | 'PERSON';

export type FieldOnEntityForTranslation =
  | 'PERSON_FULL_NAME';

export interface DynamicTranslationVariableInput {
  /** The name of the variable in the translation. */
  key: Scalars['String']['input'];
  /** The entity type we want to query */
  identifierType: TranslationIdentifierTypes;
  /** The ID of the entity to query. */
  identifierId: Scalars['ID']['input'];
  /** The field on that entity to be used as a translation variable. */
  fieldOnIdentifiedEntity: FieldOnEntityForTranslation;
  /** Optionally may provide a URL. Useful for linking to something on the frontend. */
  translationLink?: InputMaybe<TranslationLinkInput>;
}

/** Used to provide a translation key and and variables which can be used in translation function. */
export interface TranslatableObjectInput {
  /** Translation key. Should map to to known translation in content.json or common.json. If you provide any other string value it will render untranslated. */
  key: Scalars['String']['input'];
  /** JSON object consisting of variables defined for a given translation. */
  variables?: InputMaybe<Array<TranslationVariableInput>>;
  dynamicVariables?: InputMaybe<Array<DynamicTranslationVariableInput>>;
}

export interface TranslationLink {
  __typename?: 'TranslationLink';
  /** URL you'd like the split of the translation to link to */
  url: Scalars['String']['output'];
  /** The split point in the translation value EG: for <0>Sent Recognition to</0> <1>{{ recipient }}</1>, the split would be 1. */
  translationSubstitutionIndex: Scalars['Int']['output'];
}

export interface TranslationVariable {
  __typename?: 'TranslationVariable';
  /** The variable name defined in content.json or common.json for a specific translation. */
  key: Scalars['String']['output'];
  /** The value to be rendered in the translation. EG: Janet, Q4 Check-In, etc. */
  value: Scalars['String']['output'];
  /** Optionally may provide a URL. Useful for linking to something on the frontend. */
  translationLink?: Maybe<TranslationLink>;
}

/** Returns a translation key and variables needed to translate. */
export interface TranslatableObject {
  __typename?: 'TranslatableObject';
  key: Scalars['String']['output'];
  variables?: Maybe<Array<TranslationVariable>>;
  translatedValue?: Maybe<Scalars['String']['output']>;
}

/** Represents an element that can be substituted into a translation. */
export interface TranslationValue {
  __typename?: 'TranslationValue';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
}

export interface TranslatableError {
  __typename?: 'TranslatableError';
  message: Scalars['String']['output'];
  translationKey: Scalars['String']['output'];
  translationValues?: Maybe<Array<TranslationValue>>;
}

export type Role =
  | 'ADMIN'
  | 'ANALYST'
  | 'FINANCE'
  | 'FULFILLER'
  | 'PLATFORM_ADMIN'
  /** Can approve or reject rewards redemptions. */
  | 'REWARDS_MODERATOR'
  /** Deprecated. Use REWARDS_MODERATOR. */
  | 'REWARDS_MODERATORS'
  | 'SURVEY_ADMIN'
  /** Role that grants users UI access to Pulse app. Will also write back a pre-defined set of permissions within the Pulse app so that that WTW user can access certain features in Pulse. */
  | 'SURVEY_CUSTOM'
  /**
   * Sets a Full Report Reader in S&I.
   * Has access to view detailed reports for the Engagement survey type, including employee-level data, across all hierarchies.
   * This role can also filter reports using all attributes.
   */
  | 'SURVEY_FULL_REPORT_READER'
  /**
   * Sets a People Leader role in S&I.
   * Can manage and analyze engagement surveys, including viewing detailed reports filtered by various attributes, but their data access is limited to employees within their own hierarchy.
   * This role can also view and manage comments to understand employee sentiment.
   */
  | 'SURVEY_PEOPLE_LEADER'
  /**
   * Role that grants Pulse-only users access to the WorkTango AI Assistant admin
   * functionality.
   *
   * Some KW_USERS People who do not have this role will be treated as if they do if they have the WORKTANGO_COACH_ADMIN role in Pulse.
   * This allows SURVEY_CUSTOM permissions to define in the pulse app if a user can admin WorkTango Coach.
   */
  | 'WORKTANGO_COACH_ADMIN'
  /**
   * Role that grants users access to the WorkTango coach functionality.
   *
   * Some KW_USERS People who do not have this role will be treated as if they do if they have the WORKTANGO_COACH_USER role in Pulse.
   * This allows SURVEY_CUSTOM permissions to define in the pulse app if a user can use WorkTango Coach.
   */
  | 'WORKTANGO_COACH_USER';

/**
 * Identity providers that may still carry legacy YEI and Pulse ids. Accepted only at
 * positions whose callers still send legacy ids. New APIs must use
 * PersonIdentityProvider, which rejects legacy ids.
 */
export type LegacyPersonIdentityProvider =
  /** Email.  Only unique within a company. */
  | 'EMAIL'
  /** EmployeeID, badge number or other value that is only unique within a company. */
  | 'EMPLOYEE_ID'
  /** GRS member id */
  | 'GRS_MEMBER_ID'
  /** globally unique identifier. Kazoo-assigned. */
  | 'KAZOO_ID'
  /** Legacy YouEarnedIt userId */
  | 'LEGACY_YEI_ID'
  /** Legacy YouEarnedIt username */
  | 'LEGACY_YEI_USERNAME'
  /** Employee Id from the WorkTango Pulse platform */
  | 'PULSE_EMPLOYEE_ID'
  /** User Id from the WorkTango Pulse platform */
  | 'PULSE_USER_ID'
  /** Kazoo Username */
  | 'USERNAME'
  /** WorkOS user id */
  | 'WORKOS_USER_ID';

/** Identity providers for current WorkTango products. Does not include legacy YEI ids; see LegacyPersonIdentityProvider. */
export type PersonIdentityProvider =
  /** Email.  Only unique within a company. */
  | 'EMAIL'
  /** EmployeeID, badge number or other value that is only unique within a company. */
  | 'EMPLOYEE_ID'
  /** GRS member id */
  | 'GRS_MEMBER_ID'
  /** globally unique identifier. Kazoo-assigned. */
  | 'KAZOO_ID'
  /** Employee Id from the WorkTango Pulse platform */
  | 'PULSE_EMPLOYEE_ID'
  /** User Id from the WorkTango Pulse platform */
  | 'PULSE_USER_ID'
  /** Kazoo Username */
  | 'USERNAME'
  /** WorkOS user id */
  | 'WORKOS_USER_ID';

export type QueryPeopleSortField =
  | 'BIRTHDAY'
  | 'DEPARTMENT_NAME'
  | 'EMPLOYMENT_START_DATE'
  | 'EXEMPT_FROM_AUTO_ARCHIVE'
  | 'FULL_NAME'
  | 'LEGACY_FIRST_NAME'
  | 'LEGACY_LAST_NAME'
  | 'LOCATION_NAME'
  | 'POINTS_TO_SEND'
  | 'POINTS_TO_SPEND'
  | 'POINT_RULE'
  | 'STATUS'
  | 'TITLE';

export interface QueryPeopleSortInput {
  field: QueryPeopleSortField;
  direction: SortDirection;
}

/** Used to identify a person in input operations. Does not accept legacy ids; see LegacyPersonIdentityInput. */
export interface PersonIdentityInput {
  /** provider */
  provider: PersonIdentityProvider;
  /** identifier of their account */
  key: Scalars['String']['input'];
}

/**
 * Used to identify a person by an identifier that may be a legacy YEI or Pulse id.
 * Accepted only at positions whose callers still send legacy ids. New APIs must use
 * PersonIdentityInput. Mobile apps hardcode this type name in shipped queries.
 */
export interface LegacyPersonIdentityInput {
  /** provider */
  provider: LegacyPersonIdentityProvider;
  /** identifier of their account */
  key: Scalars['String']['input'];
}

/** Nullable to support delete operations. e.g.: Update my manager to null. */
export interface NullablePersonIdentityInput {
  provider: PersonIdentityProvider;
  key?: InputMaybe<Scalars['String']['input']>;
}

/** Legacy variant of NullablePersonIdentityInput. Accepts legacy YEI and Pulse ids. */
export interface LegacyNullablePersonIdentityInput {
  provider: LegacyPersonIdentityProvider;
  key?: InputMaybe<Scalars['String']['input']>;
}

/** Used to identify Departments, Locations, and Groups. Does not accept legacy ids; see LegacyEntityIdentifierType. */
export type EntityIdentifierType =
  /** client-provided key */
  | 'EXTERNAL'
  /** globally unique, kazoo-generated id */
  | 'KAZOO_ID';

/**
 * Used to identify Departments, Locations, and Groups by an identifier that may be a
 * legacy YEI id. Accepted only at positions whose callers still send legacy ids. New
 * APIs must use EntityIdentifierType.
 */
export type LegacyEntityIdentifierType =
  /** client-provided key */
  | 'EXTERNAL'
  /** globally unique, kazoo-generated id */
  | 'KAZOO_ID'
  /** YEI */
  | 'LEGACY_YEI_ID';

/** Identifies an entity like a Location, Group, or Department.  Nullable for use in delete operations like 'set my department to null'. */
export interface NullableEntityIdentifierInput {
  type: EntityIdentifierType;
  key?: InputMaybe<Scalars['String']['input']>;
}

/** Legacy variant of NullableEntityIdentifierInput. Accepts legacy YEI ids. */
export interface LegacyNullableEntityIdentifierInput {
  type: LegacyEntityIdentifierType;
  key?: InputMaybe<Scalars['String']['input']>;
}

/** Identifies an entity like a Location, Group, or Department. Does not accept legacy ids; see LegacyEntityIdentifierInput. */
export interface EntityIdentifierInput {
  type: EntityIdentifierType;
  key: Scalars['String']['input'];
}

/** Legacy variant of EntityIdentifierInput. Accepts legacy YEI ids. */
export interface LegacyEntityIdentifierInput {
  type: LegacyEntityIdentifierType;
  key: Scalars['String']['input'];
}

/** creates or updates a person record, typically from HRIS import. */
export interface CreateOrUpdatePersonInput {
  /**
   * client generated id for this update.  Ensures this update succeeds once and only once.
   * @deprecated This input is ignored.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional id for correlating bulk operations.  If provided, these are aggregated on the Batch entity. */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** Optional ordinal value for bulk opertions.  Useful for sorting the results of batch operations. */
  batchSequence?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Identifies the user to be created or updated.
   * Providing a null value for this field will create a new Person, though you _must_
   * provide at least one identity that matches the company identity provider in the
   * `identitiesToAdd` field.
   */
  identifier?: InputMaybe<LegacyPersonIdentityInput>;
  /** array of provider/key pairs to add */
  identitiesToAdd?: InputMaybe<Array<LegacyPersonIdentityInput>>;
  /** array of provider strings to remove */
  identitiesToRemove?: InputMaybe<Array<LegacyPersonIdentityProvider>>;
  /** Most people have a manager. */
  manager?: InputMaybe<LegacyNullablePersonIdentityInput>;
  /** Overwrites the existing list of groups with this list.  Empty if [].  No op for null.  Use in place of groupsToAdd/groupsToRemove */
  groups?: InputMaybe<Array<LegacyEntityIdentifierInput>>;
  /** These are all group memberships that are not department, title, or location, e.g. 2019 Interns or Team Bravo. */
  groupsToAdd?: InputMaybe<Array<EntityIdentifierInput>>;
  /** These are all group memberships that are not department, title, or location, e.g. 2019 Interns or Team Bravo. */
  groupsToRemove?: InputMaybe<Array<EntityIdentifierInput>>;
  /** Add this person to these security roles */
  rolesToAdd?: InputMaybe<Array<Role>>;
  /** Remove this person from these security roles */
  rolesToRemove?: InputMaybe<Array<Role>>;
  /** Set the roles on this person to these.  Invalid with either rolesToAdd or rolesToRemove. */
  roles?: InputMaybe<Array<Role>>;
  /** e.g. IT_HLP.  If key is null, we remove them from the department. */
  department?: InputMaybe<LegacyNullableEntityIdentifierInput>;
  /** This can be as granular as desired. E.g. US, or Chicago, or 363 W Erie.  If key is null, we remove them from the location. */
  location?: InputMaybe<LegacyNullableEntityIdentifierInput>;
  /** e.g. Customer Service Representative II. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Person's name. See NameInput for details. */
  name?: InputMaybe<NameInput>;
  /** Supports firstName and lastName. */
  legacyNameInput?: InputMaybe<LegacyNameInput>;
  /** person's country code. e.g. US, CA, MX, etc. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** If provided, and null, we set the current value to default. */
  avatar?: InputMaybe<ImageInput>;
  /** Employee bio, statement of purpose, shocking facts, pets, etc. */
  aboutMe?: InputMaybe<Scalars['String']['input']>;
  /** ISO 639-1 ISO 3316-1 language code e.g. en-US, es-MX */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 date only (e.g. YYYY-MM-DDTHH:MM:SSZ). Used for tracking anniversaries. */
  employmentStartDate?: InputMaybe<Scalars['StrictDateTimeInput']['input']>;
  /** month and year only */
  birthday?: InputMaybe<MonthDayInput>;
  /** ISO-8601 date only (e.g. YYYY-MM-DDTHH:MM:SSZ). Updating DOB will also update birthday. */
  dateOfBirth?: InputMaybe<Scalars['StrictDateTimeInput']['input']>;
  /** month and year only */
  workAnniversary?: InputMaybe<MonthDayInput>;
  /**
   * Active or archived.  If null, a no-op
   * Changing the status of someone to ARCHIVE does not delete any of their relationships with any other table/entity
   */
  status?: InputMaybe<PersonStatus>;
  /**
   * person's email
   * @deprecated Pass this in in the identitiesToAdd array
   */
  email?: InputMaybe<Scalars['String']['input']>;
  /** showBirthday, showAnniversary belong to on user profile */
  profileSettings?: InputMaybe<ProfileSettingsInput>;
  /** When true, this person is exempt from being auto-archived through directory ingestion/import operations. */
  exemptFromAutoArchive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use this field to request directory to perform tasks after the User has been created or Updated. Refer the documentation on each enum values for more details. */
  followupTasks?: InputMaybe<Array<InputMaybe<CrudPersonFollowupTasks>>>;
  /** Person that has access to conditionally review the modules of the users they 'Coach' or 'Manage' */
  secondaryManager?: InputMaybe<NullablePersonIdentityInput>;
  /** If provided, overwrites the existing custom attributes with this list.  To remove an attribute, set 'archiveMissing' to true and only pass the attributes you intend to keep.  Or pass "" for the value. */
  customAttributes?: InputMaybe<CustomAttributeValuesInput>;
  options?: InputMaybe<CreateOrUpdatePersonOptionsInput>;
  /** The people that this person assists. Assistants can take certain actions on behalf of the person they assist. */
  assists?: InputMaybe<Array<PersonIdentityInput>>;
  /** Phone numbers for the person. If not provided, the person's existing phone numbers will be used. If empty array, all phone numbers will be removed. */
  phoneNumbers?: InputMaybe<Array<PhoneNumberInput>>;
  /** Transfer direct reports when this person is archived. */
  transferDirectReportsOnArchive?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface PhoneNumberInput {
  type: PersonPhoneNumberType;
  /** The raw phone number string, e.g. +12345678901 */
  raw: Scalars['String']['input'];
  /** Whether this is the default phone number for the person */
  isDefault: Scalars['Boolean']['input'];
}

export interface CreateOrUpdatePersonOptionsInput {
  /** If true, we do not create a person.  Used in scenarios where we do bulk operations and want to ONLY update. */
  onlyCreateIfStatusIn?: InputMaybe<Array<PersonStatus>>;
  /** Skips adding or changing the manager if the new manager does not exist. */
  skipManagerIfNotFound?: InputMaybe<Scalars['Boolean']['input']>;
  /** Skips adding or changing the secondary manager if the new manager does not exist. */
  skipSecondaryManagerIfNotFound?: InputMaybe<Scalars['Boolean']['input']>;
  /** converts bad email input like ali ce@acme.com to alice@acme.com */
  closeUpSpacesInEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, it creates/updates the person without the avatar if the avatar service is unavailable. */
  warnOnAvatarProblems?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, it creates/updates the person without the phone numbers if the phone number service is not a valid E.164 number. */
  skipInvalidPhoneNumbers?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface CreateOrUpdateDepartmentInput {
  /**
   * client generated id for this update.  Ensures this update succeeds once and only once.
   * @deprecated This input is ignored.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional id for correlating bulk operations.  If provided, these are aggregated on the Batch entity. */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** Optional ordinal value for bulk opertions.  Useful for sorting the results of batch operations. */
  batchSequence?: InputMaybe<Scalars['Int']['input']>;
  /** attempts an insert operation if not provided */
  identifier: LegacyEntityIdentifierInput;
  name?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<LegacyNullableEntityIdentifierInput>;
  /** @deprecated active is deprecated. Use status instead */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DepartmentLocationGroupStatus>;
  /** Overwrites the existing list of administrators with this list.  Empty if [].  No op for null. */
  administrators?: InputMaybe<Array<LegacyPersonIdentityInput>>;
  /** Adds these administrators. */
  administratorsToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these administrators. */
  administratorsToRemove?: InputMaybe<Array<PersonIdentityInput>>;
  /** Overwrites the existing list of owners with this list.  Empty if [].  No op for null. */
  owners?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these owners. */
  ownersToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these owners. */
  ownersToRemove?: InputMaybe<Array<PersonIdentityInput>>;
  legacyRrId?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateOrUpdateLocationInput {
  /**
   * client generated id for this update.  Ensures this update succeeds once and only once.
   * @deprecated This input is ignored.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional id for correlating bulk operations.  If provided, these are aggregated on the Batch entity. */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** Optional ordinal value for bulk opertions.  Useful for sorting the results of batch operations. */
  batchSequence?: InputMaybe<Scalars['Int']['input']>;
  /** attempts an insert operation if not provided */
  identifier: LegacyEntityIdentifierInput;
  name?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<LegacyNullableEntityIdentifierInput>;
  /** @deprecated active is deprecated. Use status instead */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DepartmentLocationGroupStatus>;
  legacyRrId?: InputMaybe<Scalars['String']['input']>;
  /** Overwrites the existing list of administrators with this list.  Empty if [].  No op for null. */
  administrators?: InputMaybe<Array<LegacyPersonIdentityInput>>;
  /** Adds these administrators. */
  administratorsToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these administrators. */
  administratorsToRemove?: InputMaybe<Array<PersonIdentityInput>>;
  /** Overwrites the existing list of owners with this list.  Empty if [].  No op for null. */
  owners?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these owners. */
  ownersToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these owners. */
  ownersToRemove?: InputMaybe<Array<PersonIdentityInput>>;
}

export interface CreateOrUpdateGroupInput {
  /**
   * client generated id for this update.  Ensures this update succeeds once and only once.
   * @deprecated This input is ignored.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional id for correlating bulk operations.  If provided, these are aggregated on the Batch entity. */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** Optional ordinal value for bulk opertions.  Useful for sorting the results of batch operations. */
  batchSequence?: InputMaybe<Scalars['Int']['input']>;
  /** attempts an insert operation if not provided */
  identifier: LegacyEntityIdentifierInput;
  /** legacy platform identifier */
  legacyRrId?: InputMaybe<Scalars['String']['input']>;
  /** YEI group type identifier */
  legacyRrGroupTypeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Group creation defaults to type AFFINITY. Any change to GroupType cascades to the Group's children. One may not change a child Group's GroupType directly. */
  type?: InputMaybe<GroupType>;
  key?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<LegacyNullableEntityIdentifierInput>;
  /** @deprecated active is deprecated. Use status instead */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<DepartmentLocationGroupStatus>;
  /** Overwrites the existing list of administrators with this list.  Empty if [].  No op for null. */
  administrators?: InputMaybe<Array<LegacyPersonIdentityInput>>;
  /** Adds these administrators. */
  administratorsToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these administrators. */
  administratorsToRemove?: InputMaybe<Array<PersonIdentityInput>>;
  /** Overwrites the existing list of owners with this list.  Empty if [].  No op for null. */
  owners?: InputMaybe<Array<PersonIdentityInput>>;
  /** Adds these owners. */
  ownersToAdd?: InputMaybe<Array<PersonIdentityInput>>;
  /** Removes these owners. */
  ownersToRemove?: InputMaybe<Array<PersonIdentityInput>>;
}

export type GroupType =
  /** e.g. Intern Class of 2014, front-end developers */
  | 'AFFINITY'
  /** Does not appear for non-admins.  Typically used for things like CostCenter that is meaningless for end users. */
  | 'PRIVATE';

/** Allows us to attach custom attributes to a person */
export interface CustomAttributeValuesInput {
  archiveMissing?: InputMaybe<Scalars['Boolean']['input']>;
  values: Array<CustomAttributeValueInput>;
}

/** name and value of a custom attribute */
export interface CustomAttributeValueInput {
  /** Canonical name of this custom field.  If it doesn't exist, we throw a UserInputError. */
  name: Scalars['String']['input'];
  /**
   * We pass the value in as a string and parse it at runtime.
   * Passing invalid input, e.g. 'foo' for an number field will throw UserInputError.
   * Passing null removes the custom field from the Person.
   */
  value?: InputMaybe<Scalars['String']['input']>;
  /**
   * We do not make DB updates that are no-ops, but for tracking the system activity feature,
   * product would like us to track when we last successfully fetched and attempted to update
   * system attributes, regardless of if the actual data was a no-op.
   */
  syncedFromWarehouseAt?: InputMaybe<Scalars['Date']['input']>;
}

export type CrudPersonFollowupTasks =
  /** Sends email notification once user is activated whether or not they are new. */
  | 'REQUEST_ACCOUNT_ACTIVATION'
  /** Sends email notification once user is activated but only for newly created people. */
  | 'REQUEST_ACCOUNT_ACTIVATION_IF_NEW';

export interface ProfileSettingsInput {
  /** Display birthday on user profile */
  showBirthday?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display start date on user profile */
  showAnniversary?: InputMaybe<Scalars['Boolean']['input']>;
}

export type PersonStatus =
  /** They are an active Kazoo user. */
  | 'ACTIVE'
  /** They have been deleted. */
  | 'ARCHIVED'
  /** They cannot login or be a participant, but their points remain. */
  | 'PAUSED'
  /** records anonymized/deleted for GDPR-type scenarios */
  | 'PURGED';

export type DepartmentLocationGroupStatus =
  | 'ACTIVE'
  /** The department, location, or group has been deleted, but can be resurrected */
  | 'ARCHIVED'
  /** Records deleted and no longer recoverable by users */
  | 'DELETED';

export type ImageInputType =
  | 'BYTES_BASE_64'
  | 'NULLIFY'
  | 'URL';

export interface ImageInput {
  type?: InputMaybe<ImageInputType>;
  payload: Scalars['String']['input'];
  /** Should the software automatically center the user's face? */
  autoFocus?: InputMaybe<Scalars['Boolean']['input']>;
  /** When true, the main Person updates will happen as normal but the avatar upload will happen asynchronously as a task. Only supports URL avatars. For use in batches. */
  performAsync?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Setting any of these to null ignores the input.  Setting to empty string clears it. */
export interface NameInput {
  preferredName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
}

/** Support legacy name concepts. */
export interface LegacyNameInput {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}

/** These are used when mapping Kazoo Person fields to Pulse. */
export type KazooField =
  | 'COUNTRY'
  | 'DATE_OF_BIRTH'
  | 'DEPARTMENT'
  | 'EMAIL'
  | 'EMPLOYEE_ID'
  | 'EMPLOYMENT_START_DATE'
  | 'FIRST_NAME'
  | 'JOB_TITLE'
  | 'LAST_NAME'
  | 'LOCATION'
  | 'MANAGER'
  | 'PARENT_DEPARTMENT'
  | 'PARENT_LOCATION'
  | 'PERSONAL_PHONE_NUMBER'
  | 'PREFERRED_NAME'
  | 'WORK_PHONE_NUMBER';

export interface ArchivePeopleNotInBatchInput {
  batchId: Scalars['String']['input'];
}

export type PersonPhoneNumberType =
  | 'PERSONAL'
  | 'WORK';

/** Only the fields passed through will be updated in the database. */
export interface CreateOrUpdateGoalInput {
  /** ID of the goal to update. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** User supplied unique key. Immutable */
  externalKey?: InputMaybe<Scalars['String']['input']>;
  /** If provided, associates this update with a batch. */
  batchId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** There aren't huge differences in the goal data depending on the type, so it's perfectly fine to change the goal's type on the fly. */
  type?: InputMaybe<GoalType>;
  /** Updates existing measurable results attached to the goal. */
  measurableResults?: InputMaybe<Array<UpdateMeasurableResultFromGoalInput>>;
  riskStatus?: InputMaybe<GoalRiskStatus>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Defaults to PUBLIC */
  privacy?: InputMaybe<GoalPrivacy>;
  /** ID of the goal this goal aligns to. */
  parentGoalId?: InputMaybe<Scalars['ID']['input']>;
  /** External key of the goal that this goal aligns to.  If parentGoalId is provided, this is ignored. */
  parentGoalExternalKey?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<GoalStatus>;
  /** Reason why the Goal will be closed */
  closeReason?: InputMaybe<Scalars['String']['input']>;
  /** If the Goal will be closed, is it completed? */
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the department to which the Goal will be linked */
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  /** Identifier of the of the department using directory-style inputs.  If departmentId is provided, this is ignored. */
  departmentIdentifier?: InputMaybe<EntityIdentifierInput>;
  /** IDs of the collaborators of the Goal. If this is an empty array, that indicates remove all collaborators. Undefined means no op. */
  collaboratorsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Identifiers of the of the collaborators using directory-style inputs. If this is an empty array, that indicates remove all collaborators. Undefined means no op. If collaboratorIds is provided, this is ignored. */
  collaboratorsIdentifiers?: InputMaybe<Array<PersonIdentityInput>>;
  /** Owner ID, only updates on Orphaned Goals */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Identifier of the owner using directory-stlye inputs.  If ownerId is provided, this is ignored. */
  ownerIdentifier?: InputMaybe<PersonIdentityInput>;
  /** ID of category this Goal aligns to. */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the category that this goal aligns to.  If categoryId is provided, this is ignored. */
  categoryName?: InputMaybe<Scalars['String']['input']>;
  /** optional comment */
  comment?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateMeasurableResultFromGoalInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MeasurableResultType>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
}

export type MeasurableResultType =
  | 'BOOLEAN'
  | 'NUMERIC'
  | 'PERCENT';

export type GoalType =
  | 'COMPANY'
  | 'DEPARTMENT'
  | 'INDIVIDUAL';

export type GoalStatus =
  | 'AWAITING_APPROVAL'
  | 'AWAITING_CLOSURE'
  | 'CLOSED'
  | 'DRAFT'
  | 'IN_PROGRESS'
  | 'OVERDUE';

export type GoalRiskStatus =
  | 'AT_RISK'
  | 'BEHIND'
  | 'ON_TRACK';

export type GoalPrivacy =
  | 'PRIVATE'
  | 'PUBLIC';

export interface AssignPointRuleInput {
  /**
   * Optional identifier for grouping this operation into a batch.
   *
   * If provided, we will look up the person and if they were created in the same batch, we will apply the point rule (if the point rule is to be applied on new person input).
   */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** The identifier of the point rule. */
  pointRuleIdentifier: PointRuleIdentifier;
  /** The id of the person. */
  personIdentifier: PersonIdentityInput;
  personOptions?: InputMaybe<PersonPointOperationOptions>;
}

export interface PersonPointOperationOptions {
  /** If the person cannot be found, we suppress the error.  Used in 'do not create inactive people' scenarios. */
  suppressErrorForPersonNotFound?: InputMaybe<Scalars['Boolean']['input']>;
  /** We only ever apply point rules on assignment if we are also creating the person. At this time, its only possible to create and assign a point rule at the same time via batches. The default here is false, and batches will specify true. */
  applyPointRuleOnAssignment?: InputMaybe<Scalars['Boolean']['input']>;
}

export type PointRuleIdentifierType =
  | 'KAZOO_ID'
  | 'NAME';

export interface PointRuleIdentifier {
  type: PointRuleIdentifierType;
  /** If null, we remove the point rule from the person. */
  key?: InputMaybe<Scalars['String']['input']>;
}

export type PointBalanceAccount =
  | 'GIVING'
  | 'REDEMPTION';

export interface PointBalanceInput {
  /** Optional identifier for grouping this operation into a batch. */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** The owner of the point balance to adjust. */
  personIdentifier: PersonIdentityInput;
  /** A globally unique client key that guarantees the points are adjusted only once. */
  idempotencyKey: Scalars['ID']['input'];
  /** Which user account should be adjusted? */
  account: PointBalanceAccount;
  /** The positive or negative number of points to transact. Only use if absolutely necessary. */
  points: Scalars['Int']['input'];
  /** If true, the operation will be executed synchronously. */
  synchronouslyApplyAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * An event identifier related to the adjustment for audit purposes.
   *
   * Example: `Incentive:Claimed:123`
   */
  eventId: Scalars['String']['input'];
  personOptions?: InputMaybe<PersonPointOperationOptions>;
}

export type PointRuleApplicationReason =
  | 'ADMINISTRATIVE_OVERRIDE'
  | 'PERIODIC_REFRESH'
  | 'PERSON_CREATED';

export interface RefreshPointsInput {
  personId: Scalars['ID']['input'];
  /** If not provided, it executes the built in point rules for the company */
  pointRuleId?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey: Scalars['String']['input'];
  batchId: Scalars['ID']['input'];
  pointRefreshRunId: Scalars['ID']['input'];
  /** If true, the operation will not actually execute. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface RecognitionIdentifierInput {
  id: Scalars['String']['input'];
}

export interface RecipientsSearchOptionsInput {
  namePartial: Scalars['String']['input'];
}

export interface ConfigureRecognitionGiphySettingsInput {
  enabled: Scalars['Boolean']['input'];
  rating?: InputMaybe<GiphyContentRating>;
  defaultSearchTerm?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateOrUpdateRecognitionInput {
  /** The ID of the Recognition for updating. Can be a KW Recognition ID or YEI Recognition ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** For robots to send Recognition on behalf of a user. Request will fail for non-robots */
  senderIdentifier?: InputMaybe<RecognitionSenderInput>;
  /**
   * The content of the Recognition. Legacy, only supports plain text. Use richTextBody for rich text content (which allows you to specify the content in any format).
   * @deprecated Field no longer supported
   */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The content of the Recognition. */
  richTextBody?: InputMaybe<RichTextContentInput>;
  /**
   * Recipients must be identified by `KAZOO_ID`. When `source` is `UPLOAD`, recipients may also use `EMAIL` or `EMPLOYEE_ID`
   * identity providers; the mutation will resolve them to `KAZOO_ID` before saving.
   */
  recipients?: InputMaybe<Array<RecipientInput>>;
  /** Core Value is provided as its actual text value rather than ID. It will be looked up by workspace + name */
  coreValueName?: InputMaybe<Scalars['String']['input']>;
  /** Skills are sent as a list of their string names. */
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Indicates the privacy of the Recognition. */
  public?: Scalars['Boolean']['input'];
  /** Request will fail for companies which force zero-point recognitions */
  points?: InputMaybe<PointsInput>;
  /**
   * Unique ID that prevents a Recognition from being processed more than once. When in doubt, use a UUID."
   * Required for create operations and will be disregarded on edit operations.
   */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** ID of the batch to which this recognition belongs. This is used for bulk recognitions. */
  batchId?: InputMaybe<Scalars['String']['input']>;
  /** The type of recognition to send */
  recognitionType?: InputMaybe<RecognitionType>;
  /** The source of the recognition */
  source?: InputMaybe<RecognitionSource>;
  /** Whether the user accepted the AI writer's recommendation */
  acceptedAIRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
  /** ImageUpload IDs that were uploaded in association with this Recognition. An empty array will remove all images. */
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  background?: InputMaybe<RecognitionBackground>;
}

export interface RecognitionSenderInput {
  provider: RecognitionSenderIdentityProvider;
  key?: InputMaybe<Scalars['String']['input']>;
}

export interface RecipientInput {
  type: RecipientType;
  identifier: RecipientIdentifierInput;
}

export interface RecipientIdentifierInput {
  key: Scalars['String']['input'];
  provider: RecognitionIdentityProvider;
}

export interface PointsInput {
  type: PointsType;
  amount: Scalars['Int']['input'];
  tokenId?: InputMaybe<Scalars['String']['input']>;
  nonTaxable?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface PointsPayload {
  __typename?: 'PointsPayload';
  type: PointsType;
  amount: Scalars['Int']['output'];
  /** For SPECIAL_CATALOG_TOKEN type, the token ID to be used for the recognition */
  tokenId?: Maybe<Scalars['String']['output']>;
  nonTaxable: Scalars['Boolean']['output'];
}

export type RecipientType =
  | 'PERSON';

export type PointsType =
  | 'POINTS'
  | 'SPECIAL_CATALOG_TOKENS';

export type GiphyContentRating =
  | 'G'
  | 'PG'
  | 'PG13';

export type RecognitionIdentityProvider =
  | 'KAZOO_ID'
  | 'EMAIL'
  | 'EMPLOYEE_ID';

export type RecognitionPrivacy =
  | 'PRIVATE'
  | 'PUBLIC';

export type RecognitionRole =
  | 'RECIPIENT'
  | 'SENDER';

export type RecognitionType =
  /** A bulk recognition sent to multiple recipients by an admin */
  | 'BULK_RECOGNITION'
  /** An automated birthday or work anniversary recognition sent by the system */
  | 'MILESTONE_RECOGNITION'
  /** A standard peer-to-peer recognition */
  | 'PEER_TO_PEER_RECOGNITION'
  /** An ad-hoc special recognition sent by an admin on behalf of the company */
  | 'SPECIAL_RECOGNITION';

export type RecognitionSenderIdentityProvider =
  | 'KAZOO_ID'
  | 'SYSTEM';

export type RecognitionSource =
  | 'ANDROID'
  | 'IOS'
  | 'SLACK'
  | 'WEB_BULK_RECOGNITION'
  | 'WEB_DASHBOARD'
  | 'WEB_OTHER'
  | 'WEB_PROFILE'
  | 'UPLOAD';

export interface RecognitionEvent {
  __typename?: 'RecognitionEvent';
  /** The ID of the Recognition as it lives in the database */
  aggregateId: Scalars['ID']['output'];
  aggregateType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
}

export type RecognitionBackground =
  | 'BALLOONS'
  | 'CHAMPAGNE'
  | 'FEATHER'
  | 'FIREWORKS'
  | 'LEAVES'
  | 'NEON'
  | 'PRIMARY_BRANDING'
  | 'SECONDARY_BRANDING'
  | 'SIDING'
  | 'SPRINKLES'
  | 'STARS'
  | 'SUNSET'
  | 'TEDDY_BEAR'
  | 'WAVES'
  | 'WINTER_TREES'
  | 'CHALK_BURST'
  | 'FIREWORKS_SMALL'
  | 'GOLD_STARS'
  | 'LAZER_PRISM'
  | 'CONFETTI';

export interface MigrateIncentivesEntityInput {
  /** The type of the legacy entity to migrate */
  type: MigratableIncentivesEntity;
  /** The MongoDB ObjectID of the legacy entity */
  legacyId: Scalars['ID']['input'];
  /** The ID of the IncentivesMigrationBatch that this migration belongs to */
  batchId: Scalars['ID']['input'];
  /** If true, the provided legacy data will not be persisted. */
  dryRun?: Scalars['Boolean']['input'];
}

export type MigratableIncentivesEntity =
  | 'ITEM'
  | 'ITEM_ORDER';

export interface CreateWorkOsUserFromKwPersonInput {
  personId: Scalars['ID']['input'];
  batchId?: InputMaybe<Scalars['String']['input']>;
}

export type AbandonQuestionMutationVariables = Exact<{
  input: AbandonQuestionInput;
}>;


export type AbandonQuestionMutation = { __typename?: 'Mutation', abandonQuestion: { __typename?: 'AbandonQuestionPayload', success: boolean } };

export type AnswerBooleanQuestionMutationVariables = Exact<{
  input: AnswerBooleanQuestionInput;
}>;


export type AnswerBooleanQuestionMutation = { __typename?: 'Mutation', answerBooleanQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type AnswerMultipleChoiceQuestionMutationVariables = Exact<{
  input: AnswerMultipleChoiceQuestionInput;
}>;


export type AnswerMultipleChoiceQuestionMutation = { __typename?: 'Mutation', answerMultipleChoiceQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type AnswerRankingQuestionMutationVariables = Exact<{
  input: AnswerRankingQuestionInput;
}>;


export type AnswerRankingQuestionMutation = { __typename?: 'Mutation', answerRankingQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type AnswerRatingScaleQuestionMutationVariables = Exact<{
  input: AnswerRatingScaleQuestionInput;
}>;


export type AnswerRatingScaleQuestionMutation = { __typename?: 'Mutation', answerRatingScaleQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type AnswerSolutionQuestionMutationVariables = Exact<{
  input: AnswerSolutionQuestionInput;
}>;


export type AnswerSolutionQuestionMutation = { __typename?: 'Mutation', answerSolutionQuestion: { __typename?: 'AnswerSolutionQuestionPayload', solutionSessionId: string, questionsAnswered: number, isComplete: boolean, nextQuestion?: { __typename?: 'Question', id: string, content:
        | { __typename?: 'MultipleChoiceQuestionContent' }
        | { __typename?: 'TextQuestionContent', question: string }
        | { __typename?: 'BooleanQuestionContent' }
        | { __typename?: 'RankingQuestionContent' }
        | { __typename?: 'RatingScaleQuestionContent' }
       } | undefined } };

export type AnswerTextQuestionMutationVariables = Exact<{
  input: AnswerTextQuestionInput;
}>;


export type AnswerTextQuestionMutation = { __typename?: 'Mutation', answerTextQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type ApplicationStateQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationStateQuery = { __typename?: 'Query', applicationState: { __typename?: 'ApplicationState', maintenanceModeEnabled: boolean } };

export type ArchiveOrganizationMutationVariables = Exact<{
  input: ArchiveOrganizationInput;
}>;


export type ArchiveOrganizationMutation = { __typename?: 'Mutation', archiveOrganization: { __typename?: 'ArchiveOrganizationPayload', organization: { __typename?: 'Organization', id: string, name: string, status: OrganizationStatus, archivedAt?: any | undefined } } };

export type ArchiveSessionAttributeTemplateMutationVariables = Exact<{
  input: ArchiveSessionAttributeTemplateInput;
}>;


export type ArchiveSessionAttributeTemplateMutation = { __typename?: 'Mutation', archiveSessionAttributeTemplate: { __typename?: 'ArchiveSessionAttributeTemplatePayload', sessionAttributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string>, archived: boolean, createdAt: any } } };

export type ArchiveUserMutationVariables = Exact<{
  input: ArchiveUserInput;
}>;


export type ArchiveUserMutation = { __typename?: 'Mutation', archiveUser: { __typename?: 'ArchiveUserPayload', user: { __typename?: 'User', id: string, status?: UserStatus | undefined } } };

export type AssignTopicOwnershipMutationVariables = Exact<{
  input: AssignTopicOwnershipInput;
}>;


export type AssignTopicOwnershipMutation = { __typename?: 'Mutation', assignTopicOwnership: { __typename?: 'AssignTopicOwnershipPayload', topicAssignment: { __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }, idea:
      | { __typename?: 'Issue', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }
      | { __typename?: 'Opportunity', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }
      | { __typename?: 'Praise', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }
     } };

export type AssignVelocityIssueOwnershipMutationVariables = Exact<{
  input: AssignVelocityIssueOwnershipInput;
}>;


export type AssignVelocityIssueOwnershipMutation = { __typename?: 'Mutation', assignVelocityIssueOwnership: { __typename?: 'AssignVelocityIssueOwnershipPayload', assignment: { __typename?: 'VelocityIssueAssignment', id: string, email: string, createdAt: any }, issue: { __typename?: 'VelocityIssue', id: string, assignments: Array<{ __typename?: 'VelocityIssueAssignment', id: string, email: string, createdAt: any }> } } };

export type BubbleGraphDataQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  selectedForSolutioningOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BubbleGraphDataQuery = { __typename?: 'Query', sessionInsights: { __typename?: 'SessionInsightsResult', sessionInsights?: { __typename?: 'SessionInsights', participantCount: number, issues: Array<{ __typename?: 'Issue', id: string, name: string, description: string, summary?: string | undefined, score: number, myVote?: VoteType | undefined, mySolutionStatus: SolutionStatus, linkedParticipantIds: Array<string> }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, description: string, summary?: string | undefined, score: number, myVote?: VoteType | undefined, mySolutionStatus: SolutionStatus, linkedParticipantIds: Array<string> }>, praise: Array<{ __typename?: 'Praise', id: string, name: string, description: string, summary?: string | undefined, score: number, myVote?: VoteType | undefined, linkedParticipantIds: Array<string> }>, implementations: Array<{ __typename?: 'Implementation', id: string, name: string, description: string, summary?: string | undefined, score: number, linkedIssueIds: Array<string>, linkedOpportunityIds: Array<string>, linkedPraiseIds: Array<string>, myVote?: VoteType | undefined, submittedByMe: boolean }> } | undefined } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'CreateOrganizationPayload', organization: { __typename?: 'Organization', id: string, name: string } } };

export type CreateSessionMutationVariables = Exact<{
  input: CreateSessionInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'CreateSessionPayload', session?: { __typename?: 'Session', id: string, title: string, type: string, description?: string | undefined, status: SessionStatus, createdAt: any, focus?: string | undefined, defaultQuestions: Array<string>, requireDefaultQuestions: boolean, allowExperimentalFactorQuestions: boolean, identificationMode: IdentificationMode, insightsVisibility: InsightsVisibility, velocityEngineType?: string | undefined, activeFactorCodes?: Array<string> | undefined, activeReportingFactorCodes?: Array<string> | undefined, selectedAttributes: Array<{ __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string> }> } | undefined } };

export type CreateSessionAttributeTemplateMutationVariables = Exact<{
  input: CreateSessionAttributeTemplateInput;
}>;


export type CreateSessionAttributeTemplateMutation = { __typename?: 'Mutation', createSessionAttributeTemplate: { __typename?: 'CreateSessionAttributeTemplatePayload', sessionAttributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string>, archived: boolean, createdAt: any } } };

export type DuplicateSessionMutationVariables = Exact<{
  input: DuplicateSessionInput;
}>;


export type DuplicateSessionMutation = { __typename?: 'Mutation', duplicateSession: { __typename?: 'DuplicateSessionPayload', session?: { __typename?: 'Session', id: string, title: string, type: string, description?: string | undefined, status: SessionStatus, createdAt: any, focus?: string | undefined, defaultQuestions: Array<string>, requireDefaultQuestions: boolean, length: number } | undefined } };

export type EndSessionMutationVariables = Exact<{
  input: EndSessionInput;
}>;


export type EndSessionMutation = { __typename?: 'Mutation', endSession: { __typename?: 'EndSessionPayload', session?: { __typename?: 'Session', id: string, expiresAt?: any | undefined, status: SessionStatus } | undefined } };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, isPlatformAdmin?: boolean | undefined, source: string, locale?: string | undefined, organizationOverridden?: boolean | undefined, status?: UserStatus | undefined, organization?: { __typename?: 'Organization', id: string, name: string } | undefined, featureFlags?: { __typename?: 'UserFeatureFlags', velocityBetaSessionTypes: boolean, velocityExperimentalFeatures: boolean, worktangoRoadmapPage: boolean } | undefined, organizationMemberships: Array<{ __typename?: 'UserOrganization', id: string, role: UserOrganizationRole, organization: { __typename?: 'Organization', id: string, name: string } }>, impersonator?: { __typename?: 'ImpersonatorInfo', id: string, name: string } | undefined } | undefined };

export type GetNextSolutionQuestionQueryVariables = Exact<{
  solutionSessionId: Scalars['ID']['input'];
}>;


export type GetNextSolutionQuestionQuery = { __typename?: 'Query', nextSolutionQuestion?: { __typename?: 'Question', id: string, content:
      | { __typename?: 'MultipleChoiceQuestionContent' }
      | { __typename?: 'TextQuestionContent', question: string }
      | { __typename?: 'BooleanQuestionContent' }
      | { __typename?: 'RankingQuestionContent' }
      | { __typename?: 'RatingScaleQuestionContent' }
     } | undefined };

export type GetOrganizationUsersQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationUsersFilterInput>;
  sort?: InputMaybe<Array<OrganizationUsersSortInput> | OrganizationUsersSortInput>;
}>;


export type GetOrganizationUsersQuery = { __typename?: 'Query', organizationUsers: { __typename?: 'UsersConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | undefined, endCursor?: string | undefined }, edges: Array<{ __typename?: 'UsersEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, source: string, isPlatformAdmin?: boolean | undefined, status?: UserStatus | undefined, createdAt: any, organizationMemberships: Array<{ __typename?: 'UserOrganization', role: UserOrganizationRole, organization: { __typename?: 'Organization', id: string, name: string } }> } }> } };

export type GetOrganizationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrganizationsFilterInput>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationsConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean }, edges: Array<{ __typename?: 'OrganizationsEdge', cursor: string, node: { __typename?: 'Organization', id: string, name: string, createdAt: any, userCount: number, status: OrganizationStatus } }> } };

export type GetParticipantQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
}>;


export type GetParticipantQuery = { __typename?: 'Query', participant?: { __typename?: 'Participant', id: string, name: string, title: string } | undefined };

export type GetParticipantAnswersQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  participantId: Scalars['String']['input'];
}>;


export type GetParticipantAnswersQuery = { __typename?: 'Query', participantAnswers: Array<{ __typename?: 'Question', id: string, answer?: string | undefined, answeredAt?: any | undefined, content:
      | { __typename?: 'MultipleChoiceQuestionContent', question: string, multipleChoiceOptions: Array<string> }
      | { __typename?: 'TextQuestionContent', question: string }
      | { __typename?: 'BooleanQuestionContent', question: string }
      | { __typename?: 'RankingQuestionContent', question: string }
      | { __typename?: 'RatingScaleQuestionContent', question: string }
     }> };

export type GetParticipantFactorScoresQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
}>;


export type GetParticipantFactorScoresQuery = { __typename?: 'Query', participant?: { __typename?: 'Participant', id: string, name: string, title: string, factorScores: Array<{ __typename?: 'ParticipantFactorScore', id: string, factorCode: string, factorName: string, sentiment: FactorSentiment, sentimentLabel: string, summary?: string | undefined }> } | undefined };

export type GetSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, title: string, description?: string | undefined, status: SessionStatus, expiresAt?: any | undefined, startedAt?: any | undefined, sessionTimeRemaining?: number | undefined, sectionTimeRemaining?: number | undefined, length: number, section?: SessionSectionType | undefined, createdAt: any, solutioningTopicsSelectedAt?: any | undefined, type: string, velocityEngineType?: string | undefined, activeFactorCodes?: Array<string> | undefined, activeReportingFactorCodes?: Array<string> | undefined, focus?: string | undefined, defaultQuestions: Array<string>, requireDefaultQuestions: boolean, topicsToAvoid: Array<string>, allowExperimentalFactorQuestions: boolean, identificationMode: IdentificationMode, insightsVisibility: InsightsVisibility, canViewInsights: boolean, currentParticipantHasJoined: boolean, selectedAttributes: Array<{ __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string> }>, sections: Array<{ __typename?: 'SessionSection', name: string, description?: string | undefined, section: SessionSectionType, timeInSeconds: number, timeRemaining?: number | undefined }>, user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined } } };

export type GetSessionAttributeTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<SessionAttributeTemplatesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSessionAttributeTemplatesQuery = { __typename?: 'Query', sessionAttributeTemplates: { __typename?: 'SessionAttributeTemplatesConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, totalCount: number }, edges: Array<{ __typename?: 'SessionAttributeTemplatesEdge', cursor: string, node: { __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string>, archived: boolean, createdAt: any } }> } };

export type GetSessionFactorsQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type GetSessionFactorsQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, factors?: { __typename?: 'SessionFactors', status: SessionFactorGenerationStatus, error?: string | undefined, factors: Array<{ __typename?: 'SessionFactor', id: string, factorCode: string, factorName: string, description: string, analysis: string, quotes: Array<{ __typename?: 'SessionFactorQuote', quote: string, participant: { __typename?: 'Participant', id: string, name: string, title: string } }> }> } | undefined } };

export type GetSessionFeedbackQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type GetSessionFeedbackQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, title: string, createdAt: any, feedback: { __typename?: 'FeedbackConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number }, edges: Array<{ __typename?: 'FeedbackEdge', cursor: string, node: { __typename?: 'Feedback', id: string, feedback: string, rating?: number | undefined, createdAt: any, participant: { __typename?: 'Participant', id: string, name: string } } }> } } };

export type GetSessionInsightsQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type GetSessionInsightsQuery = { __typename?: 'Query', sessionInsights: { __typename?: 'SessionInsightsResult', canViewInsights: boolean, sessionInsights?: { __typename?: 'SessionInsights', participantCount: number, duration: number, sessionSummary?: { __typename?: 'SessionSummary', id: string, positiveHighlights: Array<string>, areasForImprovement: Array<string> } | undefined, issues: Array<{ __typename?: 'Issue', matchedAvoidTopic?: string | undefined, id: string, name: string, description: string, oneLiner?: string | undefined, summary?: string | undefined, score: number, selectedForSolutioning: boolean, linkedParticipantIds: Array<string>, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }>, whyQuotes: Array<{ __typename?: 'TopicWhyQuote', id: string, text: string, questionText: string, name?: string | undefined, role?: string | undefined }> }>, opportunities: Array<{ __typename?: 'Opportunity', matchedAvoidTopic?: string | undefined, id: string, name: string, description: string, oneLiner?: string | undefined, summary?: string | undefined, score: number, selectedForSolutioning: boolean, linkedParticipantIds: Array<string>, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }>, whyQuotes: Array<{ __typename?: 'TopicWhyQuote', id: string, text: string, questionText: string, name?: string | undefined, role?: string | undefined }> }>, praise: Array<{ __typename?: 'Praise', id: string, name: string, description: string, oneLiner?: string | undefined, summary?: string | undefined, score: number, linkedParticipantIds: Array<string>, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }>, whyQuotes: Array<{ __typename?: 'TopicWhyQuote', id: string, text: string, questionText: string, name?: string | undefined, role?: string | undefined }> }>, implementations: Array<{ __typename?: 'Implementation', id: string, name: string, description: string, summary?: string | undefined, score: number, linkedIssueIds: Array<string>, linkedOpportunityIds: Array<string> }> } | undefined } };

export type GetSessionParticipantAttributesQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type GetSessionParticipantAttributesQuery = { __typename?: 'Query', participants: Array<{ __typename?: 'Participant', id: string, name: string, attributeResponses: Array<{ __typename?: 'ParticipantAttributeResponse', value: string, attributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string } }> }> };

export type GetSessionParticipantCountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSessionParticipantCountQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, participants: { __typename?: 'ParticipantsConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number } } } };

export type GetSessionParticipantsQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ParticipantsSortInput> | ParticipantsSortInput>;
  filter?: InputMaybe<SessionParticipantsFilterInput>;
}>;


export type GetSessionParticipantsQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, participants: { __typename?: 'ParticipantsConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | undefined, endCursor?: string | undefined, totalCount: number }, edges: Array<{ __typename?: 'ParticipantsEdge', cursor: string, node: { __typename?: 'Participant', id: string, name: string, title: string, email?: string | undefined, attributeResponses: Array<{ __typename?: 'ParticipantAttributeResponse', value: string, attributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string } }>, factorScores: Array<{ __typename?: 'ParticipantFactorScore', id: string }> } }> } } };

export type GetSessionReportQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  attributeFilters?: InputMaybe<Array<ReportAttributeFilterInput> | ReportAttributeFilterInput>;
}>;


export type GetSessionReportQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: string, report?: Array<{ __typename?: 'VelocityReportVisualization', id: string, name: string, description: string, module:
        | { __typename: 'FactorReportModule', totalParticipants: number, factors: Array<{ __typename?: 'FactorReportFactor', code: string, name: string, score: number, participantCount: number, summary?: string | undefined, issues: Array<{ __typename?: 'VelocityIssueItem', id: string, name: string, description: string, longDescription: string, matchedAvoidTopic?: string | undefined, factorCodes: Array<string>, factorNames: Array<string>, score: number, assessmentCount: number, assessmentAgreeCount: number, assessmentDisagreeCount: number, averageImpactScore?: number | undefined, impactScoreCount: number, categorizations: Array<{ __typename?: 'IssueCategorization', domain: string, category: string }>, rcaPatterns: Array<{ __typename?: 'IssueRcaPattern', pattern: string, score: number, maxScore: number }>, averageFactorEffectScores: Array<{ __typename?: 'IssueFactorEffectScore', code: string, name: string, average: number, count: number }>, agreedParticipants?: Array<{ __typename?: 'Participant', id: string, name: string }> | undefined, originatorParticipant?: { __typename?: 'Participant', id: string, name: string } | undefined, relatedFactors: Array<{ __typename?: 'IssueRelatedFactor', code: string, name: string, description: string, score: number }> }>, questionBreakdowns: Array<{ __typename?: 'FactorQuestionBreakdown', prompt: string, negativeCount: number, neutralCount: number, positiveCount: number, participantCount: number }>, reportingFactorScores: Array<{ __typename?: 'ReportingFactorScore', reportingFactor: string, score: number }> }> }
        | { __typename: 'OrgHealthReportModule', participantCount: number, questionsAnswered: number, issueCount: number, factorsCovered: number, totalFactors: number, durationSeconds?: number | undefined, summary?: string | undefined, topIssues: Array<{ __typename?: 'VelocityIssueItem', id: string, name: string, description: string, longDescription: string, matchedAvoidTopic?: string | undefined, factorCodes: Array<string>, factorNames: Array<string>, score: number, assessmentCount: number, assessmentAgreeCount: number, assessmentDisagreeCount: number, averageImpactScore?: number | undefined, impactScoreCount: number, categorizations: Array<{ __typename?: 'IssueCategorization', domain: string, category: string }>, rcaPatterns: Array<{ __typename?: 'IssueRcaPattern', pattern: string, score: number, maxScore: number }>, averageFactorEffectScores: Array<{ __typename?: 'IssueFactorEffectScore', code: string, name: string, average: number, count: number }>, agreedParticipants?: Array<{ __typename?: 'Participant', id: string, name: string }> | undefined, originatorParticipant?: { __typename?: 'Participant', id: string, name: string } | undefined, relatedFactors: Array<{ __typename?: 'IssueRelatedFactor', code: string, name: string, description: string, score: number }> }> }
        | { __typename: 'IssuesReportModule', totalParticipants: number, issues: Array<{ __typename?: 'VelocityIssueItem', id: string, name: string, description: string, longDescription: string, matchedAvoidTopic?: string | undefined, factorCodes: Array<string>, factorNames: Array<string>, score: number, assessmentCount: number, assessmentAgreeCount: number, assessmentDisagreeCount: number, averageImpactScore?: number | undefined, impactScoreCount: number, categorizations: Array<{ __typename?: 'IssueCategorization', domain: string, category: string }>, rcaPatterns: Array<{ __typename?: 'IssueRcaPattern', pattern: string, score: number, maxScore: number }>, averageFactorEffectScores: Array<{ __typename?: 'IssueFactorEffectScore', code: string, name: string, average: number, count: number }>, agreedParticipants?: Array<{ __typename?: 'Participant', id: string, name: string }> | undefined, originatorParticipant?: { __typename?: 'Participant', id: string, name: string } | undefined, relatedFactors: Array<{ __typename?: 'IssueRelatedFactor', code: string, name: string, description: string, score: number }> }> }
        | { __typename: 'PraiseReportModule', praise: Array<{ __typename?: 'PraiseItem', id: string, name: string, description: string, celebratedPerson: string, highFives: number, praiser?: { __typename?: 'Participant', id: string, name: string } | undefined }>, topRecognizers?: Array<{ __typename?: 'RecognizerStat', participantId: string, participantName: string, praiseGiven: number }> | undefined }
        | { __typename: 'OrgStrengthsReportModule', strengths: Array<{ __typename?: 'OrgStrengthsItem', id: string, title: string, description: string, longDescription: string, agreeCount: number, disagreeCount: number, noteCount: number, score: number, diagnostics?: { __typename?: 'OrgStrengthDiagnostics', significance: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, fragility: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, reach: { __typename?: 'OrgStrengthReachRollup', total: number, counts: Array<{ __typename?: 'OrgStrengthChoiceCount', value: string, label: string, detailLabel: string, count: number }> } } | undefined }> }
       }> | undefined } };

export type OrgStrengthsItemFragment = { __typename?: 'OrgStrengthsItem', id: string, title: string, description: string, longDescription: string, agreeCount: number, disagreeCount: number, noteCount: number, score: number, diagnostics?: { __typename?: 'OrgStrengthDiagnostics', significance: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, fragility: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, reach: { __typename?: 'OrgStrengthReachRollup', total: number, counts: Array<{ __typename?: 'OrgStrengthChoiceCount', value: string, label: string, detailLabel: string, count: number }> } } | undefined };

export type OrgStrengthDiagnosticsFragment = { __typename?: 'OrgStrengthDiagnostics', significance: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, fragility: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, reach: { __typename?: 'OrgStrengthReachRollup', total: number, counts: Array<{ __typename?: 'OrgStrengthChoiceCount', value: string, label: string, detailLabel: string, count: number }> } };

export type OrgStrengthScaleRollupFragment = { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> };

export type OrgStrengthChoiceCountFragment = { __typename?: 'OrgStrengthChoiceCount', value: string, label: string, detailLabel: string, count: number };

export type VelocityIssueItemFragment = { __typename?: 'VelocityIssueItem', id: string, name: string, description: string, longDescription: string, matchedAvoidTopic?: string | undefined, factorCodes: Array<string>, factorNames: Array<string>, score: number, assessmentCount: number, assessmentAgreeCount: number, assessmentDisagreeCount: number, averageImpactScore?: number | undefined, impactScoreCount: number, categorizations: Array<{ __typename?: 'IssueCategorization', domain: string, category: string }>, rcaPatterns: Array<{ __typename?: 'IssueRcaPattern', pattern: string, score: number, maxScore: number }>, averageFactorEffectScores: Array<{ __typename?: 'IssueFactorEffectScore', code: string, name: string, average: number, count: number }>, agreedParticipants?: Array<{ __typename?: 'Participant', id: string, name: string }> | undefined, originatorParticipant?: { __typename?: 'Participant', id: string, name: string } | undefined, relatedFactors: Array<{ __typename?: 'IssueRelatedFactor', code: string, name: string, description: string, score: number }> };

export type FactorReportFactorFragment = { __typename?: 'FactorReportFactor', code: string, name: string, score: number, participantCount: number, summary?: string | undefined, issues: Array<{ __typename?: 'VelocityIssueItem', id: string, name: string, description: string, longDescription: string, matchedAvoidTopic?: string | undefined, factorCodes: Array<string>, factorNames: Array<string>, score: number, assessmentCount: number, assessmentAgreeCount: number, assessmentDisagreeCount: number, averageImpactScore?: number | undefined, impactScoreCount: number, categorizations: Array<{ __typename?: 'IssueCategorization', domain: string, category: string }>, rcaPatterns: Array<{ __typename?: 'IssueRcaPattern', pattern: string, score: number, maxScore: number }>, averageFactorEffectScores: Array<{ __typename?: 'IssueFactorEffectScore', code: string, name: string, average: number, count: number }>, agreedParticipants?: Array<{ __typename?: 'Participant', id: string, name: string }> | undefined, originatorParticipant?: { __typename?: 'Participant', id: string, name: string } | undefined, relatedFactors: Array<{ __typename?: 'IssueRelatedFactor', code: string, name: string, description: string, score: number }> }>, questionBreakdowns: Array<{ __typename?: 'FactorQuestionBreakdown', prompt: string, negativeCount: number, neutralCount: number, positiveCount: number, participantCount: number }>, reportingFactorScores: Array<{ __typename?: 'ReportingFactorScore', reportingFactor: string, score: number }> };

export type PraiseItemFragment = { __typename?: 'PraiseItem', id: string, name: string, description: string, celebratedPerson: string, highFives: number, praiser?: { __typename?: 'Participant', id: string, name: string } | undefined };

export type GetSessionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SessionsFilterInput>;
  sort?: InputMaybe<Array<SessionsSortInput> | SessionsSortInput>;
}>;


export type GetSessionsQuery = { __typename?: 'Query', sessions: { __typename?: 'SessionsConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | undefined, endCursor?: string | undefined }, edges: Array<{ __typename?: 'SessionsEdge', cursor: string, node: { __typename?: 'Session', id: string, title: string, status: SessionStatus, createdAt: any, insightsVisibility: InsightsVisibility, user: { __typename?: 'User', id: string, firstName?: string | undefined, lastName?: string | undefined }, participants: { __typename?: 'ParticipantsConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number } }, feedback: { __typename?: 'FeedbackConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number } } } }> } };

export type GetUsersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UsersFilterInput>;
  sort?: InputMaybe<Array<UsersSortInput> | UsersSortInput>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | undefined, endCursor?: string | undefined }, edges: Array<{ __typename?: 'UsersEdge', cursor: string, node: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, source: string, isPlatformAdmin?: boolean | undefined, status?: UserStatus | undefined, createdAt: any, organizationMemberships: Array<{ __typename?: 'UserOrganization', id: string, role: UserOrganizationRole, organization: { __typename?: 'Organization', id: string, name: string } }> } }> } };

export type GetVelocityFactorQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  factorCode: Scalars['String']['input'];
}>;


export type GetVelocityFactorQuery = { __typename?: 'Query', velocityFactor?: { __typename?: 'VelocityFactor', engagementPercent: number, id: string, code: string, name: string, summary?: string | undefined, rankDetails: { __typename?: 'VelocityFactorRankDetails', rank: number, totalFactors: number }, whyQuotes: Array<{ __typename?: 'VelocityFactorWhyQuote', id: string, text: string, questionText?: string | undefined, name?: string | undefined, role?: string | undefined }>, historicalScores: Array<{ __typename?: 'VelocityFactorHistoricalScore', sessionId: string, sessionTitle: string, createdAt: any, completedAt?: any | undefined, score: number, negativeCount: number, neutralCount: number, positiveCount: number }>, issues: { __typename?: 'VelocityIssuesConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number }, edges: Array<{ __typename?: 'VelocityIssuesEdge', node: { __typename?: 'VelocityIssue', id: string, slug: string, name: string, description: string, factorCodes: Array<string>, factorNames: Array<string>, score: number, assessmentAgreeCount: number, assessmentDisagreeCount: number } }> }, questionBreakdowns: Array<{ __typename?: 'VelocityFactorQuestionBreakdown', prompt: string, negativeCount: number, neutralCount: number, positiveCount: number, participantCount: number }>, reportingFactorScores: Array<{ __typename?: 'ReportingFactorScore', reportingFactor: string, score: number }> } | undefined };

export type GetVelocityIssueQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
}>;


export type GetVelocityIssueQuery = { __typename?: 'Query', velocityIssue?: { __typename?: 'VelocityIssue', id: string, slug: string, name: string, description: string, longDescription: string, guidance?: Array<string> | undefined, factorCodes: Array<string>, factorNames: Array<string>, originatorParticipantId: string, originatorName?: string | undefined, assessmentCount: number, assessmentAgreeCount: number, assessmentDisagreeCount: number, score: number, averageImpactScore?: number | undefined, impactScoreCount: number, engagementPercent: number, assignments: Array<{ __typename?: 'VelocityIssueAssignment', id: string, email: string, createdAt: any }>, categorizations: Array<{ __typename?: 'IssueCategorization', domain: string, category: string }>, patternValidations: Array<{ __typename?: 'IssuePatternValidation', pattern?: string | undefined, question: string, short?: string | undefined, ratingCounts: { __typename?: 'LikertRatingCounts', stronglyDisagree: number, disagree: number, neutral: number, agree: number, stronglyAgree: number } }>, participants: Array<{ __typename?: 'VelocityParticipantRef', id: string, name: string }>, averageFactorEffectScores: Array<{ __typename?: 'VelocityFactorEffectScore', code: string, name: string, average: number, count: number }>, diagnosticDimensionBreakdowns: { __typename?: 'IssueDiagnosticDimensionBreakdowns', scales: Array<{ __typename?: 'IssueScaleBreakdown', prompt: string, lowLabel: string, highLabel: string, participantCount: number, ratingCounts: { __typename?: 'LikertRatingCounts', stronglyDisagree: number, disagree: number, neutral: number, agree: number, stronglyAgree: number } }>, scope?: { __typename?: 'IssueChoiceBreakdown', total: number, counts: Array<{ __typename?: 'IssueChoiceCount', choice: string, label: string, detailLabel: string, count: number }> } | undefined, attempts?: { __typename?: 'IssueChoiceBreakdown', total: number, counts: Array<{ __typename?: 'IssueChoiceCount', choice: string, label: string, detailLabel: string, count: number }> } | undefined }, relatedFactors: { __typename?: 'VelocityFactorsConnection', edges: Array<{ __typename?: 'VelocityFactorsEdge', node: { __typename?: 'VelocityFactor', code: string, name: string, score: number, summary?: string | undefined } }> }, rankDetails: { __typename?: 'VelocityIssueRankDetails', rank: number, totalIssues: number }, participantQuotes: Array<{ __typename?: 'VelocityFactorWhyQuote', id: string, text: string, questionText?: string | undefined, name?: string | undefined, role?: string | undefined }> } | undefined };

export type GetVelocityOrgStrengthQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
}>;


export type GetVelocityOrgStrengthQuery = { __typename?: 'Query', velocityOrgStrength?: { __typename?: 'VelocityOrgStrength', id: string, slug: string, title: string, description: string, longDescription: string, agreeCount: number, disagreeCount: number, responseCount: number, engagementPercent: number, rankDetails: { __typename?: 'VelocityOrgStrengthRankDetails', rank: number, totalStrengths: number }, participantQuotes: Array<{ __typename?: 'VelocityFactorWhyQuote', id: string, text: string, questionText?: string | undefined, name?: string | undefined, role?: string | undefined }>, diagnostics?: { __typename?: 'OrgStrengthDiagnostics', significance: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, fragility: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, reach: { __typename?: 'OrgStrengthReachRollup', total: number, counts: Array<{ __typename?: 'OrgStrengthChoiceCount', value: string, label: string, detailLabel: string, count: number }> } } | undefined } | undefined };

export type JoinSessionMutationVariables = Exact<{
  input: JoinSessionInput;
}>;


export type JoinSessionMutation = { __typename?: 'Mutation', joinSession: { __typename?: 'JoinSessionPayload', session: { __typename?: 'Session', id: string, currentParticipantHasJoined: boolean }, participant?: { __typename?: 'Participant', id: string, name: string, title: string, email?: string | undefined } | undefined } };

export type NextQuestionQueryVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type NextQuestionQuery = { __typename?: 'Query', nextQuestion: { __typename?: 'NextQuestionResponse', session: { __typename?: 'Session', id: string, type: string, status: SessionStatus, section?: SessionSectionType | undefined, title: string, currentParticipantHasJoined: boolean, sections: Array<{ __typename?: 'SessionSection', name: string, description?: string | undefined, section: SessionSectionType, timeInSeconds: number, timeRemaining?: number | undefined }>, user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined } }, question?: { __typename?: 'Question', id: string, createdAt: any, section: SessionSectionType, issues: Array<{ __typename?: 'Issue', id: string, name: string, description: string }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, description: string }>, implementations: Array<{ __typename?: 'Implementation', id: string, name: string, description: string }>, content:
        | { __typename: 'MultipleChoiceQuestionContent', preamble?: string | undefined, question: string, multipleChoiceOptions: Array<string> }
        | { __typename: 'TextQuestionContent', preamble?: string | undefined, question: string }
        | { __typename: 'BooleanQuestionContent', preamble?: string | undefined, question: string }
        | { __typename: 'RankingQuestionContent', preamble?: string | undefined, question: string, rankingType?: string | undefined, issues: Array<{ __typename?: 'Issue', id: string, name: string, description: string }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, name: string, description: string }>, rankingOptions: Array<{ __typename?: 'RankingQuestionOption', id: string, text: string, description?: string | undefined }> }
        | { __typename: 'RatingScaleQuestionContent', preamble?: string | undefined, question: string, scaleType: RatingScaleType, minLabel: string, maxLabel: string }
       } | undefined } };

export type PauseSessionMutationVariables = Exact<{
  input: PauseSessionInput;
}>;


export type PauseSessionMutation = { __typename?: 'Mutation', pauseSession: { __typename?: 'PauseSessionPayload', session: { __typename?: 'Session', id: string, status: SessionStatus, user: { __typename?: 'User', id: string } } } };

export type ReassignSessionMutationVariables = Exact<{
  input: ReassignSessionInput;
}>;


export type ReassignSessionMutation = { __typename?: 'Mutation', reassignSession: { __typename?: 'ReassignSessionPayload', session?: { __typename?: 'Session', id: string } | undefined } };

export type RegenerateSessionSummaryMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type RegenerateSessionSummaryMutation = { __typename?: 'Mutation', regenerateSessionSummary: { __typename?: 'RegenerateSessionSummaryPayload', success: boolean } };

export type RemoveTopicAssignmentMutationVariables = Exact<{
  input: RemoveTopicAssignmentInput;
}>;


export type RemoveTopicAssignmentMutation = { __typename?: 'Mutation', removeTopicAssignment: { __typename?: 'RemoveTopicAssignmentPayload', success: boolean, idea?:
      | { __typename?: 'Issue', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }
      | { __typename?: 'Opportunity', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }
      | { __typename?: 'Praise', id: string, topicAssignments: Array<{ __typename?: 'TopicAssignment', id: string, email: string, createdAt: any }> }
     | undefined } };

export type RemoveUserFromOrganizationMutationVariables = Exact<{
  input: RemoveUserFromOrganizationInput;
}>;


export type RemoveUserFromOrganizationMutation = { __typename?: 'Mutation', removeUserFromOrganization: { __typename?: 'RemoveUserFromOrganizationPayload', success: boolean } };

export type RemoveVelocityIssueAssignmentMutationVariables = Exact<{
  input: RemoveVelocityIssueAssignmentInput;
}>;


export type RemoveVelocityIssueAssignmentMutation = { __typename?: 'Mutation', removeVelocityIssueAssignment: { __typename?: 'RemoveVelocityIssueAssignmentPayload', success: boolean, issue: { __typename?: 'VelocityIssue', id: string, assignments: Array<{ __typename?: 'VelocityIssueAssignment', id: string, email: string, createdAt: any }> } } };

export type RestoreOrganizationMutationVariables = Exact<{
  input: RestoreOrganizationInput;
}>;


export type RestoreOrganizationMutation = { __typename?: 'Mutation', restoreOrganization: { __typename?: 'RestoreOrganizationPayload', organization: { __typename?: 'Organization', id: string, name: string, status: OrganizationStatus, archivedAt?: any | undefined } } };

export type ResumeSessionMutationVariables = Exact<{
  input: ResumeSessionInput;
}>;


export type ResumeSessionMutation = { __typename?: 'Mutation', resumeSession: { __typename?: 'ResumeSessionPayload', session: { __typename?: 'Session', id: string, status: SessionStatus, user: { __typename?: 'User', id: string } } } };

export type SaveVoteMutationVariables = Exact<{
  input: SaveVoteInput;
}>;


export type SaveVoteMutation = { __typename?: 'Mutation', saveVote: { __typename?: 'SaveVotePayload', success: boolean, opportunity?: { __typename?: 'Opportunity', id: string, myVote?: VoteType | undefined, score: number } | undefined, implementation?: { __typename?: 'Implementation', id: string, myVote?: VoteType | undefined, score: number } | undefined, issue?: { __typename?: 'Issue', id: string, myVote?: VoteType | undefined, score: number } | undefined } };

export type SendInsightsEmailMutationVariables = Exact<{
  input: SendInsightsEmailInput;
}>;


export type SendInsightsEmailMutation = { __typename?: 'Mutation', sendInsightsEmail: { __typename?: 'SendInsightsEmailPayload', success: boolean, emailsSent: number } };

export type SendInvitationMutationVariables = Exact<{
  input: SendInvitationInput;
}>;


export type SendInvitationMutation = { __typename?: 'Mutation', sendInvitation: { __typename?: 'SendInvitationPayload', invitationSent: boolean, error?: string | undefined, success?: string | undefined } };

export type SetSolutioningTopicsMutationVariables = Exact<{
  input: SetSolutioningTopicsInput;
}>;


export type SetSolutioningTopicsMutation = { __typename?: 'Mutation', setSolutioningTopics: { __typename?: 'SetSolutioningTopicsPayload', issues: Array<{ __typename?: 'Issue', id: string, selectedForSolutioning: boolean }>, opportunities: Array<{ __typename?: 'Opportunity', id: string, selectedForSolutioning: boolean }> } };

export type SkipQuestionMutationVariables = Exact<{
  input: SkipQuestionInput;
}>;


export type SkipQuestionMutation = { __typename?: 'Mutation', skipQuestion: { __typename?: 'AnswerQuestionPayload', answer?: string | undefined, answeredAt?: any | undefined } };

export type SkipToNextSectionMutationVariables = Exact<{
  input: SkipToNextSectionInput;
}>;


export type SkipToNextSectionMutation = { __typename?: 'Mutation', skipToNextSection: { __typename?: 'SkipToNextSectionPayload', newSectionIndex: number, session: { __typename?: 'Session', id: string, sections: Array<{ __typename?: 'SessionSection', section: SessionSectionType, timeRemaining?: number | undefined }> } } };

export type StartSessionMutationVariables = Exact<{
  input: StartSessionInput;
}>;


export type StartSessionMutation = { __typename?: 'Mutation', startSession: { __typename?: 'StartSessionPayload', expiresAt?: any | undefined } };

export type StartSolutionForIdeaMutationVariables = Exact<{
  input: StartSolutionForIdeaInput;
}>;


export type StartSolutionForIdeaMutation = { __typename?: 'Mutation', startSolutionForIdea: { __typename?: 'StartSolutionForIdeaPayload', solutionSessionId: string, nextQuestion?: { __typename?: 'Question', id: string, content:
        | { __typename?: 'MultipleChoiceQuestionContent' }
        | { __typename?: 'TextQuestionContent', question: string }
        | { __typename?: 'BooleanQuestionContent' }
        | { __typename?: 'RankingQuestionContent' }
        | { __typename?: 'RatingScaleQuestionContent' }
       } | undefined } };

export type ToggleCurrentUserPlatformAdminMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleCurrentUserPlatformAdminMutation = { __typename?: 'Mutation', toggleCurrentUserPlatformAdmin: { __typename?: 'ToggleCurrentUserPlatformAdminPayload', user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, isPlatformAdmin?: boolean | undefined, source: string } } };

export type UpdateCurrentUserLocaleMutationVariables = Exact<{
  input: UpdateCurrentUserLocaleInput;
}>;


export type UpdateCurrentUserLocaleMutation = { __typename?: 'Mutation', updateCurrentUserLocale: { __typename?: 'UpdateCurrentUserLocalePayload', user: { __typename?: 'User', id: string, locale?: string | undefined } } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', organization: { __typename?: 'Organization', id: string, name: string } } };

export type UpdateSessionMutationVariables = Exact<{
  input: UpdateSessionInput;
}>;


export type UpdateSessionMutation = { __typename?: 'Mutation', updateSession: { __typename?: 'UpdateSessionPayload', session?: { __typename?: 'Session', id: string, title: string, type: string, description?: string | undefined, status: SessionStatus, createdAt: any, focus?: string | undefined, defaultQuestions: Array<string>, requireDefaultQuestions: boolean, allowExperimentalFactorQuestions: boolean, identificationMode: IdentificationMode, insightsVisibility: InsightsVisibility, velocityEngineType?: string | undefined, activeFactorCodes?: Array<string> | undefined, activeReportingFactorCodes?: Array<string> | undefined, selectedAttributes: Array<{ __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string> }> } | undefined } };

export type UpdateSessionAttributeTemplateMutationVariables = Exact<{
  input: UpdateSessionAttributeTemplateInput;
}>;


export type UpdateSessionAttributeTemplateMutation = { __typename?: 'Mutation', updateSessionAttributeTemplate: { __typename?: 'UpdateSessionAttributeTemplatePayload', sessionAttributeTemplate: { __typename?: 'SessionAttributeTemplate', id: string, name: string, type: SessionAttributeType, options: Array<string>, archived: boolean, createdAt: any } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', user: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined } } };

export type VelocityFactorListItemFragment = { __typename?: 'VelocityFactor', id: string, code: string, name: string, summary?: string | undefined, questionBreakdowns: Array<{ __typename?: 'VelocityFactorQuestionBreakdown', prompt: string, negativeCount: number, neutralCount: number, positiveCount: number, participantCount: number }>, reportingFactorScores: Array<{ __typename?: 'ReportingFactorScore', reportingFactor: string, score: number }> };

export type VelocityFactorDetailFragment = { __typename?: 'VelocityFactor', engagementPercent: number, id: string, code: string, name: string, summary?: string | undefined, rankDetails: { __typename?: 'VelocityFactorRankDetails', rank: number, totalFactors: number }, whyQuotes: Array<{ __typename?: 'VelocityFactorWhyQuote', id: string, text: string, questionText?: string | undefined, name?: string | undefined, role?: string | undefined }>, historicalScores: Array<{ __typename?: 'VelocityFactorHistoricalScore', sessionId: string, sessionTitle: string, createdAt: any, completedAt?: any | undefined, score: number, negativeCount: number, neutralCount: number, positiveCount: number }>, issues: { __typename?: 'VelocityIssuesConnection', pageInfo: { __typename?: 'PageInfo', totalCount: number }, edges: Array<{ __typename?: 'VelocityIssuesEdge', node: { __typename?: 'VelocityIssue', id: string, slug: string, name: string, description: string, factorCodes: Array<string>, factorNames: Array<string>, score: number, assessmentAgreeCount: number, assessmentDisagreeCount: number } }> }, questionBreakdowns: Array<{ __typename?: 'VelocityFactorQuestionBreakdown', prompt: string, negativeCount: number, neutralCount: number, positiveCount: number, participantCount: number }>, reportingFactorScores: Array<{ __typename?: 'ReportingFactorScore', reportingFactor: string, score: number }> };

export type VelocityIssueDetailFragment = { __typename?: 'VelocityIssue', id: string, slug: string, name: string, description: string, longDescription: string, guidance?: Array<string> | undefined, factorCodes: Array<string>, factorNames: Array<string>, originatorParticipantId: string, originatorName?: string | undefined, assessmentCount: number, assessmentAgreeCount: number, assessmentDisagreeCount: number, score: number, averageImpactScore?: number | undefined, impactScoreCount: number, engagementPercent: number, categorizations: Array<{ __typename?: 'IssueCategorization', domain: string, category: string }>, patternValidations: Array<{ __typename?: 'IssuePatternValidation', pattern?: string | undefined, question: string, short?: string | undefined, ratingCounts: { __typename?: 'LikertRatingCounts', stronglyDisagree: number, disagree: number, neutral: number, agree: number, stronglyAgree: number } }>, participants: Array<{ __typename?: 'VelocityParticipantRef', id: string, name: string }>, averageFactorEffectScores: Array<{ __typename?: 'VelocityFactorEffectScore', code: string, name: string, average: number, count: number }>, diagnosticDimensionBreakdowns: { __typename?: 'IssueDiagnosticDimensionBreakdowns', scales: Array<{ __typename?: 'IssueScaleBreakdown', prompt: string, lowLabel: string, highLabel: string, participantCount: number, ratingCounts: { __typename?: 'LikertRatingCounts', stronglyDisagree: number, disagree: number, neutral: number, agree: number, stronglyAgree: number } }>, scope?: { __typename?: 'IssueChoiceBreakdown', total: number, counts: Array<{ __typename?: 'IssueChoiceCount', choice: string, label: string, detailLabel: string, count: number }> } | undefined, attempts?: { __typename?: 'IssueChoiceBreakdown', total: number, counts: Array<{ __typename?: 'IssueChoiceCount', choice: string, label: string, detailLabel: string, count: number }> } | undefined }, relatedFactors: { __typename?: 'VelocityFactorsConnection', edges: Array<{ __typename?: 'VelocityFactorsEdge', node: { __typename?: 'VelocityFactor', code: string, name: string, score: number, summary?: string | undefined } }> }, rankDetails: { __typename?: 'VelocityIssueRankDetails', rank: number, totalIssues: number }, participantQuotes: Array<{ __typename?: 'VelocityFactorWhyQuote', id: string, text: string, questionText?: string | undefined, name?: string | undefined, role?: string | undefined }> };

export type VelocityOrgStrengthDetailFragment = { __typename?: 'VelocityOrgStrength', id: string, slug: string, title: string, description: string, longDescription: string, agreeCount: number, disagreeCount: number, responseCount: number, engagementPercent: number, rankDetails: { __typename?: 'VelocityOrgStrengthRankDetails', rank: number, totalStrengths: number }, participantQuotes: Array<{ __typename?: 'VelocityFactorWhyQuote', id: string, text: string, questionText?: string | undefined, name?: string | undefined, role?: string | undefined }>, diagnostics?: { __typename?: 'OrgStrengthDiagnostics', significance: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, fragility: { __typename?: 'OrgStrengthScaleRollup', count: number, average: number, distribution: Array<number> }, reach: { __typename?: 'OrgStrengthReachRollup', total: number, counts: Array<{ __typename?: 'OrgStrengthChoiceCount', value: string, label: string, detailLabel: string, count: number }> } } | undefined };

export type SendFeedbackMutationVariables = Exact<{
  input: CreateFeedbackInput;
}>;


export type SendFeedbackMutation = { __typename?: 'Mutation', createFeedback: { __typename?: 'CreateFeedbackPayload', feedback?: { __typename?: 'Feedback', id: string, feedback: string, rating?: number | undefined, participant: { __typename?: 'Participant', id: string, name: string } } | undefined } };

export const OrgStrengthScaleRollupFragmentDoc = gql`
    fragment OrgStrengthScaleRollup on OrgStrengthScaleRollup {
  count
  average
  distribution
}
    `;
export const OrgStrengthChoiceCountFragmentDoc = gql`
    fragment OrgStrengthChoiceCount on OrgStrengthChoiceCount {
  value
  label
  detailLabel
  count
}
    `;
export const OrgStrengthDiagnosticsFragmentDoc = gql`
    fragment OrgStrengthDiagnostics on OrgStrengthDiagnostics {
  significance {
    ...OrgStrengthScaleRollup
  }
  fragility {
    ...OrgStrengthScaleRollup
  }
  reach {
    total
    counts {
      ...OrgStrengthChoiceCount
    }
  }
}
    ${OrgStrengthScaleRollupFragmentDoc}
${OrgStrengthChoiceCountFragmentDoc}`;
export const OrgStrengthsItemFragmentDoc = gql`
    fragment OrgStrengthsItem on OrgStrengthsItem {
  id
  title
  description
  longDescription
  agreeCount
  disagreeCount
  noteCount
  score
  diagnostics {
    ...OrgStrengthDiagnostics
  }
}
    ${OrgStrengthDiagnosticsFragmentDoc}`;
export const VelocityIssueItemFragmentDoc = gql`
    fragment VelocityIssueItem on VelocityIssueItem {
  id
  name
  description
  longDescription
  matchedAvoidTopic
  categorizations {
    domain
    category
  }
  rcaPatterns {
    pattern
    score
    maxScore
  }
  factorCodes
  factorNames
  score
  assessmentCount
  assessmentAgreeCount
  assessmentDisagreeCount
  averageImpactScore
  impactScoreCount
  averageFactorEffectScores {
    code
    name
    average
    count
  }
  agreedParticipants {
    id
    name
  }
  originatorParticipant {
    id
    name
  }
  relatedFactors {
    code
    name
    description
    score
  }
}
    `;
export const FactorReportFactorFragmentDoc = gql`
    fragment FactorReportFactor on FactorReportFactor {
  code
  name
  score
  participantCount
  issues {
    ...VelocityIssueItem
  }
  summary
  questionBreakdowns {
    prompt
    negativeCount
    neutralCount
    positiveCount
    participantCount
  }
  reportingFactorScores {
    reportingFactor
    score
  }
}
    ${VelocityIssueItemFragmentDoc}`;
export const PraiseItemFragmentDoc = gql`
    fragment PraiseItem on PraiseItem {
  id
  name
  description
  celebratedPerson
  highFives
  praiser {
    id
    name
  }
}
    `;
export const VelocityFactorListItemFragmentDoc = gql`
    fragment VelocityFactorListItem on VelocityFactor {
  id
  code
  name
  summary
  questionBreakdowns {
    prompt
    negativeCount
    neutralCount
    positiveCount
    participantCount
  }
  reportingFactorScores {
    reportingFactor
    score
  }
}
    `;
export const VelocityFactorDetailFragmentDoc = gql`
    fragment VelocityFactorDetail on VelocityFactor {
  ...VelocityFactorListItem
  rankDetails {
    rank
    totalFactors
  }
  engagementPercent
  whyQuotes {
    id
    text
    questionText
    name
    role
  }
  historicalScores {
    sessionId
    sessionTitle
    createdAt
    completedAt
    score
    negativeCount
    neutralCount
    positiveCount
  }
  issues {
    pageInfo {
      totalCount
    }
    edges {
      node {
        id
        slug
        name
        description
        factorCodes
        factorNames
        score
        assessmentAgreeCount
        assessmentDisagreeCount
      }
    }
  }
}
    ${VelocityFactorListItemFragmentDoc}`;
export const VelocityIssueDetailFragmentDoc = gql`
    fragment VelocityIssueDetail on VelocityIssue {
  id
  slug
  name
  description
  longDescription
  guidance
  categorizations {
    domain
    category
  }
  patternValidations {
    pattern
    question
    short
    ratingCounts {
      stronglyDisagree
      disagree
      neutral
      agree
      stronglyAgree
    }
  }
  factorCodes
  factorNames
  originatorParticipantId
  originatorName
  participants {
    id
    name
  }
  assessmentCount
  assessmentAgreeCount
  assessmentDisagreeCount
  score
  averageImpactScore
  impactScoreCount
  averageFactorEffectScores {
    code
    name
    average
    count
  }
  diagnosticDimensionBreakdowns {
    scales {
      prompt
      lowLabel
      highLabel
      ratingCounts {
        stronglyDisagree
        disagree
        neutral
        agree
        stronglyAgree
      }
      participantCount
    }
    scope {
      total
      counts {
        choice
        label
        detailLabel
        count
      }
    }
    attempts {
      total
      counts {
        choice
        label
        detailLabel
        count
      }
    }
  }
  relatedFactors {
    edges {
      node {
        code
        name
        score
        summary
      }
    }
  }
  rankDetails {
    rank
    totalIssues
  }
  engagementPercent
  participantQuotes {
    id
    text
    questionText
    name
    role
  }
}
    `;
export const VelocityOrgStrengthDetailFragmentDoc = gql`
    fragment VelocityOrgStrengthDetail on VelocityOrgStrength {
  id
  slug
  title
  description
  longDescription
  agreeCount
  disagreeCount
  responseCount
  rankDetails {
    rank
    totalStrengths
  }
  engagementPercent
  participantQuotes {
    id
    text
    questionText
    name
    role
  }
  diagnostics {
    ...OrgStrengthDiagnostics
  }
}
    ${OrgStrengthDiagnosticsFragmentDoc}`;
export const AbandonQuestionDocument = gql`
    mutation AbandonQuestion($input: AbandonQuestionInput!) {
  abandonQuestion(input: $input) {
    success
  }
}
    `;
export type AbandonQuestionMutationFn = ApolloReactCommon.MutationFunction<AbandonQuestionMutation, AbandonQuestionMutationVariables>;

/**
 * __useAbandonQuestionMutation__
 *
 * To run a mutation, you first call `useAbandonQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbandonQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abandonQuestionMutation, { data, loading, error }] = useAbandonQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAbandonQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AbandonQuestionMutation, AbandonQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AbandonQuestionMutation, AbandonQuestionMutationVariables>(AbandonQuestionDocument, options);
      }
export type AbandonQuestionMutationHookResult = ReturnType<typeof useAbandonQuestionMutation>;
export type AbandonQuestionMutationResult = ApolloReactCommon.MutationResult<AbandonQuestionMutation>;
export type AbandonQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AbandonQuestionMutation, AbandonQuestionMutationVariables>;
export const AnswerBooleanQuestionDocument = gql`
    mutation AnswerBooleanQuestion($input: AnswerBooleanQuestionInput!) {
  answerBooleanQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerBooleanQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerBooleanQuestionMutation, AnswerBooleanQuestionMutationVariables>;

/**
 * __useAnswerBooleanQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerBooleanQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerBooleanQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerBooleanQuestionMutation, { data, loading, error }] = useAnswerBooleanQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerBooleanQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerBooleanQuestionMutation, AnswerBooleanQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerBooleanQuestionMutation, AnswerBooleanQuestionMutationVariables>(AnswerBooleanQuestionDocument, options);
      }
export type AnswerBooleanQuestionMutationHookResult = ReturnType<typeof useAnswerBooleanQuestionMutation>;
export type AnswerBooleanQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerBooleanQuestionMutation>;
export type AnswerBooleanQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerBooleanQuestionMutation, AnswerBooleanQuestionMutationVariables>;
export const AnswerMultipleChoiceQuestionDocument = gql`
    mutation AnswerMultipleChoiceQuestion($input: AnswerMultipleChoiceQuestionInput!) {
  answerMultipleChoiceQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerMultipleChoiceQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerMultipleChoiceQuestionMutation, AnswerMultipleChoiceQuestionMutationVariables>;

/**
 * __useAnswerMultipleChoiceQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerMultipleChoiceQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerMultipleChoiceQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerMultipleChoiceQuestionMutation, { data, loading, error }] = useAnswerMultipleChoiceQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerMultipleChoiceQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerMultipleChoiceQuestionMutation, AnswerMultipleChoiceQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerMultipleChoiceQuestionMutation, AnswerMultipleChoiceQuestionMutationVariables>(AnswerMultipleChoiceQuestionDocument, options);
      }
export type AnswerMultipleChoiceQuestionMutationHookResult = ReturnType<typeof useAnswerMultipleChoiceQuestionMutation>;
export type AnswerMultipleChoiceQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerMultipleChoiceQuestionMutation>;
export type AnswerMultipleChoiceQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerMultipleChoiceQuestionMutation, AnswerMultipleChoiceQuestionMutationVariables>;
export const AnswerRankingQuestionDocument = gql`
    mutation AnswerRankingQuestion($input: AnswerRankingQuestionInput!) {
  answerRankingQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerRankingQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerRankingQuestionMutation, AnswerRankingQuestionMutationVariables>;

/**
 * __useAnswerRankingQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerRankingQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerRankingQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerRankingQuestionMutation, { data, loading, error }] = useAnswerRankingQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerRankingQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerRankingQuestionMutation, AnswerRankingQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerRankingQuestionMutation, AnswerRankingQuestionMutationVariables>(AnswerRankingQuestionDocument, options);
      }
export type AnswerRankingQuestionMutationHookResult = ReturnType<typeof useAnswerRankingQuestionMutation>;
export type AnswerRankingQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerRankingQuestionMutation>;
export type AnswerRankingQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerRankingQuestionMutation, AnswerRankingQuestionMutationVariables>;
export const AnswerRatingScaleQuestionDocument = gql`
    mutation AnswerRatingScaleQuestion($input: AnswerRatingScaleQuestionInput!) {
  answerRatingScaleQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerRatingScaleQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerRatingScaleQuestionMutation, AnswerRatingScaleQuestionMutationVariables>;

/**
 * __useAnswerRatingScaleQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerRatingScaleQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerRatingScaleQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerRatingScaleQuestionMutation, { data, loading, error }] = useAnswerRatingScaleQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerRatingScaleQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerRatingScaleQuestionMutation, AnswerRatingScaleQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerRatingScaleQuestionMutation, AnswerRatingScaleQuestionMutationVariables>(AnswerRatingScaleQuestionDocument, options);
      }
export type AnswerRatingScaleQuestionMutationHookResult = ReturnType<typeof useAnswerRatingScaleQuestionMutation>;
export type AnswerRatingScaleQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerRatingScaleQuestionMutation>;
export type AnswerRatingScaleQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerRatingScaleQuestionMutation, AnswerRatingScaleQuestionMutationVariables>;
export const AnswerSolutionQuestionDocument = gql`
    mutation AnswerSolutionQuestion($input: AnswerSolutionQuestionInput!) {
  answerSolutionQuestion(input: $input) {
    solutionSessionId
    questionsAnswered
    isComplete
    nextQuestion {
      id
      content {
        ... on TextQuestionContent {
          question
        }
      }
    }
  }
}
    `;
export type AnswerSolutionQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerSolutionQuestionMutation, AnswerSolutionQuestionMutationVariables>;

/**
 * __useAnswerSolutionQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerSolutionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerSolutionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerSolutionQuestionMutation, { data, loading, error }] = useAnswerSolutionQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerSolutionQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerSolutionQuestionMutation, AnswerSolutionQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerSolutionQuestionMutation, AnswerSolutionQuestionMutationVariables>(AnswerSolutionQuestionDocument, options);
      }
export type AnswerSolutionQuestionMutationHookResult = ReturnType<typeof useAnswerSolutionQuestionMutation>;
export type AnswerSolutionQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerSolutionQuestionMutation>;
export type AnswerSolutionQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerSolutionQuestionMutation, AnswerSolutionQuestionMutationVariables>;
export const AnswerTextQuestionDocument = gql`
    mutation AnswerTextQuestion($input: AnswerTextQuestionInput!) {
  answerTextQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type AnswerTextQuestionMutationFn = ApolloReactCommon.MutationFunction<AnswerTextQuestionMutation, AnswerTextQuestionMutationVariables>;

/**
 * __useAnswerTextQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerTextQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerTextQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerTextQuestionMutation, { data, loading, error }] = useAnswerTextQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnswerTextQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AnswerTextQuestionMutation, AnswerTextQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AnswerTextQuestionMutation, AnswerTextQuestionMutationVariables>(AnswerTextQuestionDocument, options);
      }
export type AnswerTextQuestionMutationHookResult = ReturnType<typeof useAnswerTextQuestionMutation>;
export type AnswerTextQuestionMutationResult = ApolloReactCommon.MutationResult<AnswerTextQuestionMutation>;
export type AnswerTextQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<AnswerTextQuestionMutation, AnswerTextQuestionMutationVariables>;
export const ApplicationStateDocument = gql`
    query ApplicationState {
  applicationState {
    maintenanceModeEnabled
  }
}
    `;

/**
 * __useApplicationStateQuery__
 *
 * To run a query within a React component, call `useApplicationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ApplicationStateQuery, ApplicationStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApplicationStateQuery, ApplicationStateQueryVariables>(ApplicationStateDocument, options);
      }
export function useApplicationStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApplicationStateQuery, ApplicationStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApplicationStateQuery, ApplicationStateQueryVariables>(ApplicationStateDocument, options);
        }
// @ts-ignore
export function useApplicationStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApplicationStateQuery, ApplicationStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplicationStateQuery, ApplicationStateQueryVariables>;
export function useApplicationStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplicationStateQuery, ApplicationStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApplicationStateQuery | undefined, ApplicationStateQueryVariables>;
export function useApplicationStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApplicationStateQuery, ApplicationStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApplicationStateQuery, ApplicationStateQueryVariables>(ApplicationStateDocument, options);
        }
export type ApplicationStateQueryHookResult = ReturnType<typeof useApplicationStateQuery>;
export type ApplicationStateLazyQueryHookResult = ReturnType<typeof useApplicationStateLazyQuery>;
export type ApplicationStateSuspenseQueryHookResult = ReturnType<typeof useApplicationStateSuspenseQuery>;
export type ApplicationStateQueryResult = ApolloReactCommon.QueryResult<ApplicationStateQuery, ApplicationStateQueryVariables>;
export const ArchiveOrganizationDocument = gql`
    mutation ArchiveOrganization($input: ArchiveOrganizationInput!) {
  archiveOrganization(input: $input) {
    organization {
      id
      name
      status
      archivedAt
    }
  }
}
    `;
export type ArchiveOrganizationMutationFn = ApolloReactCommon.MutationFunction<ArchiveOrganizationMutation, ArchiveOrganizationMutationVariables>;

/**
 * __useArchiveOrganizationMutation__
 *
 * To run a mutation, you first call `useArchiveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOrganizationMutation, { data, loading, error }] = useArchiveOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveOrganizationMutation, ArchiveOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveOrganizationMutation, ArchiveOrganizationMutationVariables>(ArchiveOrganizationDocument, options);
      }
export type ArchiveOrganizationMutationHookResult = ReturnType<typeof useArchiveOrganizationMutation>;
export type ArchiveOrganizationMutationResult = ApolloReactCommon.MutationResult<ArchiveOrganizationMutation>;
export type ArchiveOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveOrganizationMutation, ArchiveOrganizationMutationVariables>;
export const ArchiveSessionAttributeTemplateDocument = gql`
    mutation ArchiveSessionAttributeTemplate($input: ArchiveSessionAttributeTemplateInput!) {
  archiveSessionAttributeTemplate(input: $input) {
    sessionAttributeTemplate {
      id
      name
      type
      options
      archived
      createdAt
    }
  }
}
    `;
export type ArchiveSessionAttributeTemplateMutationFn = ApolloReactCommon.MutationFunction<ArchiveSessionAttributeTemplateMutation, ArchiveSessionAttributeTemplateMutationVariables>;

/**
 * __useArchiveSessionAttributeTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveSessionAttributeTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSessionAttributeTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSessionAttributeTemplateMutation, { data, loading, error }] = useArchiveSessionAttributeTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveSessionAttributeTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveSessionAttributeTemplateMutation, ArchiveSessionAttributeTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveSessionAttributeTemplateMutation, ArchiveSessionAttributeTemplateMutationVariables>(ArchiveSessionAttributeTemplateDocument, options);
      }
export type ArchiveSessionAttributeTemplateMutationHookResult = ReturnType<typeof useArchiveSessionAttributeTemplateMutation>;
export type ArchiveSessionAttributeTemplateMutationResult = ApolloReactCommon.MutationResult<ArchiveSessionAttributeTemplateMutation>;
export type ArchiveSessionAttributeTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveSessionAttributeTemplateMutation, ArchiveSessionAttributeTemplateMutationVariables>;
export const ArchiveUserDocument = gql`
    mutation ArchiveUser($input: ArchiveUserInput!) {
  archiveUser(input: $input) {
    user {
      id
      status
    }
  }
}
    `;
export type ArchiveUserMutationFn = ApolloReactCommon.MutationFunction<ArchiveUserMutation, ArchiveUserMutationVariables>;

/**
 * __useArchiveUserMutation__
 *
 * To run a mutation, you first call `useArchiveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUserMutation, { data, loading, error }] = useArchiveUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveUserMutation, ArchiveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveUserMutation, ArchiveUserMutationVariables>(ArchiveUserDocument, options);
      }
export type ArchiveUserMutationHookResult = ReturnType<typeof useArchiveUserMutation>;
export type ArchiveUserMutationResult = ApolloReactCommon.MutationResult<ArchiveUserMutation>;
export type ArchiveUserMutationOptions = ApolloReactCommon.BaseMutationOptions<ArchiveUserMutation, ArchiveUserMutationVariables>;
export const AssignTopicOwnershipDocument = gql`
    mutation AssignTopicOwnership($input: AssignTopicOwnershipInput!) {
  assignTopicOwnership(input: $input) {
    topicAssignment {
      id
      email
      createdAt
    }
    idea {
      ... on Issue {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
      ... on Opportunity {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
      ... on Praise {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
    }
  }
}
    `;
export type AssignTopicOwnershipMutationFn = ApolloReactCommon.MutationFunction<AssignTopicOwnershipMutation, AssignTopicOwnershipMutationVariables>;

/**
 * __useAssignTopicOwnershipMutation__
 *
 * To run a mutation, you first call `useAssignTopicOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTopicOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTopicOwnershipMutation, { data, loading, error }] = useAssignTopicOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTopicOwnershipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignTopicOwnershipMutation, AssignTopicOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignTopicOwnershipMutation, AssignTopicOwnershipMutationVariables>(AssignTopicOwnershipDocument, options);
      }
export type AssignTopicOwnershipMutationHookResult = ReturnType<typeof useAssignTopicOwnershipMutation>;
export type AssignTopicOwnershipMutationResult = ApolloReactCommon.MutationResult<AssignTopicOwnershipMutation>;
export type AssignTopicOwnershipMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignTopicOwnershipMutation, AssignTopicOwnershipMutationVariables>;
export const AssignVelocityIssueOwnershipDocument = gql`
    mutation AssignVelocityIssueOwnership($input: AssignVelocityIssueOwnershipInput!) {
  assignVelocityIssueOwnership(input: $input) {
    assignment {
      id
      email
      createdAt
    }
    issue {
      id
      assignments {
        id
        email
        createdAt
      }
    }
  }
}
    `;
export type AssignVelocityIssueOwnershipMutationFn = ApolloReactCommon.MutationFunction<AssignVelocityIssueOwnershipMutation, AssignVelocityIssueOwnershipMutationVariables>;

/**
 * __useAssignVelocityIssueOwnershipMutation__
 *
 * To run a mutation, you first call `useAssignVelocityIssueOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignVelocityIssueOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignVelocityIssueOwnershipMutation, { data, loading, error }] = useAssignVelocityIssueOwnershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignVelocityIssueOwnershipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignVelocityIssueOwnershipMutation, AssignVelocityIssueOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignVelocityIssueOwnershipMutation, AssignVelocityIssueOwnershipMutationVariables>(AssignVelocityIssueOwnershipDocument, options);
      }
export type AssignVelocityIssueOwnershipMutationHookResult = ReturnType<typeof useAssignVelocityIssueOwnershipMutation>;
export type AssignVelocityIssueOwnershipMutationResult = ApolloReactCommon.MutationResult<AssignVelocityIssueOwnershipMutation>;
export type AssignVelocityIssueOwnershipMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignVelocityIssueOwnershipMutation, AssignVelocityIssueOwnershipMutationVariables>;
export const BubbleGraphDataDocument = gql`
    query BubbleGraphData($sessionId: ID!, $selectedForSolutioningOnly: Boolean) {
  sessionInsights(
    sessionId: $sessionId
    selectedForSolutioningOnly: $selectedForSolutioningOnly
  ) {
    sessionInsights {
      issues {
        id
        name
        description
        summary
        score
        myVote
        mySolutionStatus
        linkedParticipantIds
      }
      opportunities {
        id
        name
        description
        summary
        score
        myVote
        mySolutionStatus
        linkedParticipantIds
      }
      praise {
        id
        name
        description
        summary
        score
        myVote
        linkedParticipantIds
      }
      implementations {
        id
        name
        description
        summary
        score
        linkedIssueIds
        linkedOpportunityIds
        linkedPraiseIds
        myVote
        submittedByMe
      }
      participantCount
    }
  }
}
    `;

/**
 * __useBubbleGraphDataQuery__
 *
 * To run a query within a React component, call `useBubbleGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBubbleGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBubbleGraphDataQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      selectedForSolutioningOnly: // value for 'selectedForSolutioningOnly'
 *   },
 * });
 */
export function useBubbleGraphDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BubbleGraphDataQuery, BubbleGraphDataQueryVariables> & ({ variables: BubbleGraphDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>(BubbleGraphDataDocument, options);
      }
export function useBubbleGraphDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>(BubbleGraphDataDocument, options);
        }
// @ts-ignore
export function useBubbleGraphDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>;
export function useBubbleGraphDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BubbleGraphDataQuery | undefined, BubbleGraphDataQueryVariables>;
export function useBubbleGraphDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>(BubbleGraphDataDocument, options);
        }
export type BubbleGraphDataQueryHookResult = ReturnType<typeof useBubbleGraphDataQuery>;
export type BubbleGraphDataLazyQueryHookResult = ReturnType<typeof useBubbleGraphDataLazyQuery>;
export type BubbleGraphDataSuspenseQueryHookResult = ReturnType<typeof useBubbleGraphDataSuspenseQuery>;
export type BubbleGraphDataQueryResult = ApolloReactCommon.QueryResult<BubbleGraphDataQuery, BubbleGraphDataQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    organization {
      id
      name
    }
  }
}
    `;
export type CreateOrganizationMutationFn = ApolloReactCommon.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = ApolloReactCommon.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreateSessionDocument = gql`
    mutation CreateSession($input: CreateSessionInput!) {
  createSession(input: $input) {
    session {
      id
      title
      type
      description
      status
      createdAt
      focus
      defaultQuestions
      requireDefaultQuestions
      allowExperimentalFactorQuestions
      identificationMode
      insightsVisibility
      velocityEngineType
      activeFactorCodes
      activeReportingFactorCodes
      selectedAttributes {
        id
        name
        type
        options
      }
    }
  }
}
    `;
export type CreateSessionMutationFn = ApolloReactCommon.MutationFunction<CreateSessionMutation, CreateSessionMutationVariables>;

/**
 * __useCreateSessionMutation__
 *
 * To run a mutation, you first call `useCreateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionMutation, { data, loading, error }] = useCreateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSessionMutation, CreateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSessionMutation, CreateSessionMutationVariables>(CreateSessionDocument, options);
      }
export type CreateSessionMutationHookResult = ReturnType<typeof useCreateSessionMutation>;
export type CreateSessionMutationResult = ApolloReactCommon.MutationResult<CreateSessionMutation>;
export type CreateSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSessionMutation, CreateSessionMutationVariables>;
export const CreateSessionAttributeTemplateDocument = gql`
    mutation CreateSessionAttributeTemplate($input: CreateSessionAttributeTemplateInput!) {
  createSessionAttributeTemplate(input: $input) {
    sessionAttributeTemplate {
      id
      name
      type
      options
      archived
      createdAt
    }
  }
}
    `;
export type CreateSessionAttributeTemplateMutationFn = ApolloReactCommon.MutationFunction<CreateSessionAttributeTemplateMutation, CreateSessionAttributeTemplateMutationVariables>;

/**
 * __useCreateSessionAttributeTemplateMutation__
 *
 * To run a mutation, you first call `useCreateSessionAttributeTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionAttributeTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionAttributeTemplateMutation, { data, loading, error }] = useCreateSessionAttributeTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionAttributeTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSessionAttributeTemplateMutation, CreateSessionAttributeTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSessionAttributeTemplateMutation, CreateSessionAttributeTemplateMutationVariables>(CreateSessionAttributeTemplateDocument, options);
      }
export type CreateSessionAttributeTemplateMutationHookResult = ReturnType<typeof useCreateSessionAttributeTemplateMutation>;
export type CreateSessionAttributeTemplateMutationResult = ApolloReactCommon.MutationResult<CreateSessionAttributeTemplateMutation>;
export type CreateSessionAttributeTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateSessionAttributeTemplateMutation, CreateSessionAttributeTemplateMutationVariables>;
export const DuplicateSessionDocument = gql`
    mutation DuplicateSession($input: DuplicateSessionInput!) {
  duplicateSession(input: $input) {
    session {
      id
      title
      type
      description
      status
      createdAt
      focus
      defaultQuestions
      requireDefaultQuestions
      length
    }
  }
}
    `;
export type DuplicateSessionMutationFn = ApolloReactCommon.MutationFunction<DuplicateSessionMutation, DuplicateSessionMutationVariables>;

/**
 * __useDuplicateSessionMutation__
 *
 * To run a mutation, you first call `useDuplicateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateSessionMutation, { data, loading, error }] = useDuplicateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DuplicateSessionMutation, DuplicateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DuplicateSessionMutation, DuplicateSessionMutationVariables>(DuplicateSessionDocument, options);
      }
export type DuplicateSessionMutationHookResult = ReturnType<typeof useDuplicateSessionMutation>;
export type DuplicateSessionMutationResult = ApolloReactCommon.MutationResult<DuplicateSessionMutation>;
export type DuplicateSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<DuplicateSessionMutation, DuplicateSessionMutationVariables>;
export const EndSessionDocument = gql`
    mutation EndSession($input: EndSessionInput!) {
  endSession(input: $input) {
    session {
      id
      expiresAt
      status
    }
  }
}
    `;
export type EndSessionMutationFn = ApolloReactCommon.MutationFunction<EndSessionMutation, EndSessionMutationVariables>;

/**
 * __useEndSessionMutation__
 *
 * To run a mutation, you first call `useEndSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endSessionMutation, { data, loading, error }] = useEndSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEndSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EndSessionMutation, EndSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EndSessionMutation, EndSessionMutationVariables>(EndSessionDocument, options);
      }
export type EndSessionMutationHookResult = ReturnType<typeof useEndSessionMutation>;
export type EndSessionMutationResult = ApolloReactCommon.MutationResult<EndSessionMutation>;
export type EndSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<EndSessionMutation, EndSessionMutationVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    email
    firstName
    lastName
    isPlatformAdmin
    source
    locale
    organization {
      id
      name
    }
    organizationOverridden
    featureFlags {
      velocityBetaSessionTypes
      velocityExperimentalFeatures
      worktangoRoadmapPage
    }
    organizationMemberships {
      id
      role
      organization {
        id
        name
      }
    }
    status
    impersonator {
      id
      name
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCurrentUserQuery | undefined, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = ApolloReactCommon.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetNextSolutionQuestionDocument = gql`
    query GetNextSolutionQuestion($solutionSessionId: ID!) {
  nextSolutionQuestion(solutionSessionId: $solutionSessionId) {
    id
    content {
      ... on TextQuestionContent {
        question
      }
    }
  }
}
    `;

/**
 * __useGetNextSolutionQuestionQuery__
 *
 * To run a query within a React component, call `useGetNextSolutionQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextSolutionQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextSolutionQuestionQuery({
 *   variables: {
 *      solutionSessionId: // value for 'solutionSessionId'
 *   },
 * });
 */
export function useGetNextSolutionQuestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables> & ({ variables: GetNextSolutionQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>(GetNextSolutionQuestionDocument, options);
      }
export function useGetNextSolutionQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>(GetNextSolutionQuestionDocument, options);
        }
// @ts-ignore
export function useGetNextSolutionQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>;
export function useGetNextSolutionQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNextSolutionQuestionQuery | undefined, GetNextSolutionQuestionQueryVariables>;
export function useGetNextSolutionQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>(GetNextSolutionQuestionDocument, options);
        }
export type GetNextSolutionQuestionQueryHookResult = ReturnType<typeof useGetNextSolutionQuestionQuery>;
export type GetNextSolutionQuestionLazyQueryHookResult = ReturnType<typeof useGetNextSolutionQuestionLazyQuery>;
export type GetNextSolutionQuestionSuspenseQueryHookResult = ReturnType<typeof useGetNextSolutionQuestionSuspenseQuery>;
export type GetNextSolutionQuestionQueryResult = ApolloReactCommon.QueryResult<GetNextSolutionQuestionQuery, GetNextSolutionQuestionQueryVariables>;
export const GetOrganizationUsersDocument = gql`
    query GetOrganizationUsers($organizationId: ID!, $first: Int, $after: String, $last: Int, $before: String, $filter: OrganizationUsersFilterInput, $sort: [OrganizationUsersSortInput!]) {
  organizationUsers(
    organizationId: $organizationId
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      totalCount
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        email
        firstName
        lastName
        source
        isPlatformAdmin
        status
        createdAt
        organizationMemberships {
          role
          organization {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetOrganizationUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables> & ({ variables: GetOrganizationUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
      }
export function useGetOrganizationUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
// @ts-ignore
export function useGetOrganizationUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export function useGetOrganizationUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrganizationUsersQuery | undefined, GetOrganizationUsersQueryVariables>;
export function useGetOrganizationUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export type GetOrganizationUsersQueryHookResult = ReturnType<typeof useGetOrganizationUsersQuery>;
export type GetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersLazyQuery>;
export type GetOrganizationUsersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationUsersSuspenseQuery>;
export type GetOrganizationUsersQueryResult = ApolloReactCommon.QueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($first: Int, $after: String, $last: Int, $before: String, $filter: OrganizationsFilterInput) {
  organizations(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
  ) {
    pageInfo {
      totalCount
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        name
        createdAt
        userCount
        status
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrganizationsQuery | undefined, GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = ApolloReactCommon.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetParticipantDocument = gql`
    query GetParticipant($sessionId: ID!, $participantId: ID!) {
  participant(sessionId: $sessionId, participantId: $participantId) {
    id
    name
    title
  }
}
    `;

/**
 * __useGetParticipantQuery__
 *
 * To run a query within a React component, call `useGetParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables> & ({ variables: GetParticipantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
      }
export function useGetParticipantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
        }
// @ts-ignore
export function useGetParticipantSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetParticipantQuery, GetParticipantQueryVariables>;
export function useGetParticipantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetParticipantQuery | undefined, GetParticipantQueryVariables>;
export function useGetParticipantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
        }
export type GetParticipantQueryHookResult = ReturnType<typeof useGetParticipantQuery>;
export type GetParticipantLazyQueryHookResult = ReturnType<typeof useGetParticipantLazyQuery>;
export type GetParticipantSuspenseQueryHookResult = ReturnType<typeof useGetParticipantSuspenseQuery>;
export type GetParticipantQueryResult = ApolloReactCommon.QueryResult<GetParticipantQuery, GetParticipantQueryVariables>;
export const GetParticipantAnswersDocument = gql`
    query GetParticipantAnswers($sessionId: ID!, $participantId: String!) {
  participantAnswers(
    filter: {sessionId: $sessionId, participantId: $participantId}
  ) {
    id
    content {
      ... on MultipleChoiceQuestionContent {
        question
        multipleChoiceOptions
      }
      ... on TextQuestionContent {
        question
      }
      ... on BooleanQuestionContent {
        question
      }
      ... on RankingQuestionContent {
        question
      }
      ... on RatingScaleQuestionContent {
        question
      }
    }
    answer
    answeredAt
  }
}
    `;

/**
 * __useGetParticipantAnswersQuery__
 *
 * To run a query within a React component, call `useGetParticipantAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantAnswersQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantAnswersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables> & ({ variables: GetParticipantAnswersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>(GetParticipantAnswersDocument, options);
      }
export function useGetParticipantAnswersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>(GetParticipantAnswersDocument, options);
        }
// @ts-ignore
export function useGetParticipantAnswersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>;
export function useGetParticipantAnswersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetParticipantAnswersQuery | undefined, GetParticipantAnswersQueryVariables>;
export function useGetParticipantAnswersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>(GetParticipantAnswersDocument, options);
        }
export type GetParticipantAnswersQueryHookResult = ReturnType<typeof useGetParticipantAnswersQuery>;
export type GetParticipantAnswersLazyQueryHookResult = ReturnType<typeof useGetParticipantAnswersLazyQuery>;
export type GetParticipantAnswersSuspenseQueryHookResult = ReturnType<typeof useGetParticipantAnswersSuspenseQuery>;
export type GetParticipantAnswersQueryResult = ApolloReactCommon.QueryResult<GetParticipantAnswersQuery, GetParticipantAnswersQueryVariables>;
export const GetParticipantFactorScoresDocument = gql`
    query GetParticipantFactorScores($sessionId: ID!, $participantId: ID!) {
  participant(sessionId: $sessionId, participantId: $participantId) {
    id
    name
    title
    factorScores {
      id
      factorCode
      factorName
      sentiment
      sentimentLabel
      summary
    }
  }
}
    `;

/**
 * __useGetParticipantFactorScoresQuery__
 *
 * To run a query within a React component, call `useGetParticipantFactorScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantFactorScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantFactorScoresQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantFactorScoresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables> & ({ variables: GetParticipantFactorScoresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>(GetParticipantFactorScoresDocument, options);
      }
export function useGetParticipantFactorScoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>(GetParticipantFactorScoresDocument, options);
        }
// @ts-ignore
export function useGetParticipantFactorScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>;
export function useGetParticipantFactorScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetParticipantFactorScoresQuery | undefined, GetParticipantFactorScoresQueryVariables>;
export function useGetParticipantFactorScoresSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>(GetParticipantFactorScoresDocument, options);
        }
export type GetParticipantFactorScoresQueryHookResult = ReturnType<typeof useGetParticipantFactorScoresQuery>;
export type GetParticipantFactorScoresLazyQueryHookResult = ReturnType<typeof useGetParticipantFactorScoresLazyQuery>;
export type GetParticipantFactorScoresSuspenseQueryHookResult = ReturnType<typeof useGetParticipantFactorScoresSuspenseQuery>;
export type GetParticipantFactorScoresQueryResult = ApolloReactCommon.QueryResult<GetParticipantFactorScoresQuery, GetParticipantFactorScoresQueryVariables>;
export const GetSessionDocument = gql`
    query GetSession($id: ID!) {
  session(id: $id) {
    id
    title
    description
    status
    expiresAt
    startedAt
    sessionTimeRemaining
    sectionTimeRemaining
    length
    section
    createdAt
    solutioningTopicsSelectedAt
    type
    velocityEngineType
    activeFactorCodes
    activeReportingFactorCodes
    focus
    defaultQuestions
    requireDefaultQuestions
    topicsToAvoid
    allowExperimentalFactorQuestions
    identificationMode
    insightsVisibility
    canViewInsights
    selectedAttributes {
      id
      name
      type
      options
    }
    currentParticipantHasJoined
    sections {
      name
      description
      section
      timeInSeconds
      timeRemaining
    }
    user {
      id
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSessionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionQuery, GetSessionQueryVariables> & ({ variables: GetSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
      }
export function useGetSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
        }
// @ts-ignore
export function useGetSessionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionQuery, GetSessionQueryVariables>;
export function useGetSessionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionQuery | undefined, GetSessionQueryVariables>;
export function useGetSessionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
        }
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionSuspenseQueryHookResult = ReturnType<typeof useGetSessionSuspenseQuery>;
export type GetSessionQueryResult = ApolloReactCommon.QueryResult<GetSessionQuery, GetSessionQueryVariables>;
export const GetSessionAttributeTemplatesDocument = gql`
    query GetSessionAttributeTemplates($filter: SessionAttributeTemplatesFilterInput, $first: Int, $after: String) {
  sessionAttributeTemplates(filter: $filter, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalCount
    }
    edges {
      cursor
      node {
        id
        name
        type
        options
        archived
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetSessionAttributeTemplatesQuery__
 *
 * To run a query within a React component, call `useGetSessionAttributeTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionAttributeTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionAttributeTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSessionAttributeTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>(GetSessionAttributeTemplatesDocument, options);
      }
export function useGetSessionAttributeTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>(GetSessionAttributeTemplatesDocument, options);
        }
// @ts-ignore
export function useGetSessionAttributeTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>;
export function useGetSessionAttributeTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionAttributeTemplatesQuery | undefined, GetSessionAttributeTemplatesQueryVariables>;
export function useGetSessionAttributeTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>(GetSessionAttributeTemplatesDocument, options);
        }
export type GetSessionAttributeTemplatesQueryHookResult = ReturnType<typeof useGetSessionAttributeTemplatesQuery>;
export type GetSessionAttributeTemplatesLazyQueryHookResult = ReturnType<typeof useGetSessionAttributeTemplatesLazyQuery>;
export type GetSessionAttributeTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetSessionAttributeTemplatesSuspenseQuery>;
export type GetSessionAttributeTemplatesQueryResult = ApolloReactCommon.QueryResult<GetSessionAttributeTemplatesQuery, GetSessionAttributeTemplatesQueryVariables>;
export const GetSessionFactorsDocument = gql`
    query GetSessionFactors($sessionId: ID!) {
  session(id: $sessionId) {
    id
    factors {
      status
      error
      factors {
        id
        factorCode
        factorName
        description
        analysis
        quotes {
          quote
          participant {
            id
            name
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionFactorsQuery__
 *
 * To run a query within a React component, call `useGetSessionFactorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionFactorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionFactorsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionFactorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionFactorsQuery, GetSessionFactorsQueryVariables> & ({ variables: GetSessionFactorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>(GetSessionFactorsDocument, options);
      }
export function useGetSessionFactorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>(GetSessionFactorsDocument, options);
        }
// @ts-ignore
export function useGetSessionFactorsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>;
export function useGetSessionFactorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionFactorsQuery | undefined, GetSessionFactorsQueryVariables>;
export function useGetSessionFactorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>(GetSessionFactorsDocument, options);
        }
export type GetSessionFactorsQueryHookResult = ReturnType<typeof useGetSessionFactorsQuery>;
export type GetSessionFactorsLazyQueryHookResult = ReturnType<typeof useGetSessionFactorsLazyQuery>;
export type GetSessionFactorsSuspenseQueryHookResult = ReturnType<typeof useGetSessionFactorsSuspenseQuery>;
export type GetSessionFactorsQueryResult = ApolloReactCommon.QueryResult<GetSessionFactorsQuery, GetSessionFactorsQueryVariables>;
export const GetSessionFeedbackDocument = gql`
    query GetSessionFeedback($sessionId: ID!) {
  session(id: $sessionId) {
    id
    title
    createdAt
    feedback {
      pageInfo {
        totalCount
      }
      edges {
        cursor
        node {
          id
          feedback
          rating
          createdAt
          participant {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionFeedbackQuery__
 *
 * To run a query within a React component, call `useGetSessionFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionFeedbackQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionFeedbackQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables> & ({ variables: GetSessionFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>(GetSessionFeedbackDocument, options);
      }
export function useGetSessionFeedbackLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>(GetSessionFeedbackDocument, options);
        }
// @ts-ignore
export function useGetSessionFeedbackSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>;
export function useGetSessionFeedbackSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionFeedbackQuery | undefined, GetSessionFeedbackQueryVariables>;
export function useGetSessionFeedbackSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>(GetSessionFeedbackDocument, options);
        }
export type GetSessionFeedbackQueryHookResult = ReturnType<typeof useGetSessionFeedbackQuery>;
export type GetSessionFeedbackLazyQueryHookResult = ReturnType<typeof useGetSessionFeedbackLazyQuery>;
export type GetSessionFeedbackSuspenseQueryHookResult = ReturnType<typeof useGetSessionFeedbackSuspenseQuery>;
export type GetSessionFeedbackQueryResult = ApolloReactCommon.QueryResult<GetSessionFeedbackQuery, GetSessionFeedbackQueryVariables>;
export const GetSessionInsightsDocument = gql`
    query GetSessionInsights($sessionId: ID!) {
  sessionInsights(sessionId: $sessionId) {
    canViewInsights
    sessionInsights {
      sessionSummary {
        id
        positiveHighlights
        areasForImprovement
      }
      issues {
        matchedAvoidTopic
        id
        name
        description
        oneLiner
        summary
        score
        selectedForSolutioning
        linkedParticipantIds
        topicAssignments {
          id
          email
          createdAt
        }
        whyQuotes {
          id
          text
          questionText
          name
          role
        }
      }
      opportunities {
        matchedAvoidTopic
        id
        name
        description
        oneLiner
        summary
        score
        selectedForSolutioning
        linkedParticipantIds
        topicAssignments {
          id
          email
          createdAt
        }
        whyQuotes {
          id
          text
          questionText
          name
          role
        }
      }
      praise {
        id
        name
        description
        oneLiner
        summary
        score
        linkedParticipantIds
        topicAssignments {
          id
          email
          createdAt
        }
        whyQuotes {
          id
          text
          questionText
          name
          role
        }
      }
      implementations {
        id
        name
        description
        summary
        score
        linkedIssueIds
        linkedOpportunityIds
      }
      participantCount
      duration
    }
  }
}
    `;

/**
 * __useGetSessionInsightsQuery__
 *
 * To run a query within a React component, call `useGetSessionInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionInsightsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionInsightsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionInsightsQuery, GetSessionInsightsQueryVariables> & ({ variables: GetSessionInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>(GetSessionInsightsDocument, options);
      }
export function useGetSessionInsightsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>(GetSessionInsightsDocument, options);
        }
// @ts-ignore
export function useGetSessionInsightsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>;
export function useGetSessionInsightsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionInsightsQuery | undefined, GetSessionInsightsQueryVariables>;
export function useGetSessionInsightsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>(GetSessionInsightsDocument, options);
        }
export type GetSessionInsightsQueryHookResult = ReturnType<typeof useGetSessionInsightsQuery>;
export type GetSessionInsightsLazyQueryHookResult = ReturnType<typeof useGetSessionInsightsLazyQuery>;
export type GetSessionInsightsSuspenseQueryHookResult = ReturnType<typeof useGetSessionInsightsSuspenseQuery>;
export type GetSessionInsightsQueryResult = ApolloReactCommon.QueryResult<GetSessionInsightsQuery, GetSessionInsightsQueryVariables>;
export const GetSessionParticipantAttributesDocument = gql`
    query GetSessionParticipantAttributes($sessionId: ID!) {
  participants(filter: {sessionId: $sessionId}) {
    id
    name
    attributeResponses {
      attributeTemplate {
        id
        name
      }
      value
    }
  }
}
    `;

/**
 * __useGetSessionParticipantAttributesQuery__
 *
 * To run a query within a React component, call `useGetSessionParticipantAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionParticipantAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionParticipantAttributesQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetSessionParticipantAttributesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables> & ({ variables: GetSessionParticipantAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>(GetSessionParticipantAttributesDocument, options);
      }
export function useGetSessionParticipantAttributesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>(GetSessionParticipantAttributesDocument, options);
        }
// @ts-ignore
export function useGetSessionParticipantAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>;
export function useGetSessionParticipantAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionParticipantAttributesQuery | undefined, GetSessionParticipantAttributesQueryVariables>;
export function useGetSessionParticipantAttributesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>(GetSessionParticipantAttributesDocument, options);
        }
export type GetSessionParticipantAttributesQueryHookResult = ReturnType<typeof useGetSessionParticipantAttributesQuery>;
export type GetSessionParticipantAttributesLazyQueryHookResult = ReturnType<typeof useGetSessionParticipantAttributesLazyQuery>;
export type GetSessionParticipantAttributesSuspenseQueryHookResult = ReturnType<typeof useGetSessionParticipantAttributesSuspenseQuery>;
export type GetSessionParticipantAttributesQueryResult = ApolloReactCommon.QueryResult<GetSessionParticipantAttributesQuery, GetSessionParticipantAttributesQueryVariables>;
export const GetSessionParticipantCountDocument = gql`
    query GetSessionParticipantCount($id: ID!) {
  session(id: $id) {
    id
    participants(first: 0) {
      pageInfo {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useGetSessionParticipantCountQuery__
 *
 * To run a query within a React component, call `useGetSessionParticipantCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionParticipantCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionParticipantCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSessionParticipantCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables> & ({ variables: GetSessionParticipantCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>(GetSessionParticipantCountDocument, options);
      }
export function useGetSessionParticipantCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>(GetSessionParticipantCountDocument, options);
        }
// @ts-ignore
export function useGetSessionParticipantCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>;
export function useGetSessionParticipantCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionParticipantCountQuery | undefined, GetSessionParticipantCountQueryVariables>;
export function useGetSessionParticipantCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>(GetSessionParticipantCountDocument, options);
        }
export type GetSessionParticipantCountQueryHookResult = ReturnType<typeof useGetSessionParticipantCountQuery>;
export type GetSessionParticipantCountLazyQueryHookResult = ReturnType<typeof useGetSessionParticipantCountLazyQuery>;
export type GetSessionParticipantCountSuspenseQueryHookResult = ReturnType<typeof useGetSessionParticipantCountSuspenseQuery>;
export type GetSessionParticipantCountQueryResult = ApolloReactCommon.QueryResult<GetSessionParticipantCountQuery, GetSessionParticipantCountQueryVariables>;
export const GetSessionParticipantsDocument = gql`
    query GetSessionParticipants($sessionId: ID!, $first: Int, $after: String, $last: Int, $before: String, $sort: [ParticipantsSortInput!], $filter: SessionParticipantsFilterInput) {
  session(id: $sessionId) {
    id
    participants(
      first: $first
      after: $after
      last: $last
      before: $before
      sort: $sort
      filter: $filter
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        totalCount
      }
      edges {
        cursor
        node {
          id
          name
          title
          email
          attributeResponses {
            attributeTemplate {
              id
              name
            }
            value
          }
          factorScores {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionParticipantsQuery__
 *
 * To run a query within a React component, call `useGetSessionParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionParticipantsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSessionParticipantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables> & ({ variables: GetSessionParticipantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>(GetSessionParticipantsDocument, options);
      }
export function useGetSessionParticipantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>(GetSessionParticipantsDocument, options);
        }
// @ts-ignore
export function useGetSessionParticipantsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>;
export function useGetSessionParticipantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionParticipantsQuery | undefined, GetSessionParticipantsQueryVariables>;
export function useGetSessionParticipantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>(GetSessionParticipantsDocument, options);
        }
export type GetSessionParticipantsQueryHookResult = ReturnType<typeof useGetSessionParticipantsQuery>;
export type GetSessionParticipantsLazyQueryHookResult = ReturnType<typeof useGetSessionParticipantsLazyQuery>;
export type GetSessionParticipantsSuspenseQueryHookResult = ReturnType<typeof useGetSessionParticipantsSuspenseQuery>;
export type GetSessionParticipantsQueryResult = ApolloReactCommon.QueryResult<GetSessionParticipantsQuery, GetSessionParticipantsQueryVariables>;
export const GetSessionReportDocument = gql`
    query GetSessionReport($sessionId: ID!, $attributeFilters: [ReportAttributeFilterInput!]) {
  session(id: $sessionId) {
    id
    report(attributeFilters: $attributeFilters) {
      id
      name
      description
      module {
        __typename
        ... on OrgHealthReportModule {
          participantCount
          questionsAnswered
          issueCount
          factorsCovered
          totalFactors
          durationSeconds
          summary
          topIssues {
            ...VelocityIssueItem
          }
        }
        ... on FactorReportModule {
          totalParticipants
          factors {
            ...FactorReportFactor
          }
        }
        ... on IssuesReportModule {
          totalParticipants
          issues {
            ...VelocityIssueItem
          }
        }
        ... on PraiseReportModule {
          praise {
            ...PraiseItem
          }
          topRecognizers {
            participantId
            participantName
            praiseGiven
          }
        }
        ... on OrgStrengthsReportModule {
          strengths {
            ...OrgStrengthsItem
          }
        }
      }
    }
  }
}
    ${VelocityIssueItemFragmentDoc}
${FactorReportFactorFragmentDoc}
${PraiseItemFragmentDoc}
${OrgStrengthsItemFragmentDoc}`;

/**
 * __useGetSessionReportQuery__
 *
 * To run a query within a React component, call `useGetSessionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionReportQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      attributeFilters: // value for 'attributeFilters'
 *   },
 * });
 */
export function useGetSessionReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSessionReportQuery, GetSessionReportQueryVariables> & ({ variables: GetSessionReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionReportQuery, GetSessionReportQueryVariables>(GetSessionReportDocument, options);
      }
export function useGetSessionReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionReportQuery, GetSessionReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionReportQuery, GetSessionReportQueryVariables>(GetSessionReportDocument, options);
        }
// @ts-ignore
export function useGetSessionReportSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionReportQuery, GetSessionReportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionReportQuery, GetSessionReportQueryVariables>;
export function useGetSessionReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionReportQuery, GetSessionReportQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionReportQuery | undefined, GetSessionReportQueryVariables>;
export function useGetSessionReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionReportQuery, GetSessionReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionReportQuery, GetSessionReportQueryVariables>(GetSessionReportDocument, options);
        }
export type GetSessionReportQueryHookResult = ReturnType<typeof useGetSessionReportQuery>;
export type GetSessionReportLazyQueryHookResult = ReturnType<typeof useGetSessionReportLazyQuery>;
export type GetSessionReportSuspenseQueryHookResult = ReturnType<typeof useGetSessionReportSuspenseQuery>;
export type GetSessionReportQueryResult = ApolloReactCommon.QueryResult<GetSessionReportQuery, GetSessionReportQueryVariables>;
export const GetSessionsDocument = gql`
    query GetSessions($first: Int, $after: String, $last: Int, $before: String, $filter: SessionsFilterInput, $sort: [SessionsSortInput!]) {
  sessions(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      totalCount
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        title
        status
        createdAt
        insightsVisibility
        user {
          id
          firstName
          lastName
        }
        participants(first: 0) {
          pageInfo {
            totalCount
          }
        }
        feedback(first: 0) {
          pageInfo {
            totalCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionsQuery__
 *
 * To run a query within a React component, call `useGetSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSessionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
      }
export function useGetSessionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
        }
// @ts-ignore
export function useGetSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionsQuery, GetSessionsQueryVariables>;
export function useGetSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSessionsQuery | undefined, GetSessionsQueryVariables>;
export function useGetSessionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSessionsQuery, GetSessionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSessionsQuery, GetSessionsQueryVariables>(GetSessionsDocument, options);
        }
export type GetSessionsQueryHookResult = ReturnType<typeof useGetSessionsQuery>;
export type GetSessionsLazyQueryHookResult = ReturnType<typeof useGetSessionsLazyQuery>;
export type GetSessionsSuspenseQueryHookResult = ReturnType<typeof useGetSessionsSuspenseQuery>;
export type GetSessionsQueryResult = ApolloReactCommon.QueryResult<GetSessionsQuery, GetSessionsQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($first: Int, $after: String, $last: Int, $before: String, $filter: UsersFilterInput, $sort: [UsersSortInput!]) {
  users(
    first: $first
    after: $after
    last: $last
    before: $before
    filter: $filter
    sort: $sort
  ) {
    pageInfo {
      totalCount
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      cursor
      node {
        id
        email
        firstName
        lastName
        source
        isPlatformAdmin
        status
        createdAt
        organizationMemberships {
          id
          role
          organization {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = ApolloReactCommon.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetVelocityFactorDocument = gql`
    query GetVelocityFactor($sessionId: ID!, $factorCode: String!) {
  velocityFactor(sessionId: $sessionId, factorCode: $factorCode) {
    ...VelocityFactorDetail
  }
}
    ${VelocityFactorDetailFragmentDoc}`;

/**
 * __useGetVelocityFactorQuery__
 *
 * To run a query within a React component, call `useGetVelocityFactorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVelocityFactorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVelocityFactorQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      factorCode: // value for 'factorCode'
 *   },
 * });
 */
export function useGetVelocityFactorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVelocityFactorQuery, GetVelocityFactorQueryVariables> & ({ variables: GetVelocityFactorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>(GetVelocityFactorDocument, options);
      }
export function useGetVelocityFactorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>(GetVelocityFactorDocument, options);
        }
// @ts-ignore
export function useGetVelocityFactorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>;
export function useGetVelocityFactorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetVelocityFactorQuery | undefined, GetVelocityFactorQueryVariables>;
export function useGetVelocityFactorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>(GetVelocityFactorDocument, options);
        }
export type GetVelocityFactorQueryHookResult = ReturnType<typeof useGetVelocityFactorQuery>;
export type GetVelocityFactorLazyQueryHookResult = ReturnType<typeof useGetVelocityFactorLazyQuery>;
export type GetVelocityFactorSuspenseQueryHookResult = ReturnType<typeof useGetVelocityFactorSuspenseQuery>;
export type GetVelocityFactorQueryResult = ApolloReactCommon.QueryResult<GetVelocityFactorQuery, GetVelocityFactorQueryVariables>;
export const GetVelocityIssueDocument = gql`
    query GetVelocityIssue($sessionId: ID!, $slug: String!) {
  velocityIssue(sessionId: $sessionId, slug: $slug) {
    ...VelocityIssueDetail
    assignments {
      id
      email
      createdAt
    }
  }
}
    ${VelocityIssueDetailFragmentDoc}`;

/**
 * __useGetVelocityIssueQuery__
 *
 * To run a query within a React component, call `useGetVelocityIssueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVelocityIssueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVelocityIssueQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetVelocityIssueQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVelocityIssueQuery, GetVelocityIssueQueryVariables> & ({ variables: GetVelocityIssueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>(GetVelocityIssueDocument, options);
      }
export function useGetVelocityIssueLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>(GetVelocityIssueDocument, options);
        }
// @ts-ignore
export function useGetVelocityIssueSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>;
export function useGetVelocityIssueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetVelocityIssueQuery | undefined, GetVelocityIssueQueryVariables>;
export function useGetVelocityIssueSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>(GetVelocityIssueDocument, options);
        }
export type GetVelocityIssueQueryHookResult = ReturnType<typeof useGetVelocityIssueQuery>;
export type GetVelocityIssueLazyQueryHookResult = ReturnType<typeof useGetVelocityIssueLazyQuery>;
export type GetVelocityIssueSuspenseQueryHookResult = ReturnType<typeof useGetVelocityIssueSuspenseQuery>;
export type GetVelocityIssueQueryResult = ApolloReactCommon.QueryResult<GetVelocityIssueQuery, GetVelocityIssueQueryVariables>;
export const GetVelocityOrgStrengthDocument = gql`
    query GetVelocityOrgStrength($sessionId: ID!, $slug: String!) {
  velocityOrgStrength(sessionId: $sessionId, slug: $slug) {
    ...VelocityOrgStrengthDetail
  }
}
    ${VelocityOrgStrengthDetailFragmentDoc}`;

/**
 * __useGetVelocityOrgStrengthQuery__
 *
 * To run a query within a React component, call `useGetVelocityOrgStrengthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVelocityOrgStrengthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVelocityOrgStrengthQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetVelocityOrgStrengthQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables> & ({ variables: GetVelocityOrgStrengthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>(GetVelocityOrgStrengthDocument, options);
      }
export function useGetVelocityOrgStrengthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>(GetVelocityOrgStrengthDocument, options);
        }
// @ts-ignore
export function useGetVelocityOrgStrengthSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>;
export function useGetVelocityOrgStrengthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetVelocityOrgStrengthQuery | undefined, GetVelocityOrgStrengthQueryVariables>;
export function useGetVelocityOrgStrengthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>(GetVelocityOrgStrengthDocument, options);
        }
export type GetVelocityOrgStrengthQueryHookResult = ReturnType<typeof useGetVelocityOrgStrengthQuery>;
export type GetVelocityOrgStrengthLazyQueryHookResult = ReturnType<typeof useGetVelocityOrgStrengthLazyQuery>;
export type GetVelocityOrgStrengthSuspenseQueryHookResult = ReturnType<typeof useGetVelocityOrgStrengthSuspenseQuery>;
export type GetVelocityOrgStrengthQueryResult = ApolloReactCommon.QueryResult<GetVelocityOrgStrengthQuery, GetVelocityOrgStrengthQueryVariables>;
export const JoinSessionDocument = gql`
    mutation JoinSession($input: JoinSessionInput!) {
  joinSession(input: $input) {
    session {
      id
      currentParticipantHasJoined
    }
    participant {
      id
      name
      title
      email
    }
  }
}
    `;
export type JoinSessionMutationFn = ApolloReactCommon.MutationFunction<JoinSessionMutation, JoinSessionMutationVariables>;

/**
 * __useJoinSessionMutation__
 *
 * To run a mutation, you first call `useJoinSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinSessionMutation, { data, loading, error }] = useJoinSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinSessionMutation, JoinSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<JoinSessionMutation, JoinSessionMutationVariables>(JoinSessionDocument, options);
      }
export type JoinSessionMutationHookResult = ReturnType<typeof useJoinSessionMutation>;
export type JoinSessionMutationResult = ApolloReactCommon.MutationResult<JoinSessionMutation>;
export type JoinSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<JoinSessionMutation, JoinSessionMutationVariables>;
export const NextQuestionDocument = gql`
    query NextQuestion($sessionId: ID!) {
  nextQuestion(sessionId: $sessionId) {
    session {
      id
      type
      status
      section
      sections {
        name
        description
        section
        timeInSeconds
        timeRemaining
      }
      user {
        id
        email
        firstName
        lastName
      }
      title
      currentParticipantHasJoined
    }
    question {
      id
      createdAt
      section
      issues {
        id
        name
        description
      }
      opportunities {
        id
        name
        description
      }
      implementations {
        id
        name
        description
      }
      content {
        __typename
        ... on MultipleChoiceQuestionContent {
          preamble
          question
          multipleChoiceOptions
        }
        ... on TextQuestionContent {
          preamble
          question
        }
        ... on BooleanQuestionContent {
          preamble
          question
        }
        ... on RankingQuestionContent {
          preamble
          question
          rankingType
          issues {
            id
            name
            description
          }
          opportunities {
            id
            name
            description
          }
          rankingOptions {
            id
            text
            description
          }
        }
        ... on RatingScaleQuestionContent {
          preamble
          question
          scaleType
          minLabel
          maxLabel
        }
      }
    }
  }
}
    `;

/**
 * __useNextQuestionQuery__
 *
 * To run a query within a React component, call `useNextQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextQuestionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useNextQuestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NextQuestionQuery, NextQuestionQueryVariables> & ({ variables: NextQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NextQuestionQuery, NextQuestionQueryVariables>(NextQuestionDocument, options);
      }
export function useNextQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NextQuestionQuery, NextQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NextQuestionQuery, NextQuestionQueryVariables>(NextQuestionDocument, options);
        }
// @ts-ignore
export function useNextQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NextQuestionQuery, NextQuestionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NextQuestionQuery, NextQuestionQueryVariables>;
export function useNextQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NextQuestionQuery, NextQuestionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NextQuestionQuery | undefined, NextQuestionQueryVariables>;
export function useNextQuestionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NextQuestionQuery, NextQuestionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NextQuestionQuery, NextQuestionQueryVariables>(NextQuestionDocument, options);
        }
export type NextQuestionQueryHookResult = ReturnType<typeof useNextQuestionQuery>;
export type NextQuestionLazyQueryHookResult = ReturnType<typeof useNextQuestionLazyQuery>;
export type NextQuestionSuspenseQueryHookResult = ReturnType<typeof useNextQuestionSuspenseQuery>;
export type NextQuestionQueryResult = ApolloReactCommon.QueryResult<NextQuestionQuery, NextQuestionQueryVariables>;
export const PauseSessionDocument = gql`
    mutation PauseSession($input: PauseSessionInput!) {
  pauseSession(input: $input) {
    session {
      id
      status
      user {
        id
      }
    }
  }
}
    `;
export type PauseSessionMutationFn = ApolloReactCommon.MutationFunction<PauseSessionMutation, PauseSessionMutationVariables>;

/**
 * __usePauseSessionMutation__
 *
 * To run a mutation, you first call `usePauseSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSessionMutation, { data, loading, error }] = usePauseSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PauseSessionMutation, PauseSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PauseSessionMutation, PauseSessionMutationVariables>(PauseSessionDocument, options);
      }
export type PauseSessionMutationHookResult = ReturnType<typeof usePauseSessionMutation>;
export type PauseSessionMutationResult = ApolloReactCommon.MutationResult<PauseSessionMutation>;
export type PauseSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<PauseSessionMutation, PauseSessionMutationVariables>;
export const ReassignSessionDocument = gql`
    mutation ReassignSession($input: ReassignSessionInput!) {
  reassignSession(input: $input) {
    session {
      id
    }
  }
}
    `;
export type ReassignSessionMutationFn = ApolloReactCommon.MutationFunction<ReassignSessionMutation, ReassignSessionMutationVariables>;

/**
 * __useReassignSessionMutation__
 *
 * To run a mutation, you first call `useReassignSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignSessionMutation, { data, loading, error }] = useReassignSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReassignSessionMutation, ReassignSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReassignSessionMutation, ReassignSessionMutationVariables>(ReassignSessionDocument, options);
      }
export type ReassignSessionMutationHookResult = ReturnType<typeof useReassignSessionMutation>;
export type ReassignSessionMutationResult = ApolloReactCommon.MutationResult<ReassignSessionMutation>;
export type ReassignSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<ReassignSessionMutation, ReassignSessionMutationVariables>;
export const RegenerateSessionSummaryDocument = gql`
    mutation RegenerateSessionSummary($sessionId: ID!) {
  regenerateSessionSummary(input: {sessionId: $sessionId}) {
    success
  }
}
    `;
export type RegenerateSessionSummaryMutationFn = ApolloReactCommon.MutationFunction<RegenerateSessionSummaryMutation, RegenerateSessionSummaryMutationVariables>;

/**
 * __useRegenerateSessionSummaryMutation__
 *
 * To run a mutation, you first call `useRegenerateSessionSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateSessionSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateSessionSummaryMutation, { data, loading, error }] = useRegenerateSessionSummaryMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useRegenerateSessionSummaryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegenerateSessionSummaryMutation, RegenerateSessionSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegenerateSessionSummaryMutation, RegenerateSessionSummaryMutationVariables>(RegenerateSessionSummaryDocument, options);
      }
export type RegenerateSessionSummaryMutationHookResult = ReturnType<typeof useRegenerateSessionSummaryMutation>;
export type RegenerateSessionSummaryMutationResult = ApolloReactCommon.MutationResult<RegenerateSessionSummaryMutation>;
export type RegenerateSessionSummaryMutationOptions = ApolloReactCommon.BaseMutationOptions<RegenerateSessionSummaryMutation, RegenerateSessionSummaryMutationVariables>;
export const RemoveTopicAssignmentDocument = gql`
    mutation RemoveTopicAssignment($input: RemoveTopicAssignmentInput!) {
  removeTopicAssignment(input: $input) {
    success
    idea {
      ... on Issue {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
      ... on Opportunity {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
      ... on Praise {
        id
        topicAssignments {
          id
          email
          createdAt
        }
      }
    }
  }
}
    `;
export type RemoveTopicAssignmentMutationFn = ApolloReactCommon.MutationFunction<RemoveTopicAssignmentMutation, RemoveTopicAssignmentMutationVariables>;

/**
 * __useRemoveTopicAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveTopicAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTopicAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTopicAssignmentMutation, { data, loading, error }] = useRemoveTopicAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTopicAssignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTopicAssignmentMutation, RemoveTopicAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTopicAssignmentMutation, RemoveTopicAssignmentMutationVariables>(RemoveTopicAssignmentDocument, options);
      }
export type RemoveTopicAssignmentMutationHookResult = ReturnType<typeof useRemoveTopicAssignmentMutation>;
export type RemoveTopicAssignmentMutationResult = ApolloReactCommon.MutationResult<RemoveTopicAssignmentMutation>;
export type RemoveTopicAssignmentMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveTopicAssignmentMutation, RemoveTopicAssignmentMutationVariables>;
export const RemoveUserFromOrganizationDocument = gql`
    mutation RemoveUserFromOrganization($input: RemoveUserFromOrganizationInput!) {
  removeUserFromOrganization(input: $input) {
    success
  }
}
    `;
export type RemoveUserFromOrganizationMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;

/**
 * __useRemoveUserFromOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromOrganizationMutation, { data, loading, error }] = useRemoveUserFromOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveUserFromOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>(RemoveUserFromOrganizationDocument, options);
      }
export type RemoveUserFromOrganizationMutationHookResult = ReturnType<typeof useRemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromOrganizationMutation>;
export type RemoveUserFromOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromOrganizationMutation, RemoveUserFromOrganizationMutationVariables>;
export const RemoveVelocityIssueAssignmentDocument = gql`
    mutation RemoveVelocityIssueAssignment($input: RemoveVelocityIssueAssignmentInput!) {
  removeVelocityIssueAssignment(input: $input) {
    success
    issue {
      id
      assignments {
        id
        email
        createdAt
      }
    }
  }
}
    `;
export type RemoveVelocityIssueAssignmentMutationFn = ApolloReactCommon.MutationFunction<RemoveVelocityIssueAssignmentMutation, RemoveVelocityIssueAssignmentMutationVariables>;

/**
 * __useRemoveVelocityIssueAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveVelocityIssueAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVelocityIssueAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVelocityIssueAssignmentMutation, { data, loading, error }] = useRemoveVelocityIssueAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveVelocityIssueAssignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveVelocityIssueAssignmentMutation, RemoveVelocityIssueAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveVelocityIssueAssignmentMutation, RemoveVelocityIssueAssignmentMutationVariables>(RemoveVelocityIssueAssignmentDocument, options);
      }
export type RemoveVelocityIssueAssignmentMutationHookResult = ReturnType<typeof useRemoveVelocityIssueAssignmentMutation>;
export type RemoveVelocityIssueAssignmentMutationResult = ApolloReactCommon.MutationResult<RemoveVelocityIssueAssignmentMutation>;
export type RemoveVelocityIssueAssignmentMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveVelocityIssueAssignmentMutation, RemoveVelocityIssueAssignmentMutationVariables>;
export const RestoreOrganizationDocument = gql`
    mutation RestoreOrganization($input: RestoreOrganizationInput!) {
  restoreOrganization(input: $input) {
    organization {
      id
      name
      status
      archivedAt
    }
  }
}
    `;
export type RestoreOrganizationMutationFn = ApolloReactCommon.MutationFunction<RestoreOrganizationMutation, RestoreOrganizationMutationVariables>;

/**
 * __useRestoreOrganizationMutation__
 *
 * To run a mutation, you first call `useRestoreOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreOrganizationMutation, { data, loading, error }] = useRestoreOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreOrganizationMutation, RestoreOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreOrganizationMutation, RestoreOrganizationMutationVariables>(RestoreOrganizationDocument, options);
      }
export type RestoreOrganizationMutationHookResult = ReturnType<typeof useRestoreOrganizationMutation>;
export type RestoreOrganizationMutationResult = ApolloReactCommon.MutationResult<RestoreOrganizationMutation>;
export type RestoreOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<RestoreOrganizationMutation, RestoreOrganizationMutationVariables>;
export const ResumeSessionDocument = gql`
    mutation ResumeSession($input: ResumeSessionInput!) {
  resumeSession(input: $input) {
    session {
      id
      status
      user {
        id
      }
    }
  }
}
    `;
export type ResumeSessionMutationFn = ApolloReactCommon.MutationFunction<ResumeSessionMutation, ResumeSessionMutationVariables>;

/**
 * __useResumeSessionMutation__
 *
 * To run a mutation, you first call `useResumeSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSessionMutation, { data, loading, error }] = useResumeSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResumeSessionMutation, ResumeSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResumeSessionMutation, ResumeSessionMutationVariables>(ResumeSessionDocument, options);
      }
export type ResumeSessionMutationHookResult = ReturnType<typeof useResumeSessionMutation>;
export type ResumeSessionMutationResult = ApolloReactCommon.MutationResult<ResumeSessionMutation>;
export type ResumeSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<ResumeSessionMutation, ResumeSessionMutationVariables>;
export const SaveVoteDocument = gql`
    mutation SaveVote($input: SaveVoteInput!) {
  saveVote(input: $input) {
    success
    opportunity {
      id
      myVote
      score
    }
    implementation {
      id
      myVote
      score
    }
    issue {
      id
      myVote
      score
    }
  }
}
    `;
export type SaveVoteMutationFn = ApolloReactCommon.MutationFunction<SaveVoteMutation, SaveVoteMutationVariables>;

/**
 * __useSaveVoteMutation__
 *
 * To run a mutation, you first call `useSaveVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveVoteMutation, { data, loading, error }] = useSaveVoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveVoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveVoteMutation, SaveVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveVoteMutation, SaveVoteMutationVariables>(SaveVoteDocument, options);
      }
export type SaveVoteMutationHookResult = ReturnType<typeof useSaveVoteMutation>;
export type SaveVoteMutationResult = ApolloReactCommon.MutationResult<SaveVoteMutation>;
export type SaveVoteMutationOptions = ApolloReactCommon.BaseMutationOptions<SaveVoteMutation, SaveVoteMutationVariables>;
export const SendInsightsEmailDocument = gql`
    mutation SendInsightsEmail($input: SendInsightsEmailInput!) {
  sendInsightsEmail(input: $input) {
    success
    emailsSent
  }
}
    `;
export type SendInsightsEmailMutationFn = ApolloReactCommon.MutationFunction<SendInsightsEmailMutation, SendInsightsEmailMutationVariables>;

/**
 * __useSendInsightsEmailMutation__
 *
 * To run a mutation, you first call `useSendInsightsEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInsightsEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInsightsEmailMutation, { data, loading, error }] = useSendInsightsEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInsightsEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInsightsEmailMutation, SendInsightsEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendInsightsEmailMutation, SendInsightsEmailMutationVariables>(SendInsightsEmailDocument, options);
      }
export type SendInsightsEmailMutationHookResult = ReturnType<typeof useSendInsightsEmailMutation>;
export type SendInsightsEmailMutationResult = ApolloReactCommon.MutationResult<SendInsightsEmailMutation>;
export type SendInsightsEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendInsightsEmailMutation, SendInsightsEmailMutationVariables>;
export const SendInvitationDocument = gql`
    mutation SendInvitation($input: SendInvitationInput!) {
  sendInvitation(input: $input) {
    invitationSent
    error
    success
  }
}
    `;
export type SendInvitationMutationFn = ApolloReactCommon.MutationFunction<SendInvitationMutation, SendInvitationMutationVariables>;

/**
 * __useSendInvitationMutation__
 *
 * To run a mutation, you first call `useSendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationMutation, { data, loading, error }] = useSendInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendInvitationMutation, SendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendInvitationMutation, SendInvitationMutationVariables>(SendInvitationDocument, options);
      }
export type SendInvitationMutationHookResult = ReturnType<typeof useSendInvitationMutation>;
export type SendInvitationMutationResult = ApolloReactCommon.MutationResult<SendInvitationMutation>;
export type SendInvitationMutationOptions = ApolloReactCommon.BaseMutationOptions<SendInvitationMutation, SendInvitationMutationVariables>;
export const SetSolutioningTopicsDocument = gql`
    mutation SetSolutioningTopics($input: SetSolutioningTopicsInput!) {
  setSolutioningTopics(input: $input) {
    issues {
      id
      selectedForSolutioning
    }
    opportunities {
      id
      selectedForSolutioning
    }
  }
}
    `;
export type SetSolutioningTopicsMutationFn = ApolloReactCommon.MutationFunction<SetSolutioningTopicsMutation, SetSolutioningTopicsMutationVariables>;

/**
 * __useSetSolutioningTopicsMutation__
 *
 * To run a mutation, you first call `useSetSolutioningTopicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSolutioningTopicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSolutioningTopicsMutation, { data, loading, error }] = useSetSolutioningTopicsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSolutioningTopicsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetSolutioningTopicsMutation, SetSolutioningTopicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetSolutioningTopicsMutation, SetSolutioningTopicsMutationVariables>(SetSolutioningTopicsDocument, options);
      }
export type SetSolutioningTopicsMutationHookResult = ReturnType<typeof useSetSolutioningTopicsMutation>;
export type SetSolutioningTopicsMutationResult = ApolloReactCommon.MutationResult<SetSolutioningTopicsMutation>;
export type SetSolutioningTopicsMutationOptions = ApolloReactCommon.BaseMutationOptions<SetSolutioningTopicsMutation, SetSolutioningTopicsMutationVariables>;
export const SkipQuestionDocument = gql`
    mutation SkipQuestion($input: SkipQuestionInput!) {
  skipQuestion(input: $input) {
    answer
    answeredAt
  }
}
    `;
export type SkipQuestionMutationFn = ApolloReactCommon.MutationFunction<SkipQuestionMutation, SkipQuestionMutationVariables>;

/**
 * __useSkipQuestionMutation__
 *
 * To run a mutation, you first call `useSkipQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipQuestionMutation, { data, loading, error }] = useSkipQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipQuestionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipQuestionMutation, SkipQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipQuestionMutation, SkipQuestionMutationVariables>(SkipQuestionDocument, options);
      }
export type SkipQuestionMutationHookResult = ReturnType<typeof useSkipQuestionMutation>;
export type SkipQuestionMutationResult = ApolloReactCommon.MutationResult<SkipQuestionMutation>;
export type SkipQuestionMutationOptions = ApolloReactCommon.BaseMutationOptions<SkipQuestionMutation, SkipQuestionMutationVariables>;
export const SkipToNextSectionDocument = gql`
    mutation SkipToNextSection($input: SkipToNextSectionInput!) {
  skipToNextSection(input: $input) {
    session {
      id
      sections {
        section
        timeRemaining
      }
    }
    newSectionIndex
  }
}
    `;
export type SkipToNextSectionMutationFn = ApolloReactCommon.MutationFunction<SkipToNextSectionMutation, SkipToNextSectionMutationVariables>;

/**
 * __useSkipToNextSectionMutation__
 *
 * To run a mutation, you first call `useSkipToNextSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipToNextSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipToNextSectionMutation, { data, loading, error }] = useSkipToNextSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipToNextSectionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SkipToNextSectionMutation, SkipToNextSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SkipToNextSectionMutation, SkipToNextSectionMutationVariables>(SkipToNextSectionDocument, options);
      }
export type SkipToNextSectionMutationHookResult = ReturnType<typeof useSkipToNextSectionMutation>;
export type SkipToNextSectionMutationResult = ApolloReactCommon.MutationResult<SkipToNextSectionMutation>;
export type SkipToNextSectionMutationOptions = ApolloReactCommon.BaseMutationOptions<SkipToNextSectionMutation, SkipToNextSectionMutationVariables>;
export const StartSessionDocument = gql`
    mutation StartSession($input: StartSessionInput!) {
  startSession(input: $input) {
    expiresAt
  }
}
    `;
export type StartSessionMutationFn = ApolloReactCommon.MutationFunction<StartSessionMutation, StartSessionMutationVariables>;

/**
 * __useStartSessionMutation__
 *
 * To run a mutation, you first call `useStartSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSessionMutation, { data, loading, error }] = useStartSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartSessionMutation, StartSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartSessionMutation, StartSessionMutationVariables>(StartSessionDocument, options);
      }
export type StartSessionMutationHookResult = ReturnType<typeof useStartSessionMutation>;
export type StartSessionMutationResult = ApolloReactCommon.MutationResult<StartSessionMutation>;
export type StartSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<StartSessionMutation, StartSessionMutationVariables>;
export const StartSolutionForIdeaDocument = gql`
    mutation StartSolutionForIdea($input: StartSolutionForIdeaInput!) {
  startSolutionForIdea(input: $input) {
    solutionSessionId
    nextQuestion {
      id
      content {
        ... on TextQuestionContent {
          question
        }
      }
    }
  }
}
    `;
export type StartSolutionForIdeaMutationFn = ApolloReactCommon.MutationFunction<StartSolutionForIdeaMutation, StartSolutionForIdeaMutationVariables>;

/**
 * __useStartSolutionForIdeaMutation__
 *
 * To run a mutation, you first call `useStartSolutionForIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSolutionForIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSolutionForIdeaMutation, { data, loading, error }] = useStartSolutionForIdeaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartSolutionForIdeaMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartSolutionForIdeaMutation, StartSolutionForIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartSolutionForIdeaMutation, StartSolutionForIdeaMutationVariables>(StartSolutionForIdeaDocument, options);
      }
export type StartSolutionForIdeaMutationHookResult = ReturnType<typeof useStartSolutionForIdeaMutation>;
export type StartSolutionForIdeaMutationResult = ApolloReactCommon.MutationResult<StartSolutionForIdeaMutation>;
export type StartSolutionForIdeaMutationOptions = ApolloReactCommon.BaseMutationOptions<StartSolutionForIdeaMutation, StartSolutionForIdeaMutationVariables>;
export const ToggleCurrentUserPlatformAdminDocument = gql`
    mutation ToggleCurrentUserPlatformAdmin {
  toggleCurrentUserPlatformAdmin {
    user {
      id
      email
      firstName
      lastName
      isPlatformAdmin
      source
    }
  }
}
    `;
export type ToggleCurrentUserPlatformAdminMutationFn = ApolloReactCommon.MutationFunction<ToggleCurrentUserPlatformAdminMutation, ToggleCurrentUserPlatformAdminMutationVariables>;

/**
 * __useToggleCurrentUserPlatformAdminMutation__
 *
 * To run a mutation, you first call `useToggleCurrentUserPlatformAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCurrentUserPlatformAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCurrentUserPlatformAdminMutation, { data, loading, error }] = useToggleCurrentUserPlatformAdminMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleCurrentUserPlatformAdminMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleCurrentUserPlatformAdminMutation, ToggleCurrentUserPlatformAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleCurrentUserPlatformAdminMutation, ToggleCurrentUserPlatformAdminMutationVariables>(ToggleCurrentUserPlatformAdminDocument, options);
      }
export type ToggleCurrentUserPlatformAdminMutationHookResult = ReturnType<typeof useToggleCurrentUserPlatformAdminMutation>;
export type ToggleCurrentUserPlatformAdminMutationResult = ApolloReactCommon.MutationResult<ToggleCurrentUserPlatformAdminMutation>;
export type ToggleCurrentUserPlatformAdminMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleCurrentUserPlatformAdminMutation, ToggleCurrentUserPlatformAdminMutationVariables>;
export const UpdateCurrentUserLocaleDocument = gql`
    mutation UpdateCurrentUserLocale($input: UpdateCurrentUserLocaleInput!) {
  updateCurrentUserLocale(input: $input) {
    user {
      id
      locale
    }
  }
}
    `;
export type UpdateCurrentUserLocaleMutationFn = ApolloReactCommon.MutationFunction<UpdateCurrentUserLocaleMutation, UpdateCurrentUserLocaleMutationVariables>;

/**
 * __useUpdateCurrentUserLocaleMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserLocaleMutation, { data, loading, error }] = useUpdateCurrentUserLocaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCurrentUserLocaleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCurrentUserLocaleMutation, UpdateCurrentUserLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCurrentUserLocaleMutation, UpdateCurrentUserLocaleMutationVariables>(UpdateCurrentUserLocaleDocument, options);
      }
export type UpdateCurrentUserLocaleMutationHookResult = ReturnType<typeof useUpdateCurrentUserLocaleMutation>;
export type UpdateCurrentUserLocaleMutationResult = ApolloReactCommon.MutationResult<UpdateCurrentUserLocaleMutation>;
export type UpdateCurrentUserLocaleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCurrentUserLocaleMutation, UpdateCurrentUserLocaleMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    organization {
      id
      name
    }
  }
}
    `;
export type UpdateOrganizationMutationFn = ApolloReactCommon.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = ApolloReactCommon.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateSessionDocument = gql`
    mutation UpdateSession($input: UpdateSessionInput!) {
  updateSession(input: $input) {
    session {
      id
      title
      type
      description
      status
      createdAt
      focus
      defaultQuestions
      requireDefaultQuestions
      allowExperimentalFactorQuestions
      identificationMode
      insightsVisibility
      velocityEngineType
      activeFactorCodes
      activeReportingFactorCodes
      selectedAttributes {
        id
        name
        type
        options
      }
    }
  }
}
    `;
export type UpdateSessionMutationFn = ApolloReactCommon.MutationFunction<UpdateSessionMutation, UpdateSessionMutationVariables>;

/**
 * __useUpdateSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionMutation, { data, loading, error }] = useUpdateSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSessionMutation, UpdateSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSessionMutation, UpdateSessionMutationVariables>(UpdateSessionDocument, options);
      }
export type UpdateSessionMutationHookResult = ReturnType<typeof useUpdateSessionMutation>;
export type UpdateSessionMutationResult = ApolloReactCommon.MutationResult<UpdateSessionMutation>;
export type UpdateSessionMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSessionMutation, UpdateSessionMutationVariables>;
export const UpdateSessionAttributeTemplateDocument = gql`
    mutation UpdateSessionAttributeTemplate($input: UpdateSessionAttributeTemplateInput!) {
  updateSessionAttributeTemplate(input: $input) {
    sessionAttributeTemplate {
      id
      name
      type
      options
      archived
      createdAt
    }
  }
}
    `;
export type UpdateSessionAttributeTemplateMutationFn = ApolloReactCommon.MutationFunction<UpdateSessionAttributeTemplateMutation, UpdateSessionAttributeTemplateMutationVariables>;

/**
 * __useUpdateSessionAttributeTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSessionAttributeTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionAttributeTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionAttributeTemplateMutation, { data, loading, error }] = useUpdateSessionAttributeTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSessionAttributeTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSessionAttributeTemplateMutation, UpdateSessionAttributeTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSessionAttributeTemplateMutation, UpdateSessionAttributeTemplateMutationVariables>(UpdateSessionAttributeTemplateDocument, options);
      }
export type UpdateSessionAttributeTemplateMutationHookResult = ReturnType<typeof useUpdateSessionAttributeTemplateMutation>;
export type UpdateSessionAttributeTemplateMutationResult = ApolloReactCommon.MutationResult<UpdateSessionAttributeTemplateMutation>;
export type UpdateSessionAttributeTemplateMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSessionAttributeTemplateMutation, UpdateSessionAttributeTemplateMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    user {
      id
      email
      firstName
      lastName
    }
  }
}
    `;
export type UpdateUserMutationFn = ApolloReactCommon.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = ApolloReactCommon.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const SendFeedbackDocument = gql`
    mutation SendFeedback($input: CreateFeedbackInput!) {
  createFeedback(input: $input) {
    feedback {
      id
      feedback
      rating
      participant {
        id
        name
      }
    }
  }
}
    `;
export type SendFeedbackMutationFn = ApolloReactCommon.MutationFunction<SendFeedbackMutation, SendFeedbackMutationVariables>;

/**
 * __useSendFeedbackMutation__
 *
 * To run a mutation, you first call `useSendFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFeedbackMutation, { data, loading, error }] = useSendFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendFeedbackMutation, SendFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendFeedbackMutation, SendFeedbackMutationVariables>(SendFeedbackDocument, options);
      }
export type SendFeedbackMutationHookResult = ReturnType<typeof useSendFeedbackMutation>;
export type SendFeedbackMutationResult = ApolloReactCommon.MutationResult<SendFeedbackMutation>;
export type SendFeedbackMutationOptions = ApolloReactCommon.BaseMutationOptions<SendFeedbackMutation, SendFeedbackMutationVariables>;